
/* CARDWORLD Rip Studio: Rip Lab "wizard" (9 okt), nieuwe variant NAAST de huidige Rip Lab (start-scene.js) en de i2c-variant.
   window.CWStartWiz = { html(ctx), mount(root, ctx), replay(root), unmount(root) }: hetzelfde contract als window.CWStart.
   Ontwerp: riplab-wizard/redesign.html (stap voor stap: 1 franchise en budget, 2 wat wil je, 3 jouw selectie met een compacte
   bedieningsstrook en grote 3D-producten, 4 in je mandje). In de pagina: geen eigen header, begroeting of tabs (die tekent de
   pagina of de Clean-laag); het kader van de Clean-laag wordt gevuld zoals rip-lab-i2c dat doet (fitFrame).
   Data: ctx.products (alle producten op voorraad, geen accessoires), beelden via ctx.img, 3D via ctx.mount3D (de gedeelde
   H3D-pool van app.js; de strook draagt data-cws-stack, dus enkel wat in beeld is krijgt een model, de rest toont de foto).
   Samenstellen: zoals het ontwerp (anker, aanvullen, aantallen schalen mee; Eén topstuk = strikt het duurste product binnen
   het budget plus hoogstens een klein extra), met een geheugen per instelling zodat Andere selectie nooit hetzelfde toont.
   "Alles in mijn mandje": cadeaudoos met platte kopieen, daarna vliegt de doos naar het echte mandje van de pagina en gaat
   alles via ctx.on.addMany (met from) in dat mandje; dan de bevestiging (Bekijk mijn mandje, Ongedaan maken, Stel een nieuwe samen).
   GSAP: de pagina laadt gsap 3.12.5 asynchroon; als window.gsap er is animeren we ermee, anders (of bij reduced motion) staat
   alles meteen in de eindstand die ook in de HTML staat. Enkel transform en opacity, geen vervaging.
   Schakelaar onderaan: ?riplab=nieuw zet deze variant aan voor de rest van de tab (sessionStorage), ?riplab=oud of ?riplab=i2c
   zet hem weer uit. */
(function () {
  'use strict';

  /* ---------------- teksten (NL is de bron; FR en EN inhoudelijk gelijk) ---------------- */
  var STR = {
    nl: {
      greet: { morning: 'Goedemorgen', afternoon: 'Goedemiddag', evening: 'Goedenavond' },
      appAria: 'Rip Lab', stepsAria: 'Stappen van de Rip Lab', back: 'Terug',
      steps: ['Franchise en budget', 'Samenstelling', 'Soort', 'Jouw selectie'],
      s1h: ['Kies je ', 'franchise'],
      s1leadD: 'Wij stellen een selectie sealed samen die binnen je budget past. Handig als je niet kan kiezen, een cadeau zoekt of snel wil rippen tijdens de stream.',
      s1leadM: 'Wij stellen sealed samen binnen je budget.',
      frAria: 'Franchise', fr: { all: 'Alles', pk: 'Pokémon', op: 'One Piece', tcg: 'Andere TCG' },
      frMeta: { all: 'Alle sealed op voorraad', pk: 'Pokémon TCG', op: 'One Piece Card Game', tcg: 'Lorcana en meer' },
      frMetaN: function (n, min) { return n + ' sealed, vanaf ' + min; },
      budget: 'Jouw budget', numAria: 'Budget in euro, tot 5.000', rangeAria: 'Budget schuif', chipsAria: 'Snelkeuze budget', rtop: '5.000', tgPacks: 'Packs', tgBoxes: 'Boxen', tgColl: 'Collecties', done: 'Klaar',
      bhint: 'Sleep, tik een snelkeuze of typ zelf een bedrag, tot € 5.000.',
      s1hint: 'Stap 1 van 4. Daarna kies je <b>hoe je het samenstelt</b>.', toS2: 'Verder: samenstelling',
      s2hSty: ['Hoe wil je het ', 'samenstellen?'], styTt: ['Hoe stel je het ', 'samen?'], s2hTyp: ['Welke ', 'soorten?'], next: 'Volgende',
      s2h: ['Wat wil je ', 'openen?'],
      s2lead: 'Duid een of meer soorten aan en kies hoe je mandje eruit mag zien. Geen voorkeur? Wij kiezen een mooie mix binnen je budget.',
      outStock: 'Nu niet op voorraad', tLang: 'Taal', allLangs: 'Alle talen',
      typeLbl: 'Soort', typesHelp: 'Kies er meerdere', typesNone: 'Niets aangeduid: alle soorten', typesMin: 'Kies minstens één soort', newTag: 'Nieuw', olderNote: 'Aangevuld met iets oudere sets, zodat je budget gevuld raakt.', selAll: 'Alles selecteren', selNone: 'Alles deselecteren', typesN: function (n) { return n + ' aangeduid'; }, typesAria: 'Soort product',
      types: { packs: 'Packs', blisters: 'Blisters', bundels: 'Bundels', etb: 'ETB', boxen: 'Booster boxen', collecties: 'Collecties en tins' },
      choices: function (n) { return n === 1 ? '1 keuze' : n + ' keuzes'; }, from: 'vanaf',
      emptyTypes: function (b) { return 'Binnen ' + b + ' is er nog niets in deze franchise. Verhoog je budget in stap 1.'; },
      overB: 'Boven je budget', catFrom: function (c, m) { return c + ' vanaf ' + m; }, setTo: function (b) { return 'Zet budget op ' + b; }, noteTypeUp: function (c, m) { return 'Wat je aanduidde begint bij ' + m + ' (' + c + '). Intussen stellen we een mix samen die wel past.'; },
      styleLbl: 'Samenstelling', styleAria: 'Samenstelling',
      styles: { packs: ['Meer packs om te rippen', 'Zoveel mogelijk packs om te openen'], mix: ['Een mix', 'Een mooi stuk plus wat packs'], big: ['Eén topstuk', 'Eén groot product dat je budget vult'],
        sets: ['Veel verschillende sets', 'Van elke set een beetje'], nieuw: ['Nieuwste sets', 'Wat net uit is'], cadeau: ['Om cadeau te geven', 'Mooi om in te pakken'],
        spelen: ['Om mee te spelen', 'Klaar om te beginnen'], populair: ['Populairst', 'Wat anderen het meest kiezen'] },
      styleMiss: function (s) { return 'Voor ' + s + ' past er nu niets binnen je budget, dus stelden we een mix samen.'; },
      escape: ['Maakt niet uit, kies jij maar', 'Wij kiezen een mooie mix binnen je budget.'], compose: 'Stel mijn selectie samen',
      pillFr: 'Franchise wijzigen: ', pillBud: 'Budget wijzigen: ',
      s3h: ['Jouw ', 'selectie'], mlineNone: 'Nog niets gekozen',
      mline: function (n, u, fr) { return n + ', ' + u + ', in ' + fr; },
      noteFallback: function (b) { return 'Van wat je aanduidde past niets binnen ' + b + ', dus kozen we een mix die wel past.'; },
      noteUnder: function (left) { return 'Er blijft ' + left + ' over: met deze keuzes past er niets meer bij.'; },
      tuneAria: 'Pas je selectie aan', tuneDone: 'Klaar', tBud: 'Budget', tFr: 'Franchise', tSty: 'Stijl', tTyp: 'Soort: ', tAll: 'alle',
      tN: function (n) { return n + ' soorten'; }, allTypes: 'Alle soorten',
      tyOnly: function (l) { return 'Je toont enkel ' + l + '.'; }, tyShowAll: 'Toon alle soorten', and: ' en ',
      sty: { packs: 'Meer packs', mix: 'Een mix', big: 'Eén topstuk', sets: 'Veel sets', nieuw: 'Nieuwste sets', cadeau: 'Cadeau', spelen: 'Om te spelen', populair: 'Populairst' },
      gPrev: 'Vorige producten', gNext: 'Volgende producten', countOf: function (i, n) { return i + ' van ' + n; }, stepOf: function (i, n) { return 'Stap ' + i + ' van ' + n; }, bodyAria: 'Producten in je selectie',
      tkTeaser: 'Bekijk de topkaarten uit je selectie', tkUpTo: function (p) { return 'tot ' + p; },
      tkNone: 'Voor deze set hebben we nog geen topkaarten in PriceDex.', tkNoSetH: 'Set niet vast', tkNoSet: 'Bij dit product is de set niet vast, daarom tonen we geen topkaarten.',
      tkTitle: 'Topkaarten uit je sets', tkSub: 'De waardevolste kaarten uit de sets in je selectie, met hun prijs volgens PriceDex.', tkLive: function (d) { return 'Prijzen volgens PriceDex, bijgewerkt ' + d; }, tkTopL: 'Duurste kaart', popFr: 'Kies je franchise', popBud: 'Pas je budget aan', popClose: 'Klaar', tkSrc: function (d) { return 'Bron: PriceDex, prijzen van ' + d; }, tkOpen: function (n, p) { return n + ', ' + p + ', bekijk in PriceDex'; }, tkCards: function (n) { return n === 1 ? '1 kaart' : n + ' kaarten'; }, tkCta: 'Bekijk de topkaarten uit je sets', tkNoFix: function (l) { return 'Voor ' + l + ' is de set niet vast, daarvoor tonen we geen topkaarten.'; }, tkNoData: function (l) { return 'Voor ' + l + ' hebben we nog geen topkaarten.'; }, tkAnd: ' en ', tkTop: function (p) { return 'Duurste kaart: ' + p; },
      hover3d: 'Beweeg erover om in 3D te bekijken', dh: 'Sleep om te draaien', qtyAria: function (t) { return 'Aantal ' + t; }, minus: 'Eentje minder', plus: 'Eentje meer',
      swap: 'Wissel voor een ander product', swapT: 'Wisselen', remove: 'Verwijder uit je selectie', removeT: 'Verwijderen', openAria: function (t) { return 'Open ' + t; },
      eTightH: 'Nog net te krap', eTightP: function (fr, min, need) { return 'In ' + fr + ' begint het bij ' + min + '. Met ' + need + ' kunnen we al iets samenstellen.'; },
      eTightB: function (need) { return 'Zet je budget op ' + need; },
      eEmptyH: 'Je selectie is leeg', eEmptyP: 'Je haalde alles weg. Stel opnieuw samen met dezelfde keuzes, of pas je franchise en budget aan.', eEmptyB: 'Stel opnieuw samen',
      ofB: function (b) { return 'van ' + b; }, leftL: function (l) { return 'nog ' + l; }, exactL: 'precies je budget',
      ofLine: function (b, l) { return 'van ' + b + (l ? ', nog ' + l : ''); }, ofExact: function (b) { return 'van ' + b + ', precies je budget'; }, ofOver: function (b, o) { return 'van ' + b + ', ' + o + ' boven je budget'; }, addOverBy: function (o) { return o + ' boven je budget'; },
      addSub: 'Kies wat je erbij wil in je selectie.', addBud: function (b) { return 'Budget ' + b; }, addToSel: 'Toevoegen aan selectie', addDone: 'Toegevoegd', inSel: function (n) { return n + 'x in je selectie'; }, sortLbl: 'Sorteer', sortRec: 'Aanbevolen', sortAsc: 'Prijs oplopend', sortDesc: 'Prijs aflopend', addFrAria: 'Franchise',
      addBtn: 'Voeg iets toe', addSearch: 'Zoek een product', addMore: 'Toon ook duurder', addOver: 'Boven je budget', addNone: 'Niets gevonden binnen je keuzes.',
      addOne: 'Toevoegen', addAdded: function (t) { return t + ' toegevoegd.'; }, addClose: 'Sluiten', addLeft: function (l) { return 'Nog ' + l + ' over in je budget'; }, addAll: 'Alles',
      reroll: 'Andere selectie', toCart: 'Alles in mijn mandje',
      noOther: 'Voor dit budget in deze franchise is er geen andere mix. Verhoog je budget of kies een andere franchise.',
      plusNo: function (t, b) { return 'Nog een ' + t + ' past niet meer binnen je budget van ' + b + '.'; },
      swapNo: 'Er past geen ander product op deze plek binnen je budget.',
      s4h: ['In je ', 'mandje'],
      dline: function (u, t) { return '<b>' + u + '</b> in een cadeaudoos, samen <b>' + t + '</b>. Je kan alles nog aanpassen in je mandje.'; },
      dlineUndone: 'Ongedaan gemaakt: je selectie staat niet meer in je mandje.',
      seeCart: 'Bekijk mijn mandje', undo: 'Ongedaan maken', again: 'Stel een nieuwe samen', tag: 'Rip Lab', skip: 'Sla over',
      units: function (u) { return u === 1 ? '1 stuk' : u + ' stuks'; }, products: function (n) { return n === 1 ? '1 product' : n + ' producten'; },
      live: {
        world: function (f) { return f + ' gekozen'; },
        step: ['Stap 1 van 4: franchise en budget', 'Stap 2 van 4: samenstelling', 'Stap 4 van 4: jouw selectie', 'In je mandje'], typ: 'Stap 3 van 4: soort',
        qty: function (t, u, tot) { return t + ': ' + u + '. Totaal ' + tot + '.'; },
        swapped: function (t, p) { return 'Gewisseld voor ' + t + ', ' + p + '.'; }, removed: function (t) { return t + ' verwijderd.'; },
        newSel: function (n, t) { return 'Nieuwe selectie: ' + n + ', ' + t + '.'; }, upd: function (n, t) { return 'Bijgewerkt: ' + n + ', ' + t + '.'; },
        tooTight: 'Je budget is te krap voor deze keuze.', none: 'Geen selectie met deze keuzes.',
        gift: function (u) { return u + ' gaan in een cadeaudoos naar je mandje.'; }, inCart: function (u, t) { return u + ' in je mandje, samen ' + t + '.'; }
      }
    },
    fr: {
      greet: { morning: 'Bonjour', afternoon: 'Bon après-midi', evening: 'Bonsoir' },
      appAria: 'Rip Lab', stepsAria: 'Étapes du Rip Lab', back: 'Retour',
      steps: ['Franchise et budget', 'Composition', 'Types', 'Ta sélection'],
      s1h: ['Choisis ta ', 'franchise'],
      s1leadD: 'Nous composons une sélection de sealed qui entre dans ton budget. Pratique si tu hésites, si tu cherches un cadeau ou si tu veux ripper vite pendant le stream.',
      s1leadM: 'Nous composons du sealed dans ton budget.',
      frAria: 'Franchise', fr: { all: 'Tout', pk: 'Pokémon', op: 'One Piece', tcg: 'Autres TCG' },
      frMeta: { all: 'Tout le sealed en stock', pk: 'Pokémon TCG', op: 'One Piece Card Game', tcg: 'Lorcana et plus' },
      frMetaN: function (n, min) { return n + ' sealed, dès ' + min; },
      budget: 'Ton budget', numAria: 'Budget en euros, jusqu\u2019à 5\u202f000', rangeAria: 'Curseur du budget', chipsAria: 'Budget rapide', rtop: '5 000', tgPacks: 'Boosters', tgBoxes: 'Boîtes', tgColl: 'Collections', done: 'OK',
      bhint: 'Glisse, touche un montant rapide ou tape ton propre montant, jusqu\u2019à 5\u202f000 €.',
      s1hint: 'Étape 1 sur 4. Ensuite tu choisis <b>comment le composer</b>.', toS2: 'Suite : composition',
      s2hSty: ['Comment veux-tu le ', 'composer ?'], styTt: ['Comment le ', 'composer ?'], s2hTyp: ['Quels ', 'types ?'], next: 'Suivant',
      s2h: ['Que veux-tu ', 'ouvrir ?'],
      s2lead: 'Coche un ou plusieurs types et choisis la forme de ton panier. Pas de préférence ? Nous choisissons un beau mix dans ton budget.',
      outStock: 'Pas en stock pour le moment', tLang: 'Langue', allLangs: 'Toutes les langues',
      typeLbl: 'Type', typesHelp: 'Choisis-en plusieurs', typesNone: 'Rien de coché : tous les types', typesMin: 'Choisis au moins un type', newTag: 'Nouveau', olderNote: 'Complété avec des séries un peu plus anciennes pour remplir ton budget.', selAll: 'Tout sélectionner', selNone: 'Tout désélectionner', typesN: function (n) { return n + ' coché' + (n > 1 ? 's' : ''); }, typesAria: 'Type de produit',
      types: { packs: 'Boosters', blisters: 'Blisters', bundels: 'Bundles', etb: 'ETB', boxen: 'Booster boxes', collecties: 'Coffrets et tins' },
      choices: function (n) { return n === 1 ? '1 choix' : n + ' choix'; }, from: 'dès',
      emptyTypes: function (b) { return 'Avec ' + b + ', il n’y a encore rien dans cette franchise. Augmente ton budget à l’étape 1.'; },
      overB: 'Au-dessus de ton budget', catFrom: function (c, m) { return c + ' dès ' + m; }, setTo: function (b) { return 'Mettre le budget à ' + b; }, noteTypeUp: function (c, m) { return 'Ce que tu as coché commence à ' + m + ' (' + c + '). En attendant, nous composons un mix qui entre dans ton budget.'; },
      styleLbl: 'Composition', styleAria: 'Composition',
      styles: { packs: ['Plus de boosters à ouvrir', 'Un maximum de boosters à ouvrir'], mix: ['Un mix', 'Une belle pièce plus quelques boosters'], big: ['Une pièce phare', 'Un grand produit qui remplit ton budget'],
        sets: ['Plein de séries différentes', 'Un peu de chaque série'], nieuw: ['Les séries les plus récentes', 'Ce qui vient de sortir'], cadeau: ['Pour offrir', 'Joli à emballer'],
        spelen: ['Pour jouer', 'Prêt à commencer'], populair: ['Les plus populaires', 'Ce que les autres choisissent le plus'] },
      styleMiss: function (s) { return 'Pour ' + s + ', rien n’entre dans ton budget pour l’instant, nous avons donc composé un mix.'; },
      escape: ['Peu importe, choisis pour moi', 'Nous choisissons un beau mix dans ton budget.'], compose: 'Compose ma sélection',
      pillFr: 'Changer de franchise : ', pillBud: 'Changer le budget : ',
      s3h: ['Ta ', 'sélection'], mlineNone: 'Rien de choisi pour le moment',
      mline: function (n, u, fr) { return n + ', ' + u + ', dans ' + fr; },
      noteFallback: function (b) { return 'Rien de ce que tu as coché n’entre dans ' + b + ', nous avons donc choisi un mix qui passe.'; },
      noteUnder: function (left) { return 'Il reste ' + left + ' : avec ces choix, plus rien n’entre.'; },
      tuneAria: 'Ajuste ta sélection', tuneDone: 'Terminé', tBud: 'Budget', tFr: 'Franchise', tSty: 'Style', tTyp: 'Type : ', tAll: 'tous',
      tN: function (n) { return n + ' types'; }, allTypes: 'Tous les types',
      tyOnly: function (l) { return 'Tu n’affiches que ' + l + '.'; }, tyShowAll: 'Afficher tous les types', and: ' et ',
      sty: { packs: 'Plus de boosters', mix: 'Un mix', big: 'Une pièce phare', sets: 'Plusieurs séries', nieuw: 'Nouveautés', cadeau: 'Cadeau', spelen: 'Pour jouer', populair: 'Populaires' },
      gPrev: 'Produits précédents', gNext: 'Produits suivants', countOf: function (i, n) { return i + ' sur ' + n; }, stepOf: function (i, n) { return '\u00c9tape ' + i + ' sur ' + n; }, bodyAria: 'Produits de ta sélection',
      tkTeaser: 'Voir les cartes phares de ta sélection', tkUpTo: function (p) { return 'jusqu\u2019à ' + p; },
      tkNone: 'Pour ce set, nous n\u2019avons pas encore de cartes phares dans PriceDex.', tkNoSetH: 'Set non fixe', tkNoSet: 'Pour ce produit, le set n\u2019est pas fixe, nous n\u2019affichons donc pas de cartes phares.',
      tkTitle: 'Cartes phares de tes sets', tkSub: 'Les cartes les plus prisées des sets de ta sélection, avec leur prix selon PriceDex.', tkLive: function (d) { return 'Prix selon PriceDex, mis à jour ' + d; }, tkTopL: 'Carte la plus chère', popFr: 'Choisis ta franchise', popBud: 'Ajuste ton budget', popClose: 'OK', tkSrc: function (d) { return 'Source\u202f: PriceDex, prix du ' + d; }, tkOpen: function (n, p) { return n + ', ' + p + ', voir dans PriceDex'; }, tkCards: function (n) { return n === 1 ? '1 carte' : n + ' cartes'; }, tkCta: 'Voir les cartes phares de tes sets', tkNoFix: function (l) { return 'Pour ' + l + ', le set n\u2019est pas fixe, nous n\u2019affichons donc pas de cartes phares.'; }, tkNoData: function (l) { return 'Pour ' + l + ', nous n\u2019avons pas encore de cartes phares.'; }, tkAnd: ' et ', tkTop: function (p) { return 'Carte la plus chère\u202f: ' + p; },
      hover3d: 'Survole pour voir en 3D', dh: 'Glisse pour tourner', qtyAria: function (t) { return 'Quantité ' + t; }, minus: 'Un de moins', plus: 'Un de plus',
      swap: 'Échanger contre un autre produit', swapT: 'Échanger', remove: 'Retirer de ta sélection', removeT: 'Retirer', openAria: function (t) { return 'Ouvrir ' + t; },
      eTightH: 'Encore un peu juste', eTightP: function (fr, min, need) { return 'Dans ' + fr + ', ça commence à ' + min + '. Avec ' + need + ', nous pouvons déjà composer quelque chose.'; },
      eTightB: function (need) { return 'Mettre ton budget à ' + need; },
      eEmptyH: 'Ta sélection est vide', eEmptyP: 'Tu as tout retiré. Recompose avec les mêmes choix, ou change de franchise et de budget.', eEmptyB: 'Recomposer',
      ofB: function (b) { return 'sur ' + b; }, leftL: function (l) { return 'encore ' + l; }, exactL: 'exactement ton budget',
      ofLine: function (b, l) { return 'sur ' + b + (l ? ', encore ' + l : ''); }, ofExact: function (b) { return 'sur ' + b + ', exactement ton budget'; }, ofOver: function (b, o) { return 'sur ' + b + ', ' + o + ' au-dessus de ton budget'; }, addOverBy: function (o) { return o + ' au-dessus de ton budget'; },
      addSub: 'Choisis ce que tu veux ajouter à ta sélection.', addBud: function (b) { return 'Budget ' + b; }, addToSel: 'Ajouter à la sélection', addDone: 'Ajouté', inSel: function (n) { return n + 'x dans ta sélection'; }, sortLbl: 'Trier', sortRec: 'Recommandé', sortAsc: 'Prix croissant', sortDesc: 'Prix décroissant', addFrAria: 'Franchise',
      addBtn: 'Ajouter quelque chose', addSearch: 'Cherche un produit', addMore: 'Afficher aussi plus cher', addOver: 'Au-dessus de ton budget', addNone: 'Rien trouvé dans tes choix.',
      addOne: 'Ajouter', addAdded: function (t) { return t + ' ajouté.'; }, addClose: 'Fermer', addLeft: function (l) { return 'Encore ' + l + ' dans ton budget'; }, addAll: 'Tout',
      reroll: 'Autre sélection', toCart: 'Tout dans mon panier',
      noOther: 'Pour ce budget dans cette franchise, il n’y a pas d’autre mix. Augmente ton budget ou choisis une autre franchise.',
      plusNo: function (t, b) { return 'Un ' + t + ' de plus n’entre plus dans ton budget de ' + b + '.'; },
      swapNo: 'Aucun autre produit n’entre à cette place dans ton budget.',
      s4h: ['Dans ton ', 'panier'],
      dline: function (u, t) { return '<b>' + u + '</b> dans une boîte cadeau, ' + '<b>' + t + '</b> au total. Tu peux encore tout modifier dans ton panier.'; },
      dlineUndone: 'Annulé : ta sélection n’est plus dans ton panier.',
      seeCart: 'Voir mon panier', undo: 'Annuler', again: 'Composer une nouvelle sélection', tag: 'Rip Lab', skip: 'Passer',
      units: function (u) { return u === 1 ? '1 article' : u + ' articles'; }, products: function (n) { return n === 1 ? '1 produit' : n + ' produits'; },
      live: {
        world: function (f) { return f + ' choisi'; },
        step: ['Étape 1 sur 4 : franchise et budget', 'Étape 2 sur 4 : composition', 'Étape 4 sur 4 : ta sélection', 'Dans ton panier'], typ: 'Étape 3 sur 4 : types',
        qty: function (t, u, tot) { return t + ' : ' + u + '. Total ' + tot + '.'; },
        swapped: function (t, p) { return 'Échangé contre ' + t + ', ' + p + '.'; }, removed: function (t) { return t + ' retiré.'; },
        newSel: function (n, t) { return 'Nouvelle sélection : ' + n + ', ' + t + '.'; }, upd: function (n, t) { return 'Mis à jour : ' + n + ', ' + t + '.'; },
        tooTight: 'Ton budget est trop juste pour ce choix.', none: 'Pas de sélection avec ces choix.',
        gift: function (u) { return u + ' partent dans une boîte cadeau vers ton panier.'; }, inCart: function (u, t) { return u + ' dans ton panier, ' + t + ' au total.'; }
      }
    },
    en: {
      greet: { morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening' },
      appAria: 'Rip Lab', stepsAria: 'Rip Lab steps', back: 'Back',
      steps: ['Franchise and budget', 'Composition', 'Types', 'Your selection'],
      s1h: ['Pick your ', 'franchise'],
      s1leadD: 'We put together a sealed selection that fits your budget. Handy if you cannot decide, want a gift or want a quick rip during the stream.',
      s1leadM: 'We put together sealed within your budget.',
      frAria: 'Franchise', fr: { all: 'All', pk: 'Pokémon', op: 'One Piece', tcg: 'Other TCG' },
      frMeta: { all: 'All sealed in stock', pk: 'Pokémon TCG', op: 'One Piece Card Game', tcg: 'Lorcana and more' },
      frMetaN: function (n, min) { return n + ' sealed, from ' + min; },
      budget: 'Your budget', numAria: 'Budget in euros, up to 5,000', rangeAria: 'Budget slider', chipsAria: 'Quick budget', rtop: '5,000', tgPacks: 'Packs', tgBoxes: 'Boxes', tgColl: 'Collections', done: 'Done',
      bhint: 'Drag, tap a quick pick or type your own amount, up to € 5,000.',
      s1hint: 'Step 1 of 4. Next you pick <b>how to build it</b>.', toS2: 'Next: composition',
      s2hSty: ['How do you want to ', 'build it?'], styTt: ['How do you ', 'build it?'], s2hTyp: ['Which ', 'types?'], next: 'Next',
      s2h: ['What do you want to ', 'open?'],
      s2lead: 'Tick one or more types and choose the shape of your basket. No preference? We pick a nice mix within your budget.',
      outStock: 'Out of stock right now', tLang: 'Language', allLangs: 'All languages',
      typeLbl: 'Type', typesHelp: 'Pick several', typesNone: 'Nothing ticked: all types', typesMin: 'Pick at least one type', newTag: 'New', olderNote: 'Topped up with slightly older sets to fill your budget.', selAll: 'Select all', selNone: 'Deselect all', typesN: function (n) { return n + ' ticked'; }, typesAria: 'Product type',
      types: { packs: 'Packs', blisters: 'Blisters', bundels: 'Bundles', etb: 'ETB', boxen: 'Booster boxes', collecties: 'Collections and tins' },
      choices: function (n) { return n === 1 ? '1 option' : n + ' options'; }, from: 'from',
      emptyTypes: function (b) { return 'Within ' + b + ' there is nothing in this franchise yet. Raise your budget in step 1.'; },
      overB: 'Above your budget', catFrom: function (c, m) { return c + ' from ' + m; }, setTo: function (b) { return 'Set budget to ' + b; }, noteTypeUp: function (c, m) { return 'What you ticked starts at ' + m + ' (' + c + '). Until then we put together a mix that fits.'; },
      styleLbl: 'Composition', styleAria: 'Composition',
      styles: { packs: ['More packs to rip', 'As many packs as possible to open'], mix: ['A mix', 'One nice piece plus some packs'], big: ['One top piece', 'One big product that fills your budget'],
        sets: ['Lots of different sets', 'A bit of every set'], nieuw: ['Newest sets', 'What just came out'], cadeau: ['To give as a gift', 'Nice to wrap'],
        spelen: ['To play with', 'Ready to start'], populair: ['Most popular', 'What others choose most'] },
      styleMiss: function (s) { return 'For ' + s + ' nothing fits your budget right now, so we put together a mix.'; },
      escape: ['No preference, you choose', 'We pick a nice mix within your budget.'], compose: 'Build my selection',
      pillFr: 'Change franchise: ', pillBud: 'Change budget: ',
      s3h: ['Your ', 'selection'], mlineNone: 'Nothing picked yet',
      mline: function (n, u, fr) { return n + ', ' + u + ', in ' + fr; },
      noteFallback: function (b) { return 'Nothing you ticked fits within ' + b + ', so we picked a mix that does.'; },
      noteUnder: function (left) { return left + ' is left: with these choices nothing more fits.'; },
      tuneAria: 'Adjust your selection', tuneDone: 'Done', tBud: 'Budget', tFr: 'Franchise', tSty: 'Style', tTyp: 'Type: ', tAll: 'all',
      tN: function (n) { return n + ' types'; }, allTypes: 'All types',
      tyOnly: function (l) { return 'You are only showing ' + l + '.'; }, tyShowAll: 'Show all types', and: ' and ',
      sty: { packs: 'More packs', mix: 'A mix', big: 'One top piece', sets: 'Many sets', nieuw: 'Newest sets', cadeau: 'Gift', spelen: 'To play', populair: 'Most popular' },
      gPrev: 'Previous products', gNext: 'Next products', countOf: function (i, n) { return i + ' of ' + n; }, stepOf: function (i, n) { return 'Step ' + i + ' of ' + n; }, bodyAria: 'Products in your selection',
      tkTeaser: 'See the top cards from your selection', tkUpTo: function (p) { return 'up to ' + p; },
      tkNone: 'We have no top cards for this set in PriceDex yet.', tkNoSetH: 'Set not fixed', tkNoSet: 'The set of this product is not fixed, so we show no top cards.',
      tkTitle: 'Top cards from your sets', tkSub: 'The most valued cards from the sets in your selection, with their price according to PriceDex.', tkLive: function (d) { return 'Prices according to PriceDex, updated ' + d; }, tkTopL: 'Most expensive card', popFr: 'Pick your franchise', popBud: 'Adjust your budget', popClose: 'Done', tkSrc: function (d) { return 'Source: PriceDex, prices from ' + d; }, tkOpen: function (n, p) { return n + ', ' + p + ', view in PriceDex'; }, tkCards: function (n) { return n === 1 ? '1 card' : n + ' cards'; }, tkCta: 'See the top cards from your sets', tkNoFix: function (l) { return 'For ' + l + ' the set is not fixed, so we show no top cards.'; }, tkNoData: function (l) { return 'For ' + l + ' we have no top cards yet.'; }, tkAnd: ' and ', tkTop: function (p) { return 'Most expensive card: ' + p; },
      hover3d: 'Hover to view in 3D', dh: 'Drag to turn', qtyAria: function (t) { return 'Quantity ' + t; }, minus: 'One less', plus: 'One more',
      swap: 'Swap for another product', swapT: 'Swap', remove: 'Remove from your selection', removeT: 'Remove', openAria: function (t) { return 'Open ' + t; },
      eTightH: 'Just a bit tight', eTightP: function (fr, min, need) { return 'In ' + fr + ' it starts at ' + min + '. With ' + need + ' we can already put something together.'; },
      eTightB: function (need) { return 'Set your budget to ' + need; },
      eEmptyH: 'Your selection is empty', eEmptyP: 'You removed everything. Build again with the same choices, or change your franchise and budget.', eEmptyB: 'Build again',
      ofB: function (b) { return 'of ' + b; }, leftL: function (l) { return l + ' to spend'; }, exactL: 'exactly your budget',
      ofLine: function (b, l) { return 'of ' + b + (l ? ', ' + l + ' left' : ''); }, ofExact: function (b) { return 'of ' + b + ', exactly your budget'; }, ofOver: function (b, o) { return 'of ' + b + ', ' + o + ' over your budget'; }, addOverBy: function (o) { return o + ' over your budget'; },
      addSub: 'Pick what you want to add to your selection.', addBud: function (b) { return 'Budget ' + b; }, addToSel: 'Add to selection', addDone: 'Added', inSel: function (n) { return n + 'x in your selection'; }, sortLbl: 'Sort', sortRec: 'Recommended', sortAsc: 'Price low to high', sortDesc: 'Price high to low', addFrAria: 'Franchise',
      addBtn: 'Add something', addSearch: 'Search a product', addMore: 'Also show pricier', addOver: 'Over your budget', addNone: 'Nothing found within your choices.',
      addOne: 'Add', addAdded: function (t) { return t + ' added.'; }, addClose: 'Close', addLeft: function (l) { return l + ' left in your budget'; }, addAll: 'All',
      reroll: 'Another pick', toCart: 'All in my cart',
      noOther: 'For this budget in this franchise there is no other mix. Raise your budget or pick another franchise.',
      plusNo: function (t, b) { return 'Another ' + t + ' no longer fits within your budget of ' + b + '.'; },
      swapNo: 'No other product fits in this spot within your budget.',
      s4h: ['In your ', 'cart'],
      dline: function (u, t) { return '<b>' + u + '</b> in a gift box, <b>' + t + '</b> in total. You can still change everything in your cart.'; },
      dlineUndone: 'Undone: your selection is no longer in your cart.',
      seeCart: 'View my cart', undo: 'Undo', again: 'Build a new one', tag: 'Rip Lab', skip: 'Skip',
      units: function (u) { return u === 1 ? '1 item' : u + ' items'; }, products: function (n) { return n === 1 ? '1 product' : n + ' products'; },
      live: {
        world: function (f) { return f + ' picked'; },
        step: ['Step 1 of 4: franchise and budget', 'Step 2 of 4: composition', 'Step 4 of 4: your selection', 'In your cart'], typ: 'Step 3 of 4: types',
        qty: function (t, u, tot) { return t + ': ' + u + '. Total ' + tot + '.'; },
        swapped: function (t, p) { return 'Swapped for ' + t + ', ' + p + '.'; }, removed: function (t) { return t + ' removed.'; },
        newSel: function (n, t) { return 'New selection: ' + n + ', ' + t + '.'; }, upd: function (n, t) { return 'Updated: ' + n + ', ' + t + '.'; },
        tooTight: 'Your budget is too tight for this choice.', none: 'No selection with these choices.',
        gift: function (u) { return u + ' go in a gift box to your cart.'; }, inCart: function (u, t) { return u + ' in your cart, ' + t + ' in total.'; }
      }
    }
  };
  function strFor(lang) { return STR[lang] || STR.nl; }

  /* ---------------- hulpjes ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function round2(n) { return Math.round((n + 1e-9) * 100) / 100; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function prefersReduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  /* GSAP enkel als de pagina het al geladen heeft (asynchroon script); anders geen animatie, wel de eindstand */
  function G() { var g = window.gsap; return g && g.version && g.timeline ? g : null; }
  function anim(S) { return !S.RM && !!G(); }
  function thousands(s, lang) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, lang === 'en' ? ',' : lang === 'fr' ? ' ' : '.'); }
  function eurL(n, lang) { var v = round2(n || 0).toFixed(2).split('.'); return '€ ' + thousands(v[0], lang) + (lang === 'en' ? '.' : ',') + v[1]; }
  function eurIntL(n, lang) { return '€ ' + thousands(String(Math.round(n || 0)), lang); }
  function fmtInt(n, lang) { return thousands(String(Math.round(n || 0)), lang); }
  function brusselsHour() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var h = parts.filter(function (p) { return p.type === 'hour'; })[0];
      return h ? parseInt(h.value, 10) % 24 : new Date().getHours();
    } catch (e) { return new Date().getHours(); }
  }
  function greetingKey() { var h = brusselsHour(); return h >= 5 && h < 12 ? 'morning' : h >= 12 && h < 18 ? 'afternoon' : 'evening'; }
  function nowMs() { return (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now(); }
  function mulberry32(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  /* ---------------- budget (eigenaar 10 okt: "gewoon tot max 5k, geen quantity-limiet") ----------------
     Geen aantal-limiet meer vanuit de wizard; het budget gaat tot BUDGET_MAX (schuif, typen en snelkeuzes). */
  var BUDGET_MAX = 5000;
  var SLIDER_MAX = BUDGET_MAX;
  var QTY_SAFE = 999;      /* enkel een technisch vangnet tegen onzin, geen klantlimiet */
  function qtyMax() { return QTY_SAFE; }
  /* ---------------- pictogrammen en motieven (zelf getekend, inline SVG; geen logo's of personages) ---------------- */
  var SV = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var ICON = {
    minus: '<svg ' + SV + ' stroke-width="2.2"><path d="M6 12h12"/></svg>',
    plus: '<svg ' + SV + ' stroke-width="2.2"><path d="M6 12h12M12 6v12"/></svg>',
    swap: '<svg ' + SV + ' stroke-width="1.9"><path d="M19.5 10A7.5 7.5 0 0 0 6 6.6L4.5 8"/><path d="M4.5 4v4h4"/><path d="M4.5 14A7.5 7.5 0 0 0 18 17.4l1.5-1.4"/><path d="M19.5 20v-4h-4"/></svg>',
    x: '<svg ' + SV + ' stroke-width="1.9"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    edit: '<svg class="ed" ' + SV + ' stroke-width="2"><path d="M4 20h4L19 9l-4-4L4 16z"/></svg>',
    empty: '<svg ' + SV + ' stroke-width="1.7"><path d="M4 11h16v8.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5z"/><path d="M3 7.5h18V11H3z"/><path d="M12 7.5V21"/></svg>',
    spark: '<svg ' + SV + ' stroke-width="1.9"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/></svg>',
    arr: '<svg class="arr" ' + SV + ' stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    back: '<svg ' + SV + ' stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>',
    prev: '<svg ' + SV + ' stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg ' + SV + ' stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>',
    check: '<svg ' + SV + ' stroke-width="3"><path d="M6 12.5l4 4 8-9"/></svg>',
    tune: '<svg ' + SV + ' stroke-width="1.9"><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2.2"/><circle cx="9" cy="17" r="2.2"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 10l5 5 5-5z"/></svg>',
    reroll: '<svg ' + SV + ' stroke-width="1.9"><path d="M4 7h3.5c2.2 0 3.6 1 4.8 3l1.4 2.4c1.2 2 2.6 3 4.8 3H20"/><path d="M4 17h3.5c1.4 0 2.5-.4 3.4-1.2"/><path d="M14.3 8.2c.9-.8 2-1.2 3.4-1.2H20"/><path d="M17.5 4.5L20 7l-2.5 2.5"/><path d="M17.5 13L20 15.4l-2.5 2.5"/></svg>',
    cart: '<svg ' + SV + ' stroke-width="1.9"><path d="M4 11h16v8.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5z"/><path d="M3 7.5h18V11H3z"/><path d="M12 7.5V21"/><path d="M12 7.5C10.5 4 7 3.6 7 5.6c0 1.6 2.6 1.9 5 1.9 2.4 0 5-.3 5-1.9 0-2-3.5-1.6-5 1.9z"/></svg>',
    drag: '<svg ' + SV + ' stroke-width="1.8"><path d="M20 12a8 8 0 0 1-14.3 4.9"/><path d="M4 12a8 8 0 0 1 14.3-4.9"/><path d="M18.5 3.5v3.8h-3.8"/><path d="M5.5 20.5v-3.8h3.8"/></svg>'
  };
  var MOTIF = {
    all: '<svg ' + SV + ' stroke-width="1.6"><rect x="4" y="4.5" width="9.5" height="13.5" rx="1.8" transform="rotate(-9 8.75 11.25)"/><rect x="10.5" y="6" width="9.5" height="13.5" rx="1.8" transform="rotate(8 15.25 12.75)"/></svg>',
    pk: '<svg ' + SV + ' stroke-width="1.6"><path d="M13.5 2.5L6 13.5h5.2l-2 8 8.8-11.6h-5.3z"/></svg>',
    op: '<svg ' + SV + ' stroke-width="1.6"><circle cx="12" cy="4.8" r="2.2"/><path d="M12 7v14M7.5 10.5h9M4.8 15.5q7.2 9.5 14.4 0"/></svg>',
    tcg: '<svg ' + SV + ' stroke-width="1.6"><path d="M4 9.5l4-5h8l4 5-8 11z"/><path d="M4 9.5h16M12 20.5l-4-11M12 20.5l4-11"/></svg>'
  };
  var TICON = {
    packs: '<svg ' + SV + ' stroke-width="1.7"><path d="M7 3.5h10l-.7 2 .7 2V20a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V7.5l.7-2z"/><path d="M7 7.5h10M10 12.5l2 2.5 2-2.5"/></svg>',
    blisters: '<svg ' + SV + ' stroke-width="1.7"><rect x="5" y="3" width="14" height="18" rx="2.2"/><circle cx="12" cy="6" r="1"/><rect x="8.5" y="9" width="7" height="9" rx="1.2"/></svg>',
    bundels: '<svg ' + SV + ' stroke-width="1.7"><rect x="3.5" y="7" width="7" height="13" rx="1.3"/><rect x="8.5" y="5" width="7" height="15" rx="1.3"/><rect x="13.5" y="7" width="7" height="13" rx="1.3"/></svg>',
    etb: '<svg ' + SV + ' stroke-width="1.7"><rect x="4" y="9" width="16" height="11.5" rx="1.6"/><path d="M3 5.5h18V9H3z"/><path d="M12 5.5v15"/></svg>',
    boxen: '<svg ' + SV + ' stroke-width="1.7"><path d="M3.5 8L12 4l8.5 4v8.5L12 20.5l-8.5-4z"/><path d="M3.5 8L12 12l8.5-4M12 12v8.5"/></svg>',
    collecties: '<svg ' + SV + ' stroke-width="1.7"><rect x="3.5" y="6" width="17" height="14" rx="2"/><path d="M12 9.2l1.2 2.5 2.7.3-2 1.8.6 2.7-2.5-1.4-2.5 1.4.6-2.7-2-1.8 2.7-.3z"/></svg>'
  };
  /* de drie mini-illustraties van de samenstelling (packs, mix, topstuk) */
  var STYLE_ILL = {
    packs: '<svg viewBox="0 0 60 42" fill="currentColor" aria-hidden="true"><rect x="4" y="10" width="9" height="24" rx="2" opacity=".55"/><rect x="15.5" y="7" width="9" height="27" rx="2" opacity=".75"/><rect x="27" y="5" width="9" height="29" rx="2"/><rect x="38.5" y="7" width="9" height="27" rx="2" opacity=".75"/><rect x="50" y="10" width="7" height="24" rx="2" opacity=".55"/><rect x="2" y="36" width="56" height="2" rx="1" opacity=".25"/></svg>',
    mix: '<svg viewBox="0 0 60 42" fill="currentColor" aria-hidden="true"><rect x="6" y="8" width="24" height="26" rx="3"/><rect x="9" y="11" width="18" height="4" rx="1" fill="#fff" opacity=".5"/><rect x="34" y="12" width="9" height="22" rx="2" opacity=".7"/><rect x="46" y="15" width="9" height="19" rx="2" opacity=".5"/><rect x="2" y="36" width="56" height="2" rx="1" opacity=".25"/></svg>',
    big: '<svg viewBox="0 0 60 42" fill="currentColor" aria-hidden="true"><rect x="13" y="4" width="34" height="30" rx="3"/><path d="M30 10.5l2 4.3 4.6.5-3.4 3.1 1 4.6-4.2-2.4-4.2 2.4 1-4.6-3.4-3.1 4.6-.5z" fill="#fff" opacity=".8"/><rect x="2" y="36" width="56" height="2" rx="1" opacity=".25"/></svg>'
  };
  /* cadeaudoos (bevestiging): id's van de verlopen per instantie uniek (uid) */
  function giftSVG(uid) {
    var F = uid + 'F', L = uid + 'L', Gd = uid + 'G';
    return '<svg viewBox="0 0 200 186" aria-hidden="true"><defs><linearGradient id="' + F + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#8a6db6"/><stop offset="1" stop-color="#4a3470"/></linearGradient>' +
      '<linearGradient id="' + L + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#a28ac9"/><stop offset="1" stop-color="#6a4f94"/></linearGradient>' +
      '<linearGradient id="' + Gd + '" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#b8860f"/><stop offset=".45" stop-color="#F2C95E"/><stop offset="1" stop-color="#b8860f"/></linearGradient></defs>' +
      '<ellipse cx="100" cy="178" rx="74" ry="6" fill="rgba(26,6,62,.13)"/>' +
      '<rect x="30" y="84" width="140" height="92" rx="9" fill="url(#' + F + ')"/>' +
      '<path d="M30 84h140v18L30 132z" fill="#fff" opacity=".08"/>' +
      '<rect x="21" y="64" width="158" height="28" rx="7" fill="url(#' + L + ')"/>' +
      '<rect x="88" y="64" width="24" height="112" fill="url(#' + Gd + ')"/>' +
      '<path d="M100 64c-8-24-42-30-44-12-2 14 26 15 44 12z" fill="url(#' + Gd + ')"/>' +
      '<path d="M100 64c8-24 42-30 44-12 2 14-26 15-44 12z" fill="url(#' + Gd + ')"/>' +
      '<path d="M100 64c-6 8-14 18-24 22M100 64c6 8 14 18 24 22" stroke="#b8860f" stroke-width="5" fill="none" stroke-linecap="round"/>' +
      '<circle cx="100" cy="62" r="8" fill="#c9971a"/>' +
      '<g transform="rotate(9 152 96)"><path d="M152 92v8" stroke="#c9971a" stroke-width="2"/><rect x="132" y="100" width="44" height="28" rx="5" fill="#fff"/><rect x="138" y="108" width="24" height="4" rx="2" fill="#2d1270" opacity=".75"/><rect x="138" y="116" width="16" height="3" rx="1.5" fill="#c9971a"/></g>' +
      '</svg>';
  }

  /* ---------------- gegevens: werelden, soorten ---------------- */
  var FR_ORDER = ['all', 'pk', 'op', 'tcg'];
  var FR_BASE = { all: '#e4dff1', pk: '#dfe2f5', op: '#ecdfee', tcg: '#dcd2ef' };
  var FR_AC = { all: '#7B5EA7', pk: '#2f5bc4', op: '#c2362b', tcg: '#5b3a96' };
  /* doorgeefknoppen voor het keuzescherm van de pagina (app.js klikt .cws-seg[data-group="franchise3"] button[data-franchise3]) */
  var FR3 = { mix: 'all', pokemon: 'pk', one_piece: 'op', '': 'tcg' };
  var TYPE_ORDER = ['packs', 'blisters', 'bundels', 'etb', 'boxen', 'collecties'];
  var STYLES = ['packs', 'mix', 'big', 'sets', 'nieuw', 'cadeau', 'spelen', 'populair'];
  function frOf(p) { var f = String(p.franchise || ''); return /^pok/i.test(f) ? 'pk' : f === 'One Piece' ? 'op' : 'tcg'; }
  function inFr(p, k) { return k === 'all' || frOf(p) === k; }
  /* soort uit het veld kind van ctx.products (zelfde namen als de budgetbouwer van de pagina) */
  /* Soort in stap 2, de strook en Voeg iets toe (eigenaar 9 okt: "alle categorieen vanuit Shopify"): de Shopify-categorie
     van elk product (category:-tag, in app.js via bouwerSoort vertaald naar kind) met de namen van de shop. Enkel echt
     dezelfde soort is samengevoegd (Sleeved Boosters bij Booster Packs). Bewust weggelaten: Mystery Boxes, Mystery Packs en
     Mystery Slabs (randomizer, compliance: geen kansspel in de Rip Lab) en Accessoires (geen sealed product);
     bouwerSoort in app.js laat ze al weg, catOf geeft voor alles wat onbekend is null. */
  /* (10 okt) Soorten en talen uit exact dezelfde bron als het shopmenu van de Clean-laag: de Shopify-tags die app.js per
     product meegeeft in window.P (scat = category:-tag, slang = language:-tag, sfr = franchise:-tag), dezelfde namen als
     de shop en dezelfde volgorde als catsFor/langsFor in app.js (meeste producten eerst). Ook categorieen zonder voorraad
     staan erin (dan "Nu niet op voorraad", niet kiesbaar). Bewust weggelaten: Mystery Boxes, Mystery Packs en Mystery
     Slabs (randomizer, compliance), Accessoires (geen sealed product), Livestream en de cadeaubon. */
  var CAT_EXC = /mystery|accessoire|livestream|cadeau|gift/i;
  var KIND2SCAT = { 'Booster Pack': 'Booster Packs', 'Blister': 'Blisters', 'Booster Box': 'Booster Boxen', 'Booster Bundle': 'Booster Bundles', 'Elite Trainer Box': 'Elite Trainer Boxen (ETB)',
    'Collectie box': 'Collection Boxen', 'Tin': 'Tins', 'Ultra Premium Collection': 'Ultra Premium Collection', 'Double Pack Set': 'Double Packs' };
  var CAT_LBL = {
    fr: { 'Booster Packs': 'Packs de boosters', 'Booster Boxen': 'Boîtes de boosters', 'Booster Bundles': 'Lots de boosters', 'Elite Trainer Boxen (ETB)': 'Coffrets Elite Trainer (ETB)',
      'Collection Boxen': 'Coffrets de collection', 'Sleeved Boosters': 'Boosters sleeved', 'Double Packs': 'Double Packs' },
    en: { 'Booster Boxen': 'Booster Boxes', 'Elite Trainer Boxen (ETB)': 'Elite Trainer Boxes (ETB)', 'Collection Boxen': 'Collection Boxes' }
  };
  var LANG_LBL = {
    fr: { Engels: 'Anglais', Japans: 'Japonais', Chinees: 'Chinois', Koreaans: 'Coréen', Frans: 'Français', Duits: 'Allemand', Spaans: 'Espagnol', Italiaans: 'Italien', Nederlands: 'Néerlandais' },
    en: { Engels: 'English', Japans: 'Japanese', Chinees: 'Chinese', Koreaans: 'Korean', Frans: 'French', Duits: 'German', Spaans: 'Spanish', Italiaans: 'Italian', Nederlands: 'Dutch' }
  };
  function catGroup(c) { return /Pack|Sleeved|Blister/i.test(c) ? 'packs' : /Bundle|ETB|Elite|Booster Box/i.test(c) ? 'boxes' : 'coll'; }
  function catIcon(c) {
    return /Pack|Sleeved/i.test(c) ? 'packs' : /Blister/i.test(c) ? 'blisters' : /Bundle/i.test(c) ? 'bundels' : /ETB|Elite/i.test(c) ? 'etb' : /Booster Box/i.test(c) ? 'boxen' : 'collecties';
  }
  function frOfSfr(sfr) { if (!sfr || CAT_EXC.test(sfr)) return null; return sfr === 'Pokemon' ? 'pk' : sfr === 'One Piece' ? 'op' : 'tcg'; }
  /* alle producten van de pagina met hun tags (window.P, de brug van app.js); lui opgebouwd, zonder brug: enkel ctx.products */
  function metaAll(S) {
    if (S.meta) return S.meta;
    var BP = null; try { BP = window.P; } catch (e) { BP = null; }
    if (!BP || typeof BP !== 'object') return null;
    var out = [], byH = {}, seen = {};
    Object.keys(BP).forEach(function (id) {
      var q = BP[id]; if (!q || !q.h || seen[q.h]) return; seen[q.h] = 1;
      var fr = frOfSfr(q.sfr), c = q.scat || null;
      var m = { h: q.h, t: q.t || '', fr: fr, scat: c && !CAT_EXC.test(c) ? c : null, slang: q.slang || null, cr: q.created || '' };
      byH[q.h] = m; if (fr && m.scat) out.push(m);
    });
    if (out.length < 20) return null;
    S.meta = out; S.metaH = byH;
    S.all.forEach(function (p) { var m = byH[p.handle]; if (m) { p._scat = m.scat; p._slang = m.slang; } });
    return out;
  }
  function catOf(p) {
    if (p._scat !== undefined) return p._scat;
    var k = KIND2SCAT[p.kind] || null; return k && !CAT_EXC.test(k) ? k : null;
  }
  function langOf(p) { return p._slang || null; }
  function catLabel(S, id) { return (CAT_LBL[S.lang] || {})[id] || id; }
  function langLabel(S, l) { return (LANG_LBL[S.lang] || {})[l] || l; }
  /* categorieen en talen van de gekozen franchise (en taal), volgorde op aantal zoals het menu */
  function catsMenu(S) { return catsList(S, S.fr, S.tl); }
  function catsList(S, fr, tl) {
    var M = metaAll(S), cnt = {}, order = [];
    var src = M || S.all.map(function (p) { return { fr: frOf(p), scat: catOf(p), slang: langOf(p) }; });
    src.forEach(function (m) { if (!m.scat || (fr !== 'all' && m.fr !== fr) || (tl && m.slang !== tl)) return; if (!(m.scat in cnt)) order.push(m.scat); cnt[m.scat] = (cnt[m.scat] || 0) + 1; });
    return order.sort(function (a, b) { return cnt[b] - cnt[a]; });
  }
  function langsMenu(S) { return langsList(S, S.fr); }
  /* (10 okt) taalfilter weg op vraag van Andrea: geen taalkeuze meer in stap 2, de strook of Voeg iets toe, de samensteller
     laat alle talen toe (S.tl blijft leeg). Zet LANG_FILTER op true om de taalkeuze terug te zetten. */
  var LANG_FILTER = false;
  function langsList(S, fr) {
    if (!LANG_FILTER) { S.tl = ''; if (S.add) S.add.tl = ''; return []; }
    var M = metaAll(S), cnt = {}, order = [];
    (M || []).forEach(function (m) { if (!m.slang || (fr !== 'all' && m.fr !== fr)) return; if (!(m.slang in cnt)) order.push(m.slang); cnt[m.slang] = (cnt[m.slang] || 0) + 1; });
    return order.sort(function (a, b) { return cnt[b] - cnt[a]; });
  }
  /* naar boven afgerond op het raster van de schuif (STEPS), daarboven per 500 */
  function stepUp(v) { for (var i = 0; i < STEPS.length; i++) if (STEPS[i] >= v - 1e-9) return STEPS[i]; return Math.ceil(v / 500) * 500; }
  function typeOf(p) {
    var k = String(p.kind || '');
    if (/Elite Trainer/i.test(k)) return 'etb';
    if (/Booster Box/i.test(k)) return 'boxen';
    if (/Bundle/i.test(k)) return 'bundels';
    if (/Blister/i.test(k)) return 'blisters';
    if (/Booster Pack|Double Pack|Sleeved/i.test(k)) return 'packs';
    if (/Premium|Collect|Tin/i.test(k)) return 'collecties';
    return 'other';
  }
  var KIND_LABELS = {
    nl: { 'Booster Pack': 'Booster pack', 'Double Pack Set': 'Double pack', 'Booster Bundle': 'Booster bundle', 'Booster Box': 'Booster box', 'Collectie box': 'Collectiebox' },
    fr: { 'Booster Pack': 'Booster', 'Double Pack Set': 'Double pack', 'Booster Bundle': 'Booster bundle', 'Booster Box': 'Booster box', 'Collectie box': 'Coffret collection' },
    en: { 'Booster Pack': 'Booster pack', 'Double Pack Set': 'Double pack', 'Booster Bundle': 'Booster bundle', 'Booster Box': 'Booster box', 'Collectie box': 'Collection box' }
  };
  function kindOf(p, lang) { var k = p.kind || ''; var m = KIND_LABELS[lang] || KIND_LABELS.nl; return m[k] || k; }
  var KIND_RE = /\s*[-:]?\s*(Sleeved Booster Pack|Booster Pack|Booster Box|Elite Trainer Box|Booster Bundle Display|Booster Bundle|Mini Tin|Tin|Ultra Premium Collection|Super Premium Collection|Collection Box|Double Pack Set|2-pack Blister|Blister|Bundle)\b.*$/i;
  /* volledige productnaam zoals in de shop (eigenaar 10 okt), enkel zonder het lange voorvoegsel "Pokémon TCG:"; het
     producttype blijft altijd staan */
  function fullTitle(t) { var s = String(t || '').replace(/^Pok[eé]mon TCG:\s*/i, '').trim(); return s || String(t || ''); }
  function shortTitle(t) {
    var s = String(t || '').replace(/^Pok[eé]mon TCG:\s*/i, '').replace(/^Disney Lorcana Set \d+:\s*/i, 'Lorcana ').replace(/^One Piece( Card Game)?:?\s*/i, '').replace(/\s*\([^)]*\)/g, '').trim();
    var s2 = s.replace(KIND_RE, '').replace(/[\s\-:&]+$/, '').trim();
    return s2 || s;
  }

  /* ---------------- samenstellen: nooit boven budget, eerst een anker, dan aanvullen, aantallen schalen mee ----------------
     Eén topstuk: strikt het duurste product binnen het budget (rank 0; Andere selectie neemt het volgende duurste) plus
     hoogstens een klein extra. Meer packs: eerst echte packs en blisters, anders de kleine producten. */
  function poolFr(S) { metaAll(S); return S.all.filter(function (p) { return inFr(p, S.fr) && (!S.tl || langOf(p) === S.tl); }); }
  function poolFor(S) {
    var pool = poolFr(S);
    if (S.types.length && !S.fallback) { var typed = pool.filter(function (p) { return S.types.indexOf(catOf(p)) !== -1; }); if (typed.length) return typed; }
    return pool;
  }
  /* ---------- samenstellingen (eigenaar 10 okt): Veel verschillende sets, Nieuwste sets, Cadeau, Spelen, Populairst ---------- */
  /* producten zonder eigen set (CARDWORLD Kluis, mystery, random): tellen niet mee voor Nieuwste sets en Veel sets */
  var NOSET_RE = /kluis|cardworld|mystery|random|vault/i;
  /* set van een product: de set uit TOPCARDS (zelfde koppeling als de topkaarten), anders de titel zonder producttype */
  function setOf(S, p) {
    S.setOfC = S.setOfC || {}; if (p.handle in S.setOfC) return S.setOfC[p.handle];
    var D = topData(), k = null;
    if (D) { try { var ks = setKeysFor(S, D, p); k = ks && ks[0] || null; } catch (e) { k = null; } }
    return (S.setOfC[p.handle] = k || normT(shortTitle(p.title)).trim());
  }
  /* echte set (sleutel franchise|set) of null */
  function realSetOf(S, p) {
    if (NOSET_RE.test(p.title || '') || NOSET_RE.test(p.handle || '')) return null;
    var D = topData(); if (!D) return null;
    var ks = []; try { ks = setKeysFor(S, D, p); } catch (e) { ks = []; }
    return ks[0] || null;
  }
  /* ---------- Nieuwste sets (eigenaar 10 okt): releasevolgorde per set ----------
     Pokémon: released_at van de PriceDex-setlijst (admin.cardworld.be/api/tcg/pk-sets, enkel lezen), anders TOPCARDS
     info.released. One Piece: de API heeft geen datum, dus de setvolgorde: OP-nn op nummer (OP17 na OP16); andere sets
     (EB, PRB) volgen na de OP-set die als laatste voor hen in de shop verscheen. Enkel als niets daarvan bestaat: de
     eerste publicatie in de shop. Producten zonder set tellen niet mee. */
  function relLoad(S) {
    if (S.relBusy || S.relPk || !window.fetch) return;
    var ck = 'rlw-rel1', hit = null;
    try { hit = JSON.parse(sessionStorage.getItem(ck) || 'null'); } catch (e) { hit = null; }
    var done = function (m) { if (!getState(S.el)) return; S.relPk = m || {}; S.relC = null; S.newC = null; renderStyleArt(S); };
    if (hit && hit.at && Date.now() - hit.at < PDX_TTL && hit.m) { done(hit.m); return; }
    S.relBusy = true;
    fetch((window.CW_RS_PDX_BASE || PDX_BASE) + '/api/tcg/pk-sets').then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); }).then(function (d) {
      var m = {}; ((d && d.data) || []).forEach(function (x) { var k = x.slug || x.id; if (k && x.released_at) m[String(k).toLowerCase()] = x.released_at; });
      try { sessionStorage.setItem(ck, JSON.stringify({ at: Date.now(), m: m })); } catch (e) { /* vol of privévenster */ }
      done(m);
    }).catch(function () { /* TOPCARDS blijft de bron */ }).then(function () { S.relBusy = false; });
  }
  function setPubFirst(S) {
    if (S.setPub) return S.setPub;
    var out = {}; metaAll(S);
    Object.keys(S.metaH || {}).forEach(function (h) {
      var m = S.metaH[h]; if (!m || !m.cr) return;
      var k = realSetOf(S, { handle: h, title: m.t, franchise: m.fr === 'pk' ? 'Pokémon' : m.fr === 'op' ? 'One Piece' : '' }); if (!k) return;
      var c = Date.parse(m.cr); if (c > 0 && (!out[k] || c < out[k])) out[k] = c;
    });
    return (S.setPub = out);
  }
  function relOfSet(S, k) {
    S.relC = S.relC || {}; if (k in S.relC) return S.relC[k];
    var D = topData(), id = k.split('|')[1] || '', v = 0, src = '';
    if (k.indexOf('pokemon|') === 0) {
      var r = S.relPk && S.relPk[id.toLowerCase()]; if (r) { v = Date.parse(r); src = 'pk-sets'; }
      if (!v) { var ri = ((D && D.sets[k]) || {}).info || {}; if (ri.released) { v = Date.parse(ri.released); src = 'topcards'; } }
    } else if (k.indexOf('one-piece|') === 0) {
      var mm = /^OP-?(\d+)$/i.exec(id);
      if (mm) { v = 1e6 + (+mm[1]) * 1000; src = 'setvolgorde'; }
      else {
        var pub = setPubFirst(S), mine = pub[k] || 0, best = 0;
        Object.keys(pub).forEach(function (o) { var m2 = /^one-piece\|OP-?(\d+)$/i.exec(o); if (m2 && pub[o] <= mine && +m2[1] > best) best = +m2[1]; });
        if (best) { v = 1e6 + best * 1000 + 500; src = 'setvolgorde'; }
      }
    }
    if (!v) { var pf = setPubFirst(S)[k]; if (pf) { v = pf; src = 'shop'; } }
    return (S.relC[k] = v || 0);
  }
  function newOf(S, p) {
    S.newC = S.newC || {}; if (p.handle in S.newC) return S.newC[p.handle];
    var k = realSetOf(S, p);
    return (S.newC[p.handle] = k ? relOfSet(S, k) : 0);
  }
  /* de nSets recentste sets per franchise die op voorraad zijn en binnen het budget iets hebben (bij Alles van elke
     franchise apart); enkel producten uit die sets */
  function newestOf(S, pool, budget, nSets) {
    var byFr = {};
    pool.forEach(function (p) {
      if (p.price > budget + 1e-9) return;
      var k = realSetOf(S, p); if (!k || !relOfSet(S, k)) return;
      var f = k.split('|')[0]; (byFr[f] = byFr[f] || {})[k] = relOfSet(S, k);
    });
    var keep = {};
    Object.keys(byFr).forEach(function (f) {
      Object.keys(byFr[f]).sort(function (a, b) { return byFr[f][b] - byFr[f][a]; }).slice(0, nSets || 2).forEach(function (k) { keep[k] = 1; });
    });
    return pool.filter(function (p) { var k = realSetOf(S, p); return k && keep[k]; });
  }
  /* Populairst: echte verkoopcijfers van de shop (admin.cardworld.be/api/cw/bestsellers, 365 dagen, enkel lezen, CORS voor
     cardworld.be), gekoppeld op producttitel. Lukt het niet of zijn er te weinig treffers, dan blijft de keuze verborgen. */
  function popLoad(S) {
    if (S.popBusy || S.popRank || !window.fetch) return;
    var ck = 'rlw-pop1', hit = null;
    try { hit = JSON.parse(sessionStorage.getItem(ck) || 'null'); } catch (e) { hit = null; }
    var done = function (list) {
      if (!getState(S.el)) return;
      var byT = {}; metaAll(S);
      S.all.forEach(function (p) { byT[normT(p.title)] = p.handle; });
      var rank = {}, n = 0;
      (list || []).forEach(function (b, i) { var h = byT[normT(b.title)]; if (h && !(h in rank)) { rank[h] = i; n++; } });
      if (n < 3) return;
      S.popRank = rank;
      qsa('[data-style="populair"],[data-ts="populair"]', S.el).forEach(function (b) { b.hidden = false; });
      renderStyleArt(S);
    };
    if (hit && hit.at && Date.now() - hit.at < PDX_TTL && hit.list) { done(hit.list); return; }
    S.popBusy = true;
    fetch((window.CW_RS_PDX_BASE || PDX_BASE) + '/api/cw/bestsellers?limit=100').then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); }).then(function (d) {
      var list = (d && d.bestsellers || []).map(function (b) { return { title: b.title, qty: b.qty }; });
      try { sessionStorage.setItem(ck, JSON.stringify({ at: Date.now(), list: list })); } catch (e) { /* vol of privévenster */ }
      done(list);
    }).catch(function () { /* geen echte cijfers: de keuze blijft verborgen */ }).then(function () { S.popBusy = false; });
  }
  function minPrice(list) { var m = Infinity; list.forEach(function (p) { if (p.price < m) m = p.price; }); return m === Infinity ? null : m; }
  /* shake (enkel Andere selectie, niet voor Eén topstuk): 1 of 2 = meer schudden in de volgorde, minder regels en een
     lager aandeel voor het hoofdproduct, zodat een groot budget met een klein aanbod toch een zichtbaar andere mix geeft */
  function compose(S, seed, rank, shake, nSets) {
    if (S.style === 'nieuw' && !nSets) {
      var r2 = compose(S, seed, rank, shake, 2);
      if (r2.styleMiss || !r2.items.length || S.budget - r2.total <= S.budget * .15) return r2;
      var r4 = compose(S, seed, rank, shake, 4);
      if (r4.items.length && r4.total > r2.total + 1e-9) { r4.older = true; return r4; }
      return r2;
    }
    var budget = S.budget, frPool = poolFr(S);
    /* (10 okt) Kluis, CARDWORLD-eigen, mystery en random enkel bij Meer packs en Een mix */
    if (S.style !== 'packs' && S.style !== 'mix') frPool = frPool.filter(function (p) { return !NOSET_RE.test(p.title || '') && !NOSET_RE.test(p.handle || ''); });
    shake = shake | 0;
    var cheapest = minPrice(frPool);
    var pool = frPool, fallback = false;
    if (S.types.length && !S.noneSel) {
      var typed = frPool.filter(function (p) { return S.types.indexOf(catOf(p)) !== -1; });
      if (typed.some(function (p) { return p.price <= budget + 1e-9; })) pool = typed; else fallback = true;
    }
    if (!pool.some(function (p) { return p.price <= budget + 1e-9; })) return { items: [], total: 0, cheapest: cheapest, fallback: fallback };
    var style = S.style, styleMiss = false;
    var rnd = mulberry32((seed * 2654435761) ^ Math.round(budget * 100) ^ (shake * 7919));
    var work = pool, anchorPool = null;
    var small = function (p) { var t = typeOf(p); return t === 'packs' || t === 'blisters'; };
    var fits = function (l) { return l.some(function (p) { return p.price <= budget + 1e-9; }); };
    if (style === 'sets') {
      var sw = pool.filter(function (p) { return !!realSetOf(S, p); });
      if (fits(sw)) work = sw; else styleMiss = true;
    }
    if (style === 'packs') {
      var packs = pool.filter(function (p) { return small(p) && p.price <= budget + 1e-9; });
      var smalls = pool.filter(function (p) { return p.price <= Math.max(budget * .22, 12); });
      if (packs.length >= 2) work = packs; else if (smalls.length >= 2) work = smalls;
    } else if (style === 'cadeau') {
      /* collection boxen, ETB's, tins en bundels, geen losse packs */
      var gw = pool.filter(function (p) { var k = typeOf(p); return k === 'etb' || k === 'collecties' || k === 'bundels'; });
      if (fits(gw)) work = gw; else styleMiss = true;
    } else if (style === 'spelen') {
      /* een ETB of bundel (sleeves, dobbelstenen) als basis, aangevuld met packs */
      var pw = pool.filter(function (p) { var k = typeOf(p); return k === 'etb' || k === 'bundels'; }), pp = pool.filter(small);
      if (fits(pw)) { anchorPool = pw; work = pw.concat(pp); } else if (fits(pp)) work = pp; else styleMiss = true;
    } else if (style === 'nieuw') {
      var nw = newestOf(S, pool, budget, nSets || 2);
      if (nw.length) work = nw; else styleMiss = true;
    } else if (style === 'populair') {
      var pr = S.popRank ? pool.filter(function (p) { return p.handle in S.popRank; }) : [];
      if (fits(pr)) work = pr; else styleMiss = true;
    }
    if (styleMiss) style = 'mix';
    var jit = style === 'big' ? 0 : .45 + .4 * shake;
    var order = style === 'populair'
      /* Populairst: volgorde op verkoopcijfers (licht geschud voor Andere selectie), niet op prijs */
      ? work.map(function (p) { return { p: p, k: (S.popRank[p.handle] + 1) * (1 - jit * .6 + rnd() * jit * 1.2) }; }).sort(function (a, b) { return a.k - b.k; }).map(function (o) { return o.p; })
      : work.map(function (p) { return { p: p, k: p.price * (1 - jit + rnd() * 2 * jit) }; }).sort(function (a, b) { return b.k - a.k; }).map(function (o) { return o.p; });
    var share = style === 'big' ? 1 : style === 'packs' ? .3 : style === 'sets' ? .35 : style === 'spelen' ? .8 : (shake === 2 ? .5 : .7);
    var anchor;
    if (anchorPool) {
      anchor = null;
      for (var ai = 0; ai < order.length; ai++) { if (anchorPool.indexOf(order[ai]) !== -1 && order[ai].price <= budget * share + 1e-9) { anchor = order[ai]; break; } }
      if (!anchor) anchor = anchorPool.filter(function (p) { return p.price <= budget + 1e-9; }).sort(function (a, b) { return b.price - a.price; })[0];
    } else if (style === 'big') {
      var tops = pool.filter(function (p) { return p.price <= budget + 1e-9; }).sort(function (a, b) { return b.price - a.price || a.handle.localeCompare(b.handle); });
      anchor = tops[Math.min(tops.length - 1, Math.max(0, rank | 0))];
    } else {
      anchor = null;
      for (var i = 0; i < order.length; i++) { if (order[i].price <= budget * share + 1e-9) { anchor = order[i]; break; } }
      if (!anchor) anchor = order.filter(function (p) { return p.price <= budget + 1e-9; }).sort(function (a, b) { return b.price - a.price; })[0];
    }
    if (!anchor) return { items: [], total: 0, cheapest: cheapest, fallback: fallback };
    var f = Math.max(1, budget / 150);
    var rowsMax = style === 'big' ? 2 : Math.max(2, Math.round(Math.min(18, Math.round((style === 'packs' ? 5 : style === 'sets' ? 9 : 6) * Math.sqrt(f))) * (shake === 1 ? .7 : shake === 2 ? .5 : 1)));
    var items = [{ p: anchor, qty: 1 }];
    var remaining = round2(budget - anchor.price), boost = false;
    /* Veel verschillende sets: eerst elke set hoogstens een keer (per product hoogstens 2), dubbele sets pas als er nog
       veel budget over is */
    var usedSet = {}, strictSets = style === 'sets';
    if (style === 'sets') usedSet[setOf(S, anchor)] = 1;
    var capFor = function (p) { return boost ? Math.max(6, Math.ceil(budget / Math.max(1, items.length) / Math.max(.01, p.price))) : (small(p) ? (style === 'packs' ? 8 : style === 'sets' ? 2 : 6) : 1); };
    function rowOf(p) { for (var k = 0; k < items.length; k++) if (items[k].p.handle === p.handle) return items[k]; return null; }
    function tryAdd(p) {
      if (p.price > remaining + 1e-9) return false;
      var row = rowOf(p);
      if (row) { if (row.qty >= capFor(p)) return false; row.qty++; }
      else {
        if (items.length >= rowsMax) return false;
        if (strictSets) { var sk = setOf(S, p); if (usedSet[sk]) return false; usedSet[sk] = 1; }
        items.push({ p: p, qty: 1 });
      }
      remaining = round2(remaining - p.price); return true;
    }
    var rest = order.filter(function (p) { return p !== anchor; });
    if (style === 'big') {
      var byDesc = rest.slice().sort(function (a, b) { return b.price - a.price; });
      for (var j = 0; j < byDesc.length; j++) { var q = byDesc[j]; if ((small(q) || q.price <= budget * .15) && tryAdd(q)) break; }
    } else {
      var g = 0, added = true;
      while (added && g++ < 200) { added = false; rest.forEach(function (p) { if (tryAdd(p)) added = true; }); }
      var asc = rest.slice().sort(function (a, b) { return a.price - b.price; });
      g = 0; added = true;
      while (added && g++ < 200) { added = false; asc.forEach(function (p) { if (tryAdd(p)) added = true; }); }
      if (strictSets && remaining > budget * .05) { strictSets = false; g = 0; added = true; while (added && g++ < 200) { added = false; asc.forEach(function (p) { if (tryAdd(p)) added = true; }); } }
      if (remaining > budget * .05) { boost = true; g = 0; added = true; while (added && g++ < 80) { added = false; order.forEach(function (p) { if (tryAdd(p)) added = true; }); } }
    }
    var head = items[0], tail = items.slice(1).sort(function (a, b) { return b.p.price * b.qty - a.p.price * a.qty; });
    var out = [head].concat(tail);
    return { items: out, total: round2(out.reduce(function (s, x) { return s + x.p.price * x.qty; }, 0)), cheapest: cheapest, fallback: fallback, styleMiss: styleMiss, older: false };
  }
  function sigH(items) { return items.map(function (x) { return x.p.handle; }).sort().join('|'); }
  function sigQ(items) { return items.map(function (x) { return x.p.handle + ':' + x.qty; }).sort().join('|'); }
  function units(S) { return S.items.reduce(function (s, x) { return s + x.qty; }, 0); }
  function recalc(S) { S.total = round2(S.items.reduce(function (s, x) { return s + x.p.price * x.qty; }, 0)); }
  /* geheugen van getoonde mixen binnen dezelfde instellingen (wereld, budget, soorten, stijl): Andere selectie toont nooit
     iets dat al in beeld was, en zoekt eerst een ander hoofdproduct */
  function shownKey(S) { return [S.fr, S.tl, S.budget, S.types.slice().sort().join(','), S.style].join('|'); }
  function remember(S, r) {
    var k = shownKey(S);
    if (S.shown.key !== k) S.shown = { key: k, sigs: {}, sets: {}, anchors: {} };
    if (r && r.items && r.items.length) { S.shown.sigs[sigQ(r.items)] = 1; S.shown.sets[sigH(r.items)] = 1; S.shown.anchors[r.items[0].p.handle] = 1; }
  }
  function apply(S, r) { S.items = r.items; S.total = r.total; S.fallback = r.fallback; S.styleMiss = !!r.styleMiss; S.older = !!r.older; S.cheapest = r.cheapest; S.composed = true; S.dirty = false; remember(S, r); }
  /* andere selectie: nooit dezelfde als die er staat en nooit een die al getoond is binnen deze instellingen; eerst een mix
     met een ander hoofdproduct, dan een andere set producten, dan andere aantallen; tijdslimiet zodat een klik nooit hapert */
  /* minstens REROLL_MIN pogingen, ook als de hoofdthread net druk is (3D-modellen die laden rekken de klok); daarna de tijdslimiet */
  var REROLL_TRIES = 120, REROLL_MIN = 24, REROLL_MS = 150;
  /* Andere selectie (eigenaar 9 okt: "altijd een ander product voorstellen"): de kandidaat met de minste overlap in handles
     met de huidige selectie (gewogen op prijs), liefst 0; nooit dezelfde set handles (enkel andere aantallen telt niet) en
     nooit een set die al getoond is. Drie rondes: gewoon, dan met meer schudden (shake 1 en 2); Eén topstuk loopt de lijst
     af op rang en schudt niet. Kan het echt niet, dan null (melding). */
  function rerollSearch(S) {
    var sh = S.shown, curH = sigH(S.items), curSet = {};
    S.items.forEach(function (x) { curSet[x.p.handle] = 1; });
    var best = null, bestSeed = 0, bestOv = Infinity, bestN = Infinity, t0 = nowMs(), stop = false;
    for (var pass = 0; pass <= (S.style === 'big' ? 0 : 2) && bestOv > 0 && !stop; pass++) {
      for (var i = 1; i <= REROLL_TRIES; i++) {
        /* de tijdslimiet mag de zoektocht enkel inkorten als er al een kandidaat is; anders zou "geen andere mix" vals
           verschijnen zodra de hoofdthread druk is (3D-modellen die laden) terwijl er nog mixen bestaan */
        if (i > REROLL_MIN && best && nowMs() - t0 > REROLL_MS) { stop = true; break; }
        var seed = S.seed + i + pass * 1000, c = compose(S, seed, i, pass);
        if (!c.items.length) break;
        var hs = sigH(c.items);
        if (hs === curH || sh.sets[hs] || sh.sigs[sigQ(c.items)]) continue;
        var ov = 0, n = 0;
        c.items.forEach(function (x) { if (curSet[x.p.handle]) { ov += x.p.price * x.qty; n++; } });
        if (!best || ov < bestOv || (ov === bestOv && n < bestN)) { best = c; bestSeed = seed; bestOv = ov; bestN = n; }
        if (bestOv === 0) break;
      }
    }
    return best ? { r: best, seed: bestSeed, overlap: bestN } : null;
  }

  /* ---------------- markup (html(ctx)): de eindstand van elke stap staat in de HTML ---------------- */
  function emH(t2) { return esc(t2[0]) + '<em>' + esc(t2[1]) + '</em>'; }
  /* Alles selecteren en Alles deselecteren (eigenaar 10 okt), in de kop van Soort en bovenaan het soortmenu van de strook */
  function selRowHTML(t) { return '<span class="rlw-selrow"><button type="button" class="rlw-sel" data-rlw-selall>' + esc(t.selAll) + '</button><button type="button" class="rlw-sel" data-rlw-selnone>' + esc(t.selNone) + '</button></span>'; }
  function btnPri(attr, label, arrow) { return '<button type="button" class="rlw-btn rlw-btn--pri" ' + attr + '>' + esc(label) + (arrow ? ICON.arr : '') + '</button>'; }
  function chipsHTML(lang) { return QUICK.map(function (v) { return '<button type="button" class="rlw-chip" data-v="' + v + '" aria-pressed="false">' + eurIntL(v, lang) + '</button>'; }).join(''); }
  var QUICK = [25, 50, 75, 150, 300, 500];
  function html(ctx) {
    var lang = ctx.lang || 'nl', t = strFor(lang), uid = 'rlw' + Math.random().toString(36).slice(2, 8);
    var o = '<div class="rlw" data-fr="all" data-step="1" data-lang="' + esc(lang) + '" data-uid="' + uid + '" aria-label="' + esc(t.appAria) + '">';
    /* de Clean-laag leest de begroeting uit de budgetkaart (.cws-eyebrow-greet): onzichtbaar meegeven */
    o += '<span class="cws-eyebrow-greet" hidden>' + esc(t.greet[greetingKey()] + (ctx.name ? ', ' + ctx.name : '')) + '</span>';
    o += '<div class="cws-seg" data-group="franchise3" style="display:none" aria-hidden="true">' + Object.keys(FR3).map(function (k) {
      return '<button type="button" tabindex="-1" data-franchise3="' + k + '"></button>';
    }).join('') + '</div>';
    o += '<div class="rlw-wrap">';
    o += '<div class="rlw-bg" aria-hidden="true">' + FR_ORDER.map(function (k, i) { return '<div class="rlw-bgl' + (i ? '' : ' is-on') + '" data-l="' + k + '"></div>'; }).join('') + '<div class="rlw-wave" data-rlw-wave></div></div>';
    o += '<div class="rlw-fx" data-rlw-fx aria-hidden="true"></div>';
    /* stappenbalk */
    o += '<nav class="rlw-bar" aria-label="' + esc(t.stepsAria) + '"><button type="button" class="rlw-back" data-rlw-back aria-hidden="true" tabindex="-1">' + ICON.back + esc(t.back) + '</button><ol class="rlw-steps">';
    /* vier stappen (eigenaar 10 okt): franchise en budget, samenstelling, soort, jouw selectie. Intern blijft stap 2 een
       scene met twee pagina's (S.sub = 'sty' of 'typ'); data-go 2t = stap 2, pagina soort */
    ['1', '2', '2t', '3'].forEach(function (g, i) {
      o += '<li><button type="button" class="rlw-stp" data-go="' + g + '" data-vi="' + (i + 1) + '"' + (i === 0 ? ' aria-current="step"' : '') + (i === 3 ? ' disabled' : '') + '><span class="n"><b>' + (i + 1) + '</b>' + ICON.check + '</span><span class="lbl">' + esc(t.steps[i]) + '</span></button></li>';
    });
    /* rechts: chips franchise en budget (bewerkbaar, alle stappen) */
    /* gsm-kop (eigenaar 10 okt): "Stap 1 van 4" plus de staptitel; de stappen zelf worden daar een balk van 4 segmenten */
    o += '</ol><p class="rlw-mstep" aria-hidden="true"><span class="k" data-rlw-mk>' + esc(t.stepOf(1, 4)) + '</span><b data-rlw-mt>' + esc(t.steps[0]) + '</b></p><div class="rlw-barr"><div class="rlw-sumw"><div class="rlw-sum" data-rlw-sum></div>' +
      '<div class="rlw-spop" id="' + uid + '-spop-fr" data-rlw-spop="fr" role="dialog" aria-label="' + esc(t.popFr) + '" hidden><p class="rlw-spt">' + esc(t.popFr) + '</p><div class="rlw-sptiles">' + FR_ORDER.map(function (k) {
        return '<button type="button" class="rlw-sptile" data-pw="' + k + '" aria-pressed="false" style="--w-ac:' + FR_AC[k] + '">' + MOTIF[k] + '<span>' + esc(t.fr[k]) + '</span></button>';
      }).join('') + '</div></div>' +
      '<div class="rlw-spop" id="' + uid + '-spop-bud" data-rlw-spop="bud" role="dialog" aria-label="' + esc(t.popBud) + '" hidden><p class="rlw-spt">' + esc(t.popBud) + '</p>' +
      '<div class="rlw-spbud"><label class="rlw-tnum"><span aria-hidden="true">€</span><input data-rlw-pin type="text" inputmode="numeric" autocomplete="off" value="75" aria-label="' + esc(t.numAria) + '"></label>' +
      '<input class="rlw-range" data-rlw-prange type="range" min="0" max="100" step="1" value="10" aria-label="' + esc(t.rangeAria) + '"></div>' +
      '<div class="rlw-chips" data-rlw-pchips role="group" aria-label="' + esc(t.chipsAria) + '">' + chipsHTML(lang) + '</div>' +
      '<button type="button" class="rlw-spdone" data-rlw-spdone>' + esc(t.popClose) + '</button></div></div></div></nav>';
    o += '<main class="rlw-scenes" data-rlw-scenes>';
    /* STAP 1 */
    o += '<section class="rlw-scene rlw-s1 is-on" data-scene="1" aria-labelledby="' + uid + '-h1">';
    o += '<header class="rlw-head" data-in><h2 class="rlw-h" id="' + uid + '-h1" tabindex="-1">' + emH(t.s1h) + '</h2><p class="rlw-lead"><span class="d">' + esc(t.s1leadD) + '</span><span class="m">' + esc(t.s1leadM) + '</span></p></header>';
    o += '<div class="rlw-worlds" role="radiogroup" aria-label="' + esc(t.frAria) + '" data-rlw-worlds data-in>' + FR_ORDER.map(function (k, i) {
      return '<button type="button" class="rlw-world" data-w="' + k + '" role="radio" aria-checked="' + (i ? 'false' : 'true') + '" tabindex="' + (i ? '-1' : '0') + '">' +
        '<span class="mot">' + MOTIF[k] + '</span><span class="wm">' + MOTIF[k] + '</span>' +
        '<span><span class="lbl">' + esc(t.fr[k]) + '</span><span class="meta" data-meta="' + k + '">' + esc(t.frMeta[k]) + '</span></span>' +
        '<span class="ok" aria-hidden="true">' + ICON.check + '</span></button>';
    }).join('') + '</div>';
    o += '<div class="rlw-budget" data-in><div class="rlw-numwrap"><label class="rlw-label" for="' + uid + '-bin">' + esc(t.budget) + '</label>' +
      '<div class="rlw-num" data-rlw-num><span class="eur" aria-hidden="true">€</span><input id="' + uid + '-bin" data-rlw-bin type="text" inputmode="numeric" autocomplete="off" value="75" aria-label="' + esc(t.numAria) + '"></div>' +
      '<span class="rlw-measure" data-rlw-measure aria-hidden="true"></span></div>' +
      '<div class="rlw-bside"><div class="rlw-rangew"><input class="rlw-range" data-rlw-range type="range" min="0" max="100" step="1" value="10" aria-label="' + esc(t.rangeAria) + '"><span class="rlw-rtop" data-rlw-rtop>' + esc(t.rtop) + '</span></div>' +
      '<div class="rlw-chips" data-rlw-chips role="group" aria-label="' + esc(t.chipsAria) + '">' + chipsHTML(lang) + '</div><p class="rlw-bhint">' + esc(t.bhint) + '</p></div></div>';
    o += '<footer class="rlw-foot" data-in><p class="hint" data-rlw-s1hint>' + t.s1hint + '</p>' + btnPri('data-rlw-tos2', t.toS2, true) + '</footer>';
    o += '</section>';
    /* STAP 2 */
    o += '<section class="rlw-scene rlw-s2" data-scene="2" aria-labelledby="' + uid + '-h2" inert>';
    o += '<header class="rlw-head" data-in><div><h2 class="rlw-h" id="' + uid + '-h2" tabindex="-1"><span data-rlw-subh="sty">' + emH(t.s2hSty) + '</span><span data-rlw-subh="typ" hidden>' + emH(t.s2hTyp) + '</span></h2></div></header>';
    o += '<div class="rlw-s2body" data-rlw-sub="typ" hidden><div class="rlw-panel" data-in><p class="rlw-label">' + esc(t.typeLbl) + '<span class="rlw-multi"><i class="rlw-cb" aria-hidden="true">' + ICON.check + '</i>' + esc(t.typesHelp) + '</span> <small data-rlw-typeshint>' + esc(t.typesNone) + '</small><span class="rlw-typefix" data-rlw-typefix hidden></span>' + selRowHTML(t) + '</p><div class="rlw-langs" data-rlw-langs role="group" aria-label="' + esc(t.tLang) + '" hidden></div><div class="rlw-types" data-rlw-types role="group" aria-label="' + esc(t.typesAria) + '"></div></div></div>';
    /* Samenstelling (gpt-tasteskill): lijst links, podium rechts */
    o += '<div class="rlw-s2body rlw-cmp" data-rlw-sub="sty"><h2 class="rlw-ctt" id="' + uid + '-h2s" tabindex="-1">' + emH(t.styTt) + '</h2><div class="rlw-cl" data-rlw-styles data-in role="radiogroup" aria-label="' + esc(t.styleAria) + '"><i class="rlw-cind" aria-hidden="true"></i>' + STYLES.map(function (v) {
      return '<button type="button" class="rlw-style" data-style="' + v + '" role="radio" aria-checked="' + (v === 'mix') + '" tabindex="' + (v === 'mix' ? '0' : '-1') + '"' + (v === 'populair' ? ' hidden' : '') + '><span class="ill" aria-hidden="true"></span>' +
        '<span class="tx"><b>' + esc(t.styles[v][0]) + '</b><small>' + esc(t.styles[v][1]) + '</small></span><span class="radio" aria-hidden="true"><i></i></span></button>';
    }).join('') + '</div>' +
      '<div class="rlw-pod" data-rlw-pod data-in aria-hidden="true"><div class="pl"></div><div class="dm"></div><div class="sp"></div><div class="dc"></div><div class="mt"><i></i><i></i><i></i></div>' +
      '<div class="pd p2">2</div><div class="pd p1">1</div><div class="pd p3">3</div><div class="gb"></div><div class="gf"></div><div class="gl"><svg class="bow" viewBox="0 0 64 40"><path d="M32 22C24 6 8 2 6 12s14 12 26 10z" fill="#E8C840"/><path d="M32 22C40 6 56 2 58 12S44 24 32 22z" fill="#E8C840"/><path d="M30 22l-8 16 6-2 4 4zM34 22l8 16-6-2-4 4z" fill="#d4b22a"/><circle cx="32" cy="22" r="5" fill="#f4f0fb" stroke="#d4b22a" stroke-width="2"/></svg></div>' +
      '<div class="spk"><svg viewBox="0 0 24 24"><path d="M12 0c.8 6.4 4.8 10.6 12 12-7.2 1.4-11.2 5.6-12 12-.8-6.4-4.8-10.6-12-12C7.2 10.6 11.2 6.4 12 0z" fill="#E8C840"/></svg></div><div class="spk"><svg viewBox="0 0 24 24"><path d="M12 0c.8 6.4 4.8 10.6 12 12-7.2 1.4-11.2 5.6-12 12-.8-6.4-4.8-10.6-12-12C7.2 10.6 11.2 6.4 12 0z" fill="#7B5EA7"/></svg></div><div class="spk"><svg viewBox="0 0 24 24"><path d="M12 0c.8 6.4 4.8 10.6 12 12-7.2 1.4-11.2 5.6-12 12-.8-6.4-4.8-10.6-12-12C7.2 10.6 11.2 6.4 12 0z" fill="#E8C840"/></svg></div><div class="spk"><svg viewBox="0 0 24 24"><path d="M12 0c.8 6.4 4.8 10.6 12 12-7.2 1.4-11.2 5.6-12 12-.8-6.4-4.8-10.6-12-12C7.2 10.6 11.2 6.4 12 0z" fill="#9c84c9"/></svg></div><div class="ptag"></div><div class="pnm" data-rlw-pnm aria-hidden="true"></div></div><div class="rlw-pnm-m" data-rlw-pnmm aria-hidden="true"></div></div>';
    /* primaire knoppen rechtsonder (eigenaar 10 okt) */
    o += '<footer class="rlw-s2foot" data-in><button type="button" class="rlw-back2" data-rlw-back2>' + ICON.back + '<span>' + esc(t.back) + '</span></button><div class="rlw-subf" data-rlw-subf="sty">' + '<button type="button" class="rlw-any2" data-rlw-any title="' + esc(t.escape[1]) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h3c4 0 6 10 10 10h3"/><path d="M4 17h3c1.6 0 2.8-1.6 4-3.6M13 9.6C14.2 8 15.4 7 17 7h3"/><path d="M18 4l3 3-3 3M18 14l3 3-3 3"/></svg>' + esc(t.escape[0]) + '</button>' + btnPri('data-rlw-tosub', t.next, true) + '</div>' +
      '<div class="rlw-subf" data-rlw-subf="typ" hidden><span class="rlw-minhint" data-rlw-typesmin hidden>' + esc(t.typesMin) + '</span>' + btnPri('data-rlw-compose', t.compose, true) + '</div></footer>';
    o += '</section>';
    /* STAP 3 */
    o += '<section class="rlw-scene rlw-s3" data-scene="3" aria-labelledby="' + uid + '-h3" inert>';
    o += '<header class="rlw-s3head" data-in><div class="rlw-s3t"><h2 class="rlw-h" id="' + uid + '-h3" tabindex="-1">' + emH(t.s3h) + '</h2><p class="rlw-mline" data-rlw-mline></p><p class="rlw-note" data-rlw-note hidden></p></div>' +
      '<div class="rlw-s3tools"><button type="button" class="rlw-tunebtn" data-rlw-tunebtn aria-expanded="false" aria-controls="' + uid + '-tune">' + ICON.tune + '<span data-rlw-tunesum></span></button>' +
      '<button type="button" class="rlw-gnav" data-rlw-gprev aria-label="' + esc(t.gPrev) + '">' + ICON.prev + '</button><span class="rlw-count" data-rlw-gcount aria-live="polite"></span>' +
      '<button type="button" class="rlw-gnav" data-rlw-gnext aria-label="' + esc(t.gNext) + '">' + ICON.next + '</button></div></header>';
    /* bedieningsstrook: elke wijziging stelt de selectie meteen opnieuw samen (desktop een strook, gsm een uitklapbaar blad) */
    o += '<div class="rlw-tunewrap" data-rlw-tunewrap data-in><div class="rlw-tback" data-rlw-tback aria-hidden="true"></div><div class="rlw-tune" id="' + uid + '-tune" role="region" aria-label="' + esc(t.tuneAria) + '">' +
      '<div class="rlw-tsheethead"><b>' + esc(t.tuneAria) + '</b><button type="button" class="rlw-tdone" data-rlw-tdone>' + esc(t.tuneDone) + '</button></div>' +
      '<div class="rlw-tg rlw-tbud"><span class="rlw-tlbl">' + esc(t.tBud) + '</span><label class="rlw-tnum" for="' + uid + '-tin"><span aria-hidden="true">€</span><input id="' + uid + '-tin" data-rlw-tin type="text" inputmode="numeric" autocomplete="off" value="75" aria-label="' + esc(t.numAria) + '"></label>' +
      '<input class="rlw-range rlw-trange" data-rlw-trange type="range" min="0" max="100" step="1" value="10" aria-label="' + esc(t.rangeAria) + '"></div>' +
      '<div class="rlw-tg rlw-tchips" data-rlw-tchips role="group" aria-label="' + esc(t.chipsAria) + '">' + chipsHTML(lang) + '</div><i class="rlw-tsep rlw-tsep--bud" aria-hidden="true"></i>' +
      '<div class="rlw-tg"><span class="rlw-tlbl" id="' + uid + '-tfrl">' + esc(t.tFr) + '</span><div class="rlw-tgrp rlw-tfr" data-rlw-tfr role="radiogroup" aria-labelledby="' + uid + '-tfrl">' + FR_ORDER.map(function (k) {
        return '<button type="button" class="rlw-tf" data-w="' + k + '" role="radio" aria-checked="false" tabindex="-1" title="' + esc(t.fr[k]) + '" aria-label="' + esc(t.fr[k]) + '">' + MOTIF[k] + '<span class="t">' + esc(t.fr[k]) + '</span></button>';
      }).join('') + '</div></div><i class="rlw-tsep" aria-hidden="true"></i>' +
      /* samenstelling in de strook (10 okt): een menu zoals Soort, met de acht keuzes (klein fotootje, titel, ondertitel) */
      '<div class="rlw-tg rlw-tstyw"><span class="rlw-tlbl rlw-tlbl-m">' + esc(t.tSty) + '</span><button type="button" class="rlw-ttbtn rlw-tsbtn" data-rlw-tsbtn aria-expanded="false" aria-controls="' + uid + '-tspop">' + esc(t.tSty) + ': <b data-rlw-tssum>' + esc(t.sty.mix) + '</b>' + ICON.chev + '</button>' +
      '<div class="rlw-tpop rlw-tspop" id="' + uid + '-tspop" data-rlw-tspop><div class="rlw-tpsc"><div class="rlw-tsty" data-rlw-tsty role="radiogroup" aria-label="' + esc(t.styleAria) + '">' + STYLES.map(function (v) {
        return '<button type="button" class="rlw-ts rlw-tso" data-ts="' + v + '" role="radio" aria-checked="false" tabindex="-1"' + (v === 'populair' ? ' hidden' : '') + '><span class="ph" aria-hidden="true">' + (STYLE_ILL[v] || STYLE_ILL.mix) + '</span>' +
          '<span class="tx"><span class="nm">' + esc(t.styles[v][0]) + '</span><small>' + esc(t.styles[v][1]) + '</small></span><span class="radio" aria-hidden="true"></span></button>';
      }).join('') + '</div></div></div></div><i class="rlw-tsep" aria-hidden="true"></i>' +
      '<div class="rlw-tg rlw-tlang" data-rlw-langw hidden><span class="rlw-tlbl">' + esc(t.tLang) + '</span><div class="rlw-langs" data-rlw-langs role="group" aria-label="' + esc(t.tLang) + '"></div></div>' +
      '<div class="rlw-tg rlw-ttyp"><button type="button" class="rlw-ttbtn" data-rlw-ttbtn aria-expanded="false" aria-controls="' + uid + '-tpop">' + esc(t.tTyp) + '<b data-rlw-ttsum>' + esc(t.tAll) + '</b>' + ICON.chev + '</button><div class="rlw-tpop" id="' + uid + '-tpop" data-rlw-tpop role="group" aria-label="' + esc(t.typesAria) + '"></div></div>' +
      '</div></div>';
    /* scrollcontainer van stap 3 (root van de 3D-pool): het raster, daaronder de hint en de topkaarten uit je sets */
    o += '<div class="rlw-scr" data-rlw-scr data-cws-stack><div class="rlw-body" data-rlw-body aria-label="' + esc(t.bodyAria) + '"></div>' +
      '<div class="rlw-tkhintw" data-rlw-tkhintw hidden><button type="button" class="rlw-tkhint rlw-teaser" data-rlw-tkhint aria-label="' + esc(t.tkTeaser) + '">' +
      '<span class="fan" data-rlw-tkfan aria-hidden="true"></span><span class="tx"><b>' + esc(t.tkTeaser) + '</b><small data-rlw-tkupto></small></span>' +
      '<span class="ar"><svg ' + SV + ' stroke-width="2"><path d="M12 5v14M6 13l6 6 6-6"/></svg></span></button></div>' +
      '<section class="rlw-tk" data-rlw-tk aria-labelledby="' + uid + '-tkh" hidden><header class="rlw-tkhead"><h3 id="' + uid + '-tkh">' + esc(t.tkTitle) + '</h3><p>' + esc(t.tkSub) + '</p></header>' +
      '<div class="rlw-tkrows" data-rlw-tkrows></div><p class="rlw-tkmiss" data-rlw-tkmiss hidden></p><p class="rlw-tksrc" data-rlw-tksrc></p></section></div>';
    /* Voeg iets toe (10 okt): een grote pop-up in de stijl van de Shop-tab (tegels, zoeken, filters franchise, soort en taal,
       sortering); bij het monteren verhuist hij naar body, zodat hij boven de header en het kader ligt */
    o += '<div class="rlw-addwrap rlw-modal" data-rlw-addwrap hidden><div class="rlw-addback" data-rlw-addback></div><div class="rlw-add" id="' + uid + '-add" role="dialog" aria-modal="true" aria-labelledby="' + uid + '-addh">' +
      '<header class="rlw-addhead"><div class="ttl"><h3 id="' + uid + '-addh">' + esc(t.addBtn) + '</h3><p>' + esc(t.addSub) + '</p></div>' +
      '<div class="rlw-addbud"><span class="b" data-rlw-addbud></span><span class="rlw-addleft" data-rlw-addleft></span>' +
      '<label class="rlw-addmore"><input type="checkbox" data-rlw-addmore><span>' + esc(t.addMore) + '</span></label></div>' +
      '<button type="button" class="rlw-addx" data-rlw-addx aria-label="' + esc(t.addClose) + '">' + ICON.x + '</button></header>' +
      '<div class="rlw-addtools"><input class="rlw-addq" data-rlw-addq type="search" autocomplete="off" placeholder="' + esc(t.addSearch) + '" aria-label="' + esc(t.addSearch) + '">' +
      '<label class="rlw-addsort"><span>' + esc(t.sortLbl) + '</span><select data-rlw-addsort><option value="rec">' + esc(t.sortRec) + '</option><option value="asc">' + esc(t.sortAsc) + '</option><option value="desc">' + esc(t.sortDesc) + '</option></select></label></div>' +
      '<div class="rlw-addfil"><div class="rlw-addfr" data-rlw-addfr role="group" aria-label="' + esc(t.addFrAria) + '"></div>' +
      '<div class="rlw-addchips" data-rlw-addchips role="group" aria-label="' + esc(t.typesAria) + '"></div>' +
      '<div class="rlw-langs" data-rlw-alangs role="group" aria-label="' + esc(t.tLang) + '" hidden></div></div>' +
      '<div class="rlw-addgrid" data-rlw-addlist role="list"></div></div></div>';
    /* voetbalk (eigenaar 10 okt): Terug links, in het midden een horizontale budgetmeter met op een lijn het totaal, "van
       € X" en rechts "nog € Y", de drie knoppen rechts */
    o += '<footer class="rlw-s3foot" data-in><button type="button" class="rlw-back2" data-rlw-back2>' + ICON.back + '<span>' + esc(t.back) + '</span></button>' +
      '<div class="rlw-meter" aria-live="polite"><div class="rlw-mline1"><span class="rlw-tot" data-rlw-tot>' + eurL(0, lang) + '</span><span class="rlw-of" data-rlw-of>' + esc(t.ofB(eurIntL(75, lang))) + '</span><span class="rlw-left" data-rlw-left></span></div>' +
      '<div class="rlw-mbar" aria-hidden="true"><i data-rlw-mfill></i></div></div>' +
      '<div class="rlw-acts"><button type="button" class="rlw-btn rlw-btn--sec rlw-addbtn" data-rlw-addbtn aria-haspopup="dialog" aria-expanded="false" aria-controls="' + uid + '-add" aria-label="' + esc(t.addBtn) + '">' + ICON.plus + '<span class="t">' + esc(t.addBtn) + '</span></button>' +
      '<button type="button" class="rlw-btn rlw-btn--sec" data-rlw-reroll aria-label="' + esc(t.reroll) + '">' + ICON.reroll + '<span class="t">' + esc(t.reroll) + '</span></button>' +
      '<button type="button" class="rlw-btn rlw-btn--pri" data-rlw-tocart data-cws-addmany>' + ICON.cart + esc(t.toCart) + '</button></div></footer>';
    o += '</section>';
    /* STAP 4 (bevestiging) */
    o += '<section class="rlw-scene rlw-s4" data-scene="4" aria-labelledby="' + uid + '-h4" inert><div class="rlw-done"><figure class="gift" data-in aria-hidden="true">' + giftSVG(uid + 'd', false) + '</figure>' +
      '<div><h2 class="rlw-h" id="' + uid + '-h4" tabindex="-1" data-in>' + emH(t.s4h) + '</h2><p class="rlw-dline" data-rlw-dline data-in></p><div class="rlw-thumbs" data-rlw-thumbs data-in></div>' +
      '<div class="rlw-dacts" data-in>' + btnPri('data-rlw-seecart', t.seeCart, true) + '<button type="button" class="rlw-btn rlw-btn--sec" data-rlw-again>' + ICON.spark + esc(t.again) + '</button>' +
      '<button type="button" class="rlw-link" data-rlw-undo>' + esc(t.undo) + '</button></div></div></div></section>';
    /* onthulling: vaste pool van vijf kaartjes en een ring */
    o += '<div class="rlw-shuffle" data-rlw-shuffle aria-hidden="true"><i class="rlw-ring"></i>' + new Array(6).join('<span class="rlw-scard"></span>') + '</div>';
    o += '</main></div>';
    o += '<p class="rlw-sr" data-rlw-live aria-live="polite"></p>';
    o += '</div>';
    return o;
  }

  /* ================= mount ================= */
  var STATES = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function findRoot(root) {
    if (!root) return null;
    if (root.classList && root.classList.contains('rlw')) return root;
    return root.querySelector ? root.querySelector('.rlw') : null;
  }
  function setState(el, s) { if (STATES) STATES.set(el, s); else el.__rlwState = s; }
  function getState(el) { return STATES ? STATES.get(el) : el.__rlwState; }
  var MIN = 10, MAX = BUDGET_MAX, NARROW = 760, FIT_GAP = 28;
  /* schuifstappen: 10 tot 95 per 5, tot 475 per 25, tot 1900 per 100, tot SLIDER_MAX per 250; daarboven typ je gewoon */
  var STEPS = (function () { var a = []; for (var v = 10; v < 100; v += 5) a.push(v); for (v = 100; v < 500; v += 25) a.push(v); for (v = 500; v < 2000; v += 100) a.push(v); for (v = 2000; v <= SLIDER_MAX; v += 250) a.push(v); return a; })();
  function nearestIdx(v) { var b = 0; for (var i = 0; i < STEPS.length; i++) if (Math.abs(STEPS[i] - v) < Math.abs(STEPS[b] - v)) b = i; return b; }

  function mount(root, ctx) {
    var el = findRoot(root); if (!el) return;
    var lang = ctx.lang || 'nl', t = strFor(lang), RM = prefersReduced();
    if (RM) el.classList.add('rlw-rm');
    var host = el.parentNode; if (host && host.classList) host.classList.add('rlw-host');
    var all = (ctx.products || []).filter(function (p) { return p && p.handle && p.price > 0 && p.av !== false && p.type !== 'acc'; });
    var byH = {}; all.forEach(function (p) { byH[p.handle] = p; });
    var S = {
      ctx: ctx, t: t, el: el, RM: RM, lang: lang, uid: el.getAttribute('data-uid') || 'rlw', host: host, all: all,
      byH: byH, eur: function (n) { return eurL(n, lang); }, eurInt: function (n) { return eurIntL(n, lang); },
      step: 1, sub: 'sty', typesAuto: false, noneSel: false, fr: 'all', tl: '', budget: 75, types: [], style: 'mix', seed: 1, items: [], total: 0, fallback: false, cheapest: null,
      composed: false, dirty: false, busy: false, shown: { key: '', sigs: {}, anchors: {} }, confirmed: null, shownTotal: 0,
      mode: null, timers: [], intervals: [], offs: [], stl: null, wtl: null, gtl: null, hintGone: false,
      ctls: new Map(), attQ: [], attT: 0, rcT: 0, hintT: 0
    };
    setState(el, S);
    function on(target, ev, fn, opt) { if (!target) return; target.addEventListener(ev, fn, opt); S.offs.push(function () { target.removeEventListener(ev, fn, opt); }); }
    S.on = on;
    S.addWrap = qs('[data-rlw-addwrap]', el); if (S.addWrap) document.body.appendChild(S.addWrap);
    S.scenes = qsa('.rlw-scene', el); S.selScene = S.scenes[2]; S.body = qs('[data-rlw-body]', el); S.scr = qs('[data-rlw-scr]', el);
    S.bIn = qs('[data-rlw-bin]', el); S.range = qs('[data-rlw-range]', el); S.numEl = qs('[data-rlw-num]', el); S.measure = qs('[data-rlw-measure]', el);
    S.range.max = String(STEPS.length - 1); qs('[data-rlw-trange]', el).max = String(STEPS.length - 1);

    popLoad(S); relLoad(S);
    wirePod(S);
    wireHover3D(S); wireTop(S); wireSpop(S); wirePage(S); wireBudget(S); wireWorlds(S); wireTypes(S); wireStyles(S); wireNav(S); wireTune(S); wireSelection(S); wireAdd(S); wireCart(S); wireKeys(S); wireSway(S);
    fillWorldMeta(S); renderTypes(S); renderStyles(S); renderBudget(S, 'init'); updateBar(S); renderSummary(S); renderTune(S);
    checkMode(S, true); fitFrame(S);
    if (window.ResizeObserver) {
      S.ro = new ResizeObserver(function () {
        if (S.roRaf) return;
        S.roRaf = requestAnimationFrame(function () {
          S.roRaf = 0; if (!getState(el)) return;
          fitFrame(S); checkMode(S); sizeInput(S); sceneH(S); if (S.step === 3) layoutGrid(S); refitAll(S); refitThumbs(S); pipClear(S);
        });
      });
      S.ro.observe(el); if (host) S.ro.observe(host); S.ro.observe(S.body);
      var scIn = host && host.parentNode; if (scIn && scIn.nodeType === 1) S.ro.observe(scIn);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (getState(el)) sizeInput(S); });
    /* Clean-kader volgen (de Clean-laag wisselt zijn klassen zonder event) en de 3D-wieglus levend houden */
    S.intervals.push(setInterval(function () { if (!document.hidden) { fitFrame(S); swayStart(S); } }, 500));
    S.intervals.push(setInterval(function () { if (!document.hidden && S.mode === 'm') pipClear(S); }, 1500));
    on(window, 'resize', function () { fitFrame(S); });
    wireTabSwitch(S);
    pipClear(S);
  }
  function isShown(S) { var r = S.el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight; }
  function live(S, msg) { var l = qs('[data-rlw-live]', S.el); if (!l) return; l.textContent = ''; setTimeout(function () { if (getState(S.el)) l.textContent = msg; }, 30); }

  /* desktop (kader breed genoeg) of gsm-indeling; de hoogte van de houder expliciet op het kader (cq-eenheden en 100%) */
  function checkMode(S, first) {
    var host = S.host, hh = host && host.clientHeight;
    var hv = hh > 120 ? hh + 'px' : '';
    if (S.el.style.getPropertyValue('--rlw-h') !== hv) { if (hv) S.el.style.setProperty('--rlw-h', hv); else S.el.style.removeProperty('--rlw-h'); }
    var m = S.el.clientWidth && S.el.clientWidth < NARROW ? 'm' : 'd';
    if (m === S.mode) return;
    S.mode = m;
    S.el.classList.toggle('rlw-m', m === 'm');
    if (first) return;
    setSheet(S, false); setPop(S, false);
    if (S.step === 3) { layoutGrid(S); updateNav(S); }
  }

  /* ---------------- zelfde kader als Shop (desktop, Clean-laag, Rip Lab): letterlijk de aanpak van rip-lab-i2c ----------------
     De houder (.rlw-fit) ligt op de geometrie van de filterkaart van Shop (#gCard) met dezelfde rand, radius en schaduw; het
     Clean-kader zelf is dan onzichtbaar (html.rlw-fitd). Enkel als Clean het kader toont (.cl-labframe zichtbaar). */
  var FIT_VARS = ['--rlw-fl', '--rlw-ft', '--rlw-fw', '--rlw-fh'], LOOK_VARS = ['--rlw-fr', '--rlw-fb', '--rlw-fc', '--rlw-fs'];
  var SHOP = null, PROBE = null;
  function unfit(host) {
    try { document.documentElement.classList.remove('rlw-fitd'); } catch (e) { /* negeren */ }
    if (!host || !host.classList || !host.classList.contains('rlw-fit')) return;
    host.classList.remove('rlw-fit', 'rlw-page');
    FIT_VARS.concat(LOOK_VARS).forEach(function (v) { host.style.removeProperty(v); });
  }
  function px(v) { return parseFloat(v) || 0; }
  function htmlCls() { return String(document.documentElement.className || '').split(/\s+/).filter(function (c) { return c && c !== 'rlw-fitd'; }).sort().join(' '); }
  function cardLook(card) {
    var cs = card ? getComputedStyle(card) : null;
    return cs ? { bw: px(cs.borderTopWidth), bc: cs.borderTopColor, rad: px(cs.borderTopLeftRadius), sh: cs.boxShadow || 'none' } : { bw: 1, bc: 'rgba(123,94,167,.16)', rad: 18, sh: 'none' };
  }
  function measureShop() {
    var b = document.body;
    if (!b || !b.classList.contains('mode-grid')) return;
    var gv = document.getElementById('grid'), sc = document.getElementById('gScroll'), card = document.getElementById('gCard');
    if (!gv || !sc || !card) return;
    var Gr = gv.getBoundingClientRect(), r = card.getBoundingClientRect();
    if (r.width < 200 || Gr.width < 200) return;
    SHOP = { l: r.left - Gr.left, r: Gr.right - r.right, t: r.top + sc.scrollTop, look: cardLook(card), w: innerWidth, h: innerHeight, cls: htmlCls() };
  }
  function probe() {
    if (!PROBE || !PROBE.isConnected) {
      PROBE = document.createElement('div');
      PROBE.setAttribute('aria-hidden', 'true');
      PROBE.style.cssText = 'position:fixed;left:0;top:0;width:60px;height:60px;overflow-y:scroll;scrollbar-width:thin;visibility:hidden;pointer-events:none;z-index:-1;margin-top:calc(var(--col-t, 70px) + 0px)';
      document.body.appendChild(PROBE);
    }
    return { colT: px(getComputedStyle(PROBE).marginTop), sb: Math.max(0, PROBE.offsetWidth - PROBE.clientWidth) };
  }
  function shopRect() {
    var gv = document.getElementById('grid'), sc = document.getElementById('gScroll'), card = document.getElementById('gCard');
    var de = document.documentElement, W = de.clientWidth, H = de.clientHeight;
    var gs = gv ? getComputedStyle(gv) : null, ss = sc ? getComputedStyle(sc) : null;
    var gl = gs ? px(gs.left) : 0, gr = gs ? px(gs.right) : 0, gb = gs ? px(gs.bottom) : 0;
    var padB = ss ? px(ss.paddingBottom) : 28;
    var l, r, tp, look;
    var ok = SHOP && SHOP.w === innerWidth && SHOP.h === innerHeight && SHOP.cls === htmlCls();
    if (ok) { l = SHOP.l; r = SHOP.r; tp = SHOP.t; look = SHOP.look; }
    else {
      var pr = probe(), cm = card ? getComputedStyle(card) : null;
      l = (ss ? px(ss.paddingLeft) : 22) + (cm ? px(cm.marginLeft) : 0);
      r = (ss ? px(ss.paddingRight) : 22) + (cm ? px(cm.marginRight) : 0) + pr.sb;
      tp = pr.colT + 62 + (document.body.classList.contains('cl-mx') ? px(getComputedStyle(document.body).getPropertyValue('--mx')) : 0);
      look = cardLook(card);
    }
    return { left: gl + l, right: W - gr - r, top: tp, bottom: H - gb - padB, look: look };
  }
  /* ---------------- paginamodus van stap 3 (eigenaar 9 okt: "ik wil echt volledig naar onder kunnen scrollen") ----------------
     De feed zelf is vergrendeld in Rip Lab (de Clean-laag zet #feed op overflow hidden en de scene terug op haar plek), dus
     de pagina kan daar niet scrollen. In stap 3 (desktop, Clean-kader) wordt de houder daarom de scrollzone van de
     middenkolom, zoals #gScroll in Shop: hij loopt van de bovenrand van het kader tot onderaan het venster, het kader groeit
     mee met de inhoud (raster, pil, topkaarten) en de voetbalk blijft sticky onderaan. Enkel met de klassen rlw-page
     (houder) en rlw-pg (component), die bij een stapwissel, buiten Rip Lab en bij unmount weggaan; de start-scene, i2c en de
     Clean-laag merken er niets van. Het raster krijgt in die modus de hoogte van het eerste scherm min een strook waarin de
     topkaarten al uitpiepen. */
  /* (10 okt) echte paginascroll: de wizard zet in stap 3 (desktop, Clean-kader) html.rlw-pagescroll. De Clean-laag laat de
     feed dan scrollen (zie CLEAN-PATCH-rlw-pagescroll.md: geen overflow hidden op #feed, geen terugzetten van de scene),
     de wizard-css zet de scroll-snap van de feed uit, verbergt de andere scenes (zoals Clean dat zelf doet in Jouw feed)
     en laat de Rip Lab-scene meegroeien met de inhoud (--rlw-sceneh). Strook sticky bovenaan onder de header, voetbalk
     sticky onderaan het venster. Weg bij een stapwissel, buiten Rip Lab en bij unmount: de feed staat dan terug op de scene. */
  function feedOf() { return document.getElementById('feed'); }
  function pageWant(S) { return S.step === 3 && !S.trans3 && S.mode === 'd' && !!S.host && S.host.classList.contains('rlw-fit'); }
  function pageSync(S) {
    var want = pageWant(S), host = S.host, de = document.documentElement;
    if (!want) { if (S.pg) pageOff(S); return; }
    var fh = parseFloat(host.style.getPropertyValue('--rlw-fh')) || 0;
    if (S.pg && Math.abs(fh - (S.pgFh || 0)) < 4) { sceneH(S); return; }
    var was = S.pg;
    if (S.pg) { de.classList.remove('rlw-pagescroll'); host.classList.remove('rlw-page'); S.el.classList.remove('rlw-pg'); S.body.style.removeProperty('height'); }
    /* in de gewone indeling meten: alles behalve de scrollzone (stappenbalk, kop, strook, voetbalk) */
    S.bhOff = Math.max(0, S.el.clientHeight - (S.scr ? S.scr.clientHeight : 0));
    var ft = qs('.rlw-s3foot', S.el); S.el.style.setProperty('--rlw-footh', (ft ? ft.offsetHeight : 80) + 'px');
    S.pgFh = fh || S.el.clientHeight; S.pg = true;
    de.classList.add('rlw-pagescroll'); host.classList.add('rlw-page'); S.el.classList.add('rlw-pg');
    layoutGrid(S); refitAll(S); sceneH(S);
    if (!was) { var f = feedOf(); if (f) f.scrollTop = 0; pxReset(S); }
    catsShift(S);
  }
  function pageOff(S) {
    if (!S.pg) return;
    S.pg = false;
    var de = document.documentElement;
    de.classList.remove('rlw-pagescroll'); de.style.removeProperty('--rlw-sceneh');
    if (S.host) S.host.classList.remove('rlw-page');
    S.el.classList.remove('rlw-pg', 'rlw-cue-off'); S.body.style.removeProperty('height');
    pxClear(S); catsShift(S);
    /* de feed terug op de Rip Lab-scene (de andere scenes staan weer in de feed) */
    var f = feedOf(), sc = S.host && S.host.closest ? S.host.closest('.scene') : null;
    if (f && sc && document.body.classList.contains('cl-lab')) f.scrollTop = sc.offsetTop;
  }
  /* hoogte van de Rip Lab-scene in paginascroll: bovenrand van het kader plus de hoogte van de wizard plus lucht */
  function sceneH(S) {
    if (!S.pg || !S.host) return;
    var top = parseFloat(S.host.style.getPropertyValue('--rlw-ft')) || 0, h = Math.ceil(top + S.el.offsetHeight + 28);
    var v = Math.max(window.innerHeight, h) + 'px', de = document.documentElement;
    if (de.style.getPropertyValue('--rlw-sceneh') !== v) de.style.setProperty('--rlw-sceneh', v);
  }
  /* rasterhoogte in de paginascroll: het eerste scherm min alles buiten de scrollzone. Geen aftrek voor de teaser (eigenaar
     10 okt): de producten staan altijd op volle grootte, de teaser volgt in de stroom eronder en verschijnt bij het scrollen */
  function pageBodyH(S) {
    return Math.max(240, Math.round((S.pgFh || 0) - (S.bhOff || 0)));
  }
  /* ---------------- rustige parallax tijdens de paginascroll (enkel transform, via rAF; reduced motion: statisch) ----------------
     productkaarten schuiven licht tegen het scrollen in (per rij een andere snelheid, hoogstens 34 px), de achtergrond-
     patronen bewegen trager dan de inhoud; de topkaartrijen komen gespreid binnen (IntersectionObserver, css). Het
     scrollsignaal stopt met wiebelen bij de eerste scroll en verdwijnt zodra de sectie in beeld is. */
  var PX_MAX = 34;
  function pxOnScroll(S) {
    if (!S.pg) return;
    if (!S.scrolled) { S.scrolled = true; S.el.classList.add('rlw-scrolled'); }
    if (S.RM || S.pxRaf) return;
    S.pxRaf = requestAnimationFrame(function () { S.pxRaf = 0; pxFrame(S); });
  }
  function pxFrame(S) {
    if (!S.pg || !getState(S.el)) return;
    var f = feedOf(), y = f ? f.scrollTop : 0, H = window.innerHeight;
    var bg = qs('.rlw-bg', S.el); if (bg) bg.style.transform = 'translate3d(0,' + (y * .35).toFixed(1) + 'px,0)';
    var cards = qsa('.rlw-card', S.body), rects = cards.map(function (c) { return c.getBoundingClientRect(); }), rowY = null, row = -1;
    rects.forEach(function (r, i) {
      if (rowY === null || Math.abs(r.top - rowY) > 8) { row++; rowY = r.top; }
      var k = clamp(((r.top + r.height / 2) - H / 2) / H, -1, 1), sp = PX_MAX * (.55 + (row % 3) * .22);
      cards[i].style.translate = '0 ' + (k * sp * .5).toFixed(1) + 'px';
    });
  }
  /* begroetingsrij met de tabs (.cats van de pagina, met de Clean-balk erin; vast boven de feed) scrolt in paginascroll mee
     uit beeld: translateY volgt het scrollen tot de rij volledig onder de donkere header zit (die heeft een hogere z-index);
     terug naar boven of buiten de paginascroll staat ze weer op haar plek. Geen wijziging aan Clean nodig. */
  function catsSoon(S) {
    if (S.catsRaf) return;
    S.catsRaf = requestAnimationFrame(function () { S.catsRaf = 0; catsShift(S); });
  }
  function catsShift(S) {
    var c = document.querySelector('.cats'); if (!c) return;
    if (!S.pg || !getState(S.el)) { if (c.style.transform) c.style.removeProperty('transform'); return; }
    var f = feedOf(), y = f ? Math.max(0, f.scrollTop) : 0, d = Math.min(y, c.offsetHeight + 24);
    var v = d > 0 ? 'translate3d(0,' + (-d).toFixed(1) + 'px,0)' : '';
    if (c.style.transform !== v) { if (v) c.style.transform = v; else c.style.removeProperty('transform'); }
  }
  function pxReset(S) { S.scrolled = false; S.el.classList.remove('rlw-scrolled'); pxFrame(S); }
  function pxClear(S) {
    var bg = qs('.rlw-bg', S.el); if (bg) bg.style.transform = '';
    qsa('.rlw-card', S.el).forEach(function (c) { c.style.translate = ''; });
  }
  function wirePage(S) {
    var f = feedOf(); if (f) S.on(f, 'scroll', function () { pxOnScroll(S); catsSoon(S); }, { passive: true });
    /* pijltjes, Page Down en spatie scrollen in paginascroll de feed zelf (anders springt de pagina naar een verborgen scene) */
    S.on(document, 'keydown', function (e) {
      if (!S.pg || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var tg = e.target, tag = (tg && tg.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag) || (tg && tg.isContentEditable)) return;
      var H = window.innerHeight, d = { ArrowDown: 80, ArrowUp: -80, PageDown: H * .85, PageUp: -H * .85, ' ': H * .85, Home: -1e7, End: 1e7 }[e.key];
      if (d == null || (e.key === ' ' && tg && tg.closest && tg.closest('button,[role="button"],a'))) return;
      var fd = feedOf(); if (!fd) return;
      e.preventDefault(); e.stopPropagation();
      fd.scrollBy({ top: e.shiftKey && e.key === ' ' ? -d : d, behavior: S.RM ? 'auto' : 'smooth' });
    }, true);
    /* topkaartrijen gespreid binnen, scrollsignaal weg zodra de sectie in beeld is */
    if (window.IntersectionObserver) {
      S.rowIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); S.rowIO.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      var sec = qs('[data-rlw-tk]', S.el);
      if (sec) { S.cueIO = new IntersectionObserver(function (es) { S.el.classList.toggle('rlw-cue-off', es[0].isIntersecting); }, { threshold: .02 }); S.cueIO.observe(sec); }
    }
  }
  function watchRows(S) {
    qsa('.rlw-tkrow', S.el).forEach(function (r, i) {
      r.style.transitionDelay = (Math.min(i, 4) * 60) + 'ms';
      if (S.rowIO && !S.RM) S.rowIO.observe(r); else r.classList.add('is-in');
    });
  }
  function fitFrame(S) {
    fitFrame0(S);
    pageSync(S);
  }
  function fitFrame0(S) {
    var host = S.host, b = document.body;
    if (!host || !host.classList || !b) return;
    measureShop();
    var fr = b.classList.contains('cl-lab') && !b.classList.contains('cl-off') && !b.classList.contains('mode-grid') ? document.querySelector('.cl-labframe') : null;
    var cs = fr ? getComputedStyle(fr) : null, F = fr ? fr.getBoundingClientRect() : null;
    var scene = host.closest ? host.closest('.scene') : null, feed = scene && scene.parentNode;
    if (!fr || cs.display === 'none' || F.width < 200 || F.height < 200 || !feed || !feed.getBoundingClientRect) { unfit(host); return; }
    var T = shopRect();
    if (T.right - T.left < 200 || T.bottom - T.top < 200) { unfit(host); return; }
    if (!host.classList.contains('rlw-fit')) host.classList.add('rlw-fit');
    document.documentElement.classList.add('rlw-fitd');
    var op = host.offsetParent || scene, P = op.getBoundingClientRect(), Fd = feed.getBoundingClientRect();
    var Sr = scene ? scene.getBoundingClientRect() : P, fTop = Fd.top + feed.clientTop;
    var opTop = Math.abs(Sr.top - fTop) < 2 ? P.top - fTop : P.top - Sr.top;
    var vals = [T.left - P.left - op.clientLeft, T.top - fTop - opTop - op.clientTop, T.right - T.left, T.bottom - T.top]
      .map(function (x) { return Math.round(x * 10) / 10 + 'px'; });
    var lk = T.look, look = [lk.rad + 'px', lk.bw + 'px', lk.bc, lk.sh];
    FIT_VARS.forEach(function (v, i) { if (host.style.getPropertyValue(v) !== vals[i]) host.style.setProperty(v, vals[i]); });
    /* strook in paginascroll: sticky net onder de bovenrand van het kader (onder de header en de tabs) */
    var stick = Math.round(T.top + 10) + 'px'; if (S.el.style.getPropertyValue('--rlw-stick') !== stick) S.el.style.setProperty('--rlw-stick', stick);
    LOOK_VARS.forEach(function (v, i) { if (host.style.getPropertyValue(v) !== look[i]) host.style.setProperty(v, look[i]); });
  }
  /* intrede bij het binnenkomen van de tab Rip Lab: de MutationObserver leest enkel de klassen van body, schrijft niets terug */
  function inLab() { var b = document.body; return !!b && b.classList.contains('cl-lab') && !b.classList.contains('mode-grid') && !b.classList.contains('cl-off'); }
  function enter(S) {
    if (S.RM) return;
    var el = S.el;
    el.classList.remove('rlw-enter'); void el.offsetWidth; el.classList.add('rlw-enter');
    clearTimeout(S.enterT);
    S.enterT = setTimeout(function () { el.classList.remove('rlw-enter'); }, 800);
  }
  function wireTabSwitch(S) {
    var was = inLab();
    var check = function () {
      if (!getState(S.el)) return;
      var now = inLab(); if (now === was) return;
      was = now; fitFrame(S);
      if (now) { enter(S); if (S.step === 3) layoutGrid(S); }
      else { setAdd(S, false); setPop(S, false); setSheet(S, false); } /* Rip Lab verlaten: geen open lagen achterlaten */
    };
    if (window.MutationObserver && document.body) {
      S.mo = new MutationObserver(check);
      S.mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    S.on(window, 'hashchange', function () { requestAnimationFrame(check); });
  }
  /* gsm: de PiP van de pagina (rechtsboven) mag de stappenbalk niet bedekken */
  function pipClear(S) {
    var el = S.el, pip = document.getElementById('pip'), w = 0;
    if (S.mode === 'm' && pip) {
      var pr = pip.getBoundingClientRect(), er = el.getBoundingClientRect(), cs = getComputedStyle(pip);
      var vis = pr.width > 0 && pr.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && !pip.hidden;
      if (vis && pr.bottom > er.top && pr.top < er.top + 70 && pr.left < er.right) w = Math.max(0, Math.round(er.right - pr.left + 8));
    }
    var v = w + 'px';
    if (el.style.getPropertyValue('--rlw-pip-w') !== v) el.style.setProperty('--rlw-pip-w', v);
  }

  /* ---------------- budget ---------------- */
  function sizeInput(S) {
    var ms = S.measure, inp = S.bIn; if (!ms || !inp) return;
    ms.style.fontSize = getComputedStyle(S.numEl).fontSize; ms.textContent = inp.value || '0';
    inp.style.width = Math.max(ms.getBoundingClientRect().width + 4, 20) + 'px';
    var tIn = qs('[data-rlw-tin]', S.el); if (tIn) tIn.style.width = (Math.max(2, String(tIn.value).length) + .4) + 'ch';
  }
  function renderBudget(S, src) {
    var el = S.el, b = S.budget, lang = S.lang;
    if (src !== 'input') S.bIn.value = fmtInt(b, lang);
    if (src !== 'range') S.range.value = String(nearestIdx(b));
    S.range.style.setProperty('--p', (b >= SLIDER_MAX ? 100 : (+S.range.value / (STEPS.length - 1)) * 100) + '%');
    qs('[data-rlw-rtop]', el).classList.toggle('is-on', b >= SLIDER_MAX);
    S.range.setAttribute('aria-valuetext', S.eurInt(b));
    qsa('.rlw-chip', el).forEach(function (c) { c.setAttribute('aria-pressed', String(+c.getAttribute('data-v') === b)); });
    paintOf(S);
    var tIn = qs('[data-rlw-tin]', el), tR = qs('[data-rlw-trange]', el);
    if (src !== 'tinput') tIn.value = String(b);
    if (src !== 'trange') tR.value = String(nearestIdx(b));
    var pin = qs('[data-rlw-pin]', el), pR = qs('[data-rlw-prange]', el);
    if (pin && src !== 'pinput') pin.value = String(b);
    if (pR) { if (src !== 'prange') pR.value = String(nearestIdx(b)); pR.style.setProperty('--p', (b >= SLIDER_MAX ? 100 : (+pR.value / (STEPS.length - 1)) * 100) + '%'); }
    tR.style.setProperty('--p', (b >= SLIDER_MAX ? 100 : (+tR.value / (STEPS.length - 1)) * 100) + '%');
    tR.setAttribute('aria-valuetext', S.eurInt(b));
    sizeInput(S);
    renderSummary(S); renderTune(S);
  }
  function setBudget(S, v, src) {
    v = Math.max(MIN, Math.min(MAX, Math.round(+v || 0)));
    if (!isFinite(v)) return;
    var diff = v !== S.budget;
    S.budget = v;
    if (diff) changed(S);
    renderBudget(S, src);
    renderTypes(S);
    var g = G();
    if (g && !S.RM && src === 'chip') g.fromTo(S.numEl, { scale: .94 }, { scale: 1, duration: .45, ease: 'back.out(3)', clearProps: 'transform' });
  }
  function digitsOf(s) { return String(s || '').replace(/[^0-9]/g, '').slice(0, 7); }
  function wireBudget(S) {
    var on = S.on, el = S.el, bIn = S.bIn, range = S.range;
    on(range, 'input', function () { setBudget(S, STEPS[+range.value], 'range'); });
    on(qs('[data-rlw-chips]', el), 'click', function (e) { var b = e.target.closest('.rlw-chip'); if (b) setBudget(S, +b.getAttribute('data-v'), 'chip'); });
    on(bIn, 'input', function () { var d = digitsOf(bIn.value); bIn.value = d; sizeInput(S); if (d && +d >= MIN) setBudget(S, +d, 'input'); });
    on(bIn, 'focus', function () { bIn.value = String(S.budget); sizeInput(S); try { bIn.select(); } catch (e) { /* negeren */ } });
    on(bIn, 'blur', function () { setBudget(S, +digitsOf(bIn.value) || S.budget, 'blur'); });
    on(bIn, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); bIn.blur(); } });
    on(S.numEl, 'click', function () { bIn.focus(); });
    /* de strook op de resultaatpagina */
    var tIn = qs('[data-rlw-tin]', el), tR = qs('[data-rlw-trange]', el);
    on(tR, 'input', function () { setBudget(S, STEPS[+tR.value], 'trange'); });
    on(qs('[data-rlw-tchips]', el), 'click', function (e) { var b = e.target.closest('.rlw-chip'); if (b) setBudget(S, +b.getAttribute('data-v'), 'chip'); });
    on(tIn, 'input', function () { var d = digitsOf(tIn.value); tIn.value = d; sizeInput(S); if (d && +d >= MIN) setBudget(S, +d, 'tinput'); });
    on(tIn, 'blur', function () { setBudget(S, +digitsOf(tIn.value) || S.budget, 'blur'); });
    on(tIn, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); tIn.blur(); } });
  }
  function markDirty(S) { if (S.composed) S.dirty = true; }
  /* elke wijziging: op de resultaatpagina meteen opnieuw samenstellen (kort uitgesteld zodat slepen vloeiend blijft) */
  function changed(S) {
    markDirty(S);
    if (S.step === 2 && S.sub === 'sty') podSoon(S);
    if (S.noneSel) return; /* niets aangevinkt: de selectie blijft staan tot er weer een soort aan staat */
    if (S.step === 3 && S.composed) {
      clearTimeout(S.rcT);
      S.rcT = setTimeout(function () { if (getState(S.el) && S.step === 3 && !S.busy) { S.dirty = false; applyDiff(S, compose(S, S.seed)); if (addOpenState(S)) renderAdd(S); } }, 160);
    }
  }

  /* ---------------- werelden ---------------- */
  function fillWorldMeta(S) {
    FR_ORDER.forEach(function (k) {
      var list = S.all.filter(function (p) { return inFr(p, k); });
      var el = qs('[data-meta="' + k + '"]', S.el); if (!el || !list.length) return;
      el.textContent = S.t.frMetaN(list.length, S.eur(minPrice(list)));
    });
  }
  function setBg(S, k) { qsa('.rlw-bgl', S.el).forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-l') === k); }); }
  function pickWorld(S, k, btn, viaKey) {
    if (k === S.fr || FR_ORDER.indexOf(k) === -1) return;
    S.fr = k; S.el.setAttribute('data-fr', k);
    qsa('.rlw-world', S.el).forEach(function (w) { var on = w.getAttribute('data-w') === k; w.setAttribute('aria-checked', String(on)); w.tabIndex = on ? 0 : -1; });
    if (viaKey && btn) try { btn.focus({ preventScroll: true }); } catch (e) { /* negeren */ }
    renderTypes(S); renderSummary(S); renderTune(S);
    live(S, S.t.live.world(S.t.fr[k]));
    worldFx(S, btn, k);
    changed(S);
  }
  function wireWorlds(S) {
    var el = S.el;
    S.on(qs('[data-rlw-worlds]', el), 'click', function (e) { var w = e.target.closest('.rlw-world'); if (w) pickWorld(S, w.getAttribute('data-w'), w); });
    S.on(qs('[data-rlw-worlds]', el), 'keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!(e.key in keys)) return;
      e.preventDefault(); e.stopPropagation();
      var n = FR_ORDER[(FR_ORDER.indexOf(S.fr) + keys[e.key] + 4) % 4];
      pickWorld(S, n, qs('.rlw-world[data-w="' + n + '"]', el), true);
    });
    /* doorgeefknoppen van het keuzescherm van de pagina */
    S.on(el, 'click', function (e) {
      var b = e.target.closest('[data-franchise3]'); if (!b || !el.contains(b)) return;
      var k = FR3[b.getAttribute('data-franchise3')] || 'all';
      pickWorld(S, k, qs('.rlw-world[data-w="' + k + '"]', el));
    });
  }

  /* ---------------- stap 2: soorten en samenstelling ---------------- */
  /* alle categorieen die in de franchise voorkomen, ook boven het budget (gedimd, wel aanklikbaar) */
  function availTypes(S) {
    var pool = poolFr(S);
    return catsMenu(S).map(function (id) {
      var all = pool.filter(function (p) { return catOf(p) === id; });
      var fit = all.filter(function (p) { return p.price <= S.budget + 1e-9; });
      return { id: id, label: catLabel(S, id), n: fit.length, total: all.length, min: all.length ? minPrice(all) : 0, dim: all.length > 0 && !fit.length, out: !all.length };
    });
  }
  /* gekozen categorieen waar binnen het budget niets van past: de laagste "vanaf"-prijs, voor de knop Zet budget op */
  function typeUp(S) {
    if (!S.types.length) return null;
    var av = availTypes(S), sel = av.filter(function (x) { return S.types.indexOf(x.id) !== -1; });
    if (!sel.length || sel.some(function (x) { return !x.dim; })) return null;
    var pick = sel.filter(function (x) { return x.id === S.lastType; })[0] || sel.slice().sort(function (a, b) { return a.min - b.min; })[0];
    return { id: pick.id, label: pick.label, min: pick.min, to: stepUp(pick.min) };
  }
  function renderTypes(S) {
    var av = availTypes(S), t = S.t, el = qs('[data-rlw-types]', S.el);
    /* (10 okt) model: S.types leeg = alles aangevinkt (geen soortfilter); S.noneSel = niets aangevinkt (enkel in stap Soort,
       dan is de hoofdknop uit). Een lijst die alle soorten bevat is weer "alles". */
    var had = S.types.length;
    S.types = S.types.filter(function (id) { return av.some(function (x) { return x.id === id; }); });
    if ((had && !S.types.length) || (S.types.length && S.types.length >= av.length)) S.types = [];
    renderLangs(S);
    el.style.gridTemplateColumns = '';
    el.setAttribute('data-n', String(av.length));
    el.classList.toggle('is-many', av.length > 6);
    /* (10 okt) sleutel enkel op de opbouw (welke soorten, in welke volgorde, met of zonder voorraad), niet op het budget:
       bij een budgetwijziging blijven de kaarten staan en verandert enkel het label Boven je budget ter plekke */
    var key = S.fr + '|' + S.tl + '|' + av.map(function (x) { return x.id + (x.out ? 'o' : ''); }).join(',');
    if (el.getAttribute('data-k') !== key) {
      el.setAttribute('data-k', key);
      el.innerHTML = (av.length ? av.map(function (x) {
        /* role checkbox: meerdere soorten tegelijk; de samenstelling rechts blijft een enkele keuze (radio). Boven het budget:
           gedimd met "vanaf", wel aanklikbaar (dan verschijnt Zet budget op) */
        if (x.out) return '<button type="button" class="rlw-type is-out" data-type="' + esc(x.id) + '" role="checkbox" aria-checked="false">' +
          '<span class="vis">' + picHTML(S, repFor(S, x.id)) + '<span class="ic">' + TICON[catIcon(x.id)] + '</span></span><span class="txt"><b>' + esc(x.label) + '</b><small>' + esc(t.outStock) + '</small></span><span class="cb" aria-hidden="true">' + ICON.check + '</span></button>';
        return '<button type="button" class="rlw-type' + (x.dim ? ' is-dim' : '') + '" data-type="' + esc(x.id) + '" role="checkbox" aria-checked="' + (S.types.indexOf(x.id) !== -1) + '">' +
          '<span class="vis">' + picHTML(S, repFor(S, x.id)) + '<span class="ic">' + TICON[catIcon(x.id)] + '</span></span>' +
          '<span class="txt">' + (x.dim ? '<em class="ob">' + esc(t.overB) + '</em>' : '') + '<b>' + esc(x.label) + '</b></span>' +
          '<span class="cb" aria-hidden="true">' + ICON.check + '</span></button>';
      }).join('') : '<p class="rlw-empty-types">' + esc(t.emptyTypes(S.eurInt(S.budget))) + '</p>');
      wirePics(el, '.rlw-type');
    } else {
      av.forEach(function (x) {
        if (x.out) return;
        var b = qs('.rlw-type[data-type="' + (window.CSS && CSS.escape ? CSS.escape(x.id) : x.id) + '"]', el); if (!b) return;
        b.classList.toggle('is-dim', !!x.dim);
        var tx = qs('.txt', b), ob = tx && qs('.ob', tx);
        if (x.dim && !ob && tx) tx.insertAdjacentHTML('afterbegin', '<em class="ob">' + esc(t.overB) + '</em>');
        else if (!x.dim && ob) ob.remove();
      });
    }
    renderStyleArt(S);
    /* soortmenu van de strook (10 okt): "Alle soorten" bovenaan, daaronder groepen Packs, Boxen en Collecties (volgorde
       binnen een groep zoals het shopmenu); per optie een kleine productfoto (zelfde uitsnede als stap 2, lijnicoon als
       terugval), naam op hoogstens 2 regels, "vanaf € X" of "Nu niet op voorraad" en rechts een checkbox. De lijst scrollt
       zelf, Klaar staat vast onderaan het menu */
    var opt = function (x) {
      var sub = x.out ? t.outStock : ''; /* eigenaar 10 okt: geen "vanaf"-regel meer, enkel de titel (en Nu niet op voorraad) */
      return '<button type="button" class="rlw-tt rlw-to' + (x.out ? ' is-out' : x.dim ? ' is-dim' : '') + '" data-type="' + esc(x.id) + '" aria-pressed="false"' + (x.out ? ' aria-disabled="true"' : '') + '>' +
        thumbHTML(S, x.id) + '<span class="tx"><span class="nm">' + esc(x.label) + '</span>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span><span class="cbx" aria-hidden="true">' + ICON.check + '</span></button>';
    };
    var grp = { packs: [], boxes: [], coll: [] };
    av.forEach(function (x) { grp[catGroup(x.id)].push(x); });
    var tp = qs('[data-rlw-tpop]', S.el);
    if (tp.getAttribute('data-k') === key) av.forEach(function (x) {
      var b = qs('.rlw-to[data-type="' + (window.CSS && CSS.escape ? CSS.escape(x.id) : x.id) + '"]', tp); if (b && !x.out) b.classList.toggle('is-dim', !!x.dim);
    });
    if (tp.getAttribute('data-k') !== key) {
      tp.setAttribute('data-k', key);
      tp.innerHTML = '<div class="rlw-tpsc"><div class="rlw-tpsel">' + selRowHTML(t) + '</div>' +
        [['packs', t.tgPacks], ['boxes', t.tgBoxes], ['coll', t.tgColl]].filter(function (g) { return grp[g[0]].length; }).map(function (g) {
          return '<div class="rlw-tgp"><p class="h">' + esc(g[1]) + '</p><div class="l">' + grp[g[0]].map(opt).join('') + '</div></div>';
        }).join('') + '</div><div class="rlw-tpft"><span class="rlw-minhint" data-rlw-typesmin2 hidden>' + esc(t.typesMin) + '</span><button type="button" class="rlw-tpdone" data-rlw-tpdone>' + esc(t.done) + '</button></div>';
      wirePics(tp, '.rlw-to');
      if (popOpen(S)) placePop(S);
    }
    syncTypes(S);
  }
  /* representatief product per soort binnen de gekozen franchise (de transparante uitsnede van de pagina via ctx.img):
     gecureerde producten eerst, bij Alles liefst Pokémon (het herkenbaarst), dan het goedkoopste. Platte foto's, geen 3D
     (de pool is beperkt). */
  function repFor(S, id, pool) {
    var list = (pool || poolFr(S)).filter(function (p) { return catOf(p) === id; });
    /* (10 okt) soort zonder voorraad (bv. Vintage): toch een echte foto, van een uitverkocht product van die soort uit de
       catalogus (window.P via metaAll; ctx.img kent ook uitverkochte producten); enkel zonder enig product het icoon */
    if (!list.length) {
      var M = metaAll(S) && S.metaH, h = null;
      if (M) Object.keys(M).some(function (k) { var m = M[k]; if (m.scat === id && (S.fr === 'all' || m.fr === S.fr)) { h = m.h; return true; } return false; });
      return h ? { handle: h } : null;
    }
    list.sort(function (a, b) {
      var ca = a.type !== 'shop' ? 0 : 1, cb = b.type !== 'shop' ? 0 : 1;
      if (ca !== cb) return ca - cb;
      if (S.fr === 'all') { var pa = frOf(a) === 'pk' ? 0 : 1, pb = frOf(b) === 'pk' ? 0 : 1; if (pa !== pb) return pa - pb; }
      return a.price - b.price;
    });
    return list[0];
  }
  /* kleine productfoto voor menu's en filters (soortmenu van de strook, filters van Voeg iets toe): de foto vloeit in over
     het lijnicoon, dat als terugval blijft staan als er geen product of geen beeld is */
  function thumbHTML(S, id, pool) {
    var p = repFor(S, id, pool);
    return '<span class="ph" aria-hidden="true">' + TICON[catIcon(id)] + (p ? '<img class="rlw-thf" data-h="' + esc(p.handle) + '" src="' + esc(S.ctx.img(p.handle)) + '" alt="" draggable="false" decoding="async">' : '') + '</span>';
  }
  function picHTML(S, p) { return p ? '<span class="pic"><img class="rlw-thf" data-h="' + esc(p.handle) + '" src="' + esc(S.ctx.img(p.handle)) + '" alt="" draggable="false" decoding="async"></span>' : ''; }
  /* kleine productfoto's (soortkaarten, soortmenu): het product zelf (cut-meta bb, zonder de lege rand van de uitsnede) vult
     ongeveer 78% van de hoogte van het fotovak, onderaan gecentreerd, op dezelfde schaal voor elke kaart */
  var CMD = null;
  function cmByH(h) {
    if (CMD === null) { try { var el = document.getElementById('cut-meta'); CMD = el ? JSON.parse(el.textContent) : {}; } catch (e) { CMD = {}; } }
    return CMD[h] || null;
  }
  function fitThumb(img) {
    var box = img && img.parentNode; if (!box || !img.naturalWidth) return;
    var W = box.clientWidth, H = box.clientHeight; if (W < 8 || H < 8) return;
    var nw = img.naturalWidth, nh = img.naturalHeight, cm = cmByH(img.getAttribute('data-h') || ''), bb = cm && cm.bb && cm.bb.length === 4 ? cm.bb : [0, 0, 1, 1];
    var fw = Math.max(1, (bb[2] - bb[0]) * nw), fh = Math.max(1, (bb[3] - bb[1]) * nh), sc = Math.min(H * .9 / fh, W * .88 / fw);
    img.style.width = (nw * sc).toFixed(1) + 'px'; img.style.height = (nh * sc).toFixed(1) + 'px';
    img.style.left = ((W - fw * sc) / 2 - bb[0] * nw * sc).toFixed(1) + 'px'; img.style.top = (H - 3 - fh * sc - bb[1] * nh * sc).toFixed(1) + 'px';
    img.classList.add('is-fit');
  }
  function refitThumbs(S) { qsa('img.rlw-thf', S.el).forEach(fitThumb); }
  /* de foto vloeit in zodra ze er is (has-pic, enkel opacity en transform); mislukt het laden, dan blijft het lijnicoon */
  function wirePics(root, hostSel) {
    qsa('img', root).forEach(function (img) {
      var host = img.closest(hostSel); if (!host) return;
      var ok = function () { host.classList.add('has-pic'); if (img.classList.contains('rlw-thf')) fitThumb(img); }, bad = function () { host.classList.remove('has-pic'); img.remove(); };
      if (img.complete) { if (img.naturalWidth) ok(); else bad(); }
      else { img.addEventListener('load', ok, { once: true }); img.addEventListener('error', bad, { once: true }); }
    });
  }
  /* kleine productcomposities in de samenstellingskaarten uit dezelfde uitsneden: Meer packs = 3 packs gewaaierd,
     Een mix = 1 doos plus 2 packs, Eén topstuk = 1 grote doos; zonder packs of doos blijft de mini-illustratie staan */
  function renderStyleArt(S) {
    var pool = poolFr(S), cur = function (p) { return p.type !== 'shop' ? 0 : 1; };
    var packs = pool.filter(function (p) { var k = typeOf(p); return k === 'packs' || k === 'blisters'; }).sort(function (a, b) { return cur(a) - cur(b) || a.price - b.price; }).slice(0, 3);
    var boxes = pool.filter(function (p) { var k = typeOf(p); return k === 'boxen' || k === 'etb' || k === 'collecties'; }).sort(function (a, b) { return cur(a) - cur(b) || b.price - a.price; });
    var box = boxes[0] || null;
    var art = { packs: packs.length >= 2 ? packs : null, mix: box && packs.length ? [box].concat(packs.slice(0, 2)) : null, big: box ? [box] : null };
    /* de nieuwe samenstellingen: een echt product dat bij de keuze past */
    var bySet = {}, setPacks = pool.filter(function (p) { var k = typeOf(p); return k === 'packs' || k === 'blisters'; }).sort(function (a, b) { return cur(a) - cur(b) || a.price - b.price; })
      .filter(function (p) { var k = setOf(S, p); if (bySet[k]) return false; bySet[k] = 1; return true; }).slice(0, 3);
    var newest = pool.filter(function (p) { return newOf(S, p) > 0; }).sort(function (a, b) { return newOf(S, b) - newOf(S, a) || cur(a) - cur(b); })[0];
    var gift = pool.filter(function (p) { var k = typeOf(p); return k === 'collecties' || k === 'etb' || k === 'bundels'; }).sort(function (a, b) { return cur(a) - cur(b) || b.price - a.price; })[0];
    var play = pool.filter(function (p) { var k = typeOf(p); return k === 'etb' || k === 'bundels'; }).sort(function (a, b) { return cur(a) - cur(b) || a.price - b.price; })[0];
    var popl3 = S.popRank ? pool.filter(function (p) { return p.handle in S.popRank; }).sort(function (a, b) { return S.popRank[a.handle] - S.popRank[b.handle]; }).slice(0, 3) : [];
    art.sets = setPacks.length >= 2 ? setPacks : null;
    art.nieuw = newest && newOf(S, newest) ? [newest] : null;
    art.cadeau = gift ? [gift] : null;
    art.spelen = play ? (packs[0] ? [play, packs[0]] : [play]) : null;
    art.populair = popl3.length >= 3 ? popl3 : null;
    var cls = { sets: 'packs', nieuw: 'big', cadeau: 'big', spelen: 'mix', populair: 'big' };
    /* strook: het eerste product als klein fotootje bij elke keuze */
    qsa('.rlw-tso', S.el).forEach(function (b) {
      var v = b.getAttribute('data-ts'), ph = qs('.ph', b), list = art[v], h = list && list[0] ? list[0].handle : '';
      if (!ph || ph.getAttribute('data-k') === h) return;
      ph.setAttribute('data-k', h);
      var oi = qs('img', ph); if (oi) oi.remove(); b.classList.remove('has-pic');
      if (h) { ph.insertAdjacentHTML('beforeend', '<img src="' + esc(S.ctx.img(h)) + '" alt="" draggable="false" decoding="async">'); wirePics(ph, '.rlw-tso'); }
    });
    podSoon(S); /* samenstelling: mini-collages en podium uit de echte uitkomst */
  }
  /* mini-scenes van de samenstellingen (eigenaar 10 okt, redesign-skill): elke kaart vertelt met echte productfoto's wat
     de keuze doet; de beweging (css, enkel transform en opacity) loopt bij hover, focus en als de kaart gekozen is.
     Rustpose = de eindstand (ook bij reduced motion). */
  function artHTML(S, v, list) {
    var im = function (p, c) { return '<i class="it ' + c + '"><img src="' + esc(S.ctx.img(p.handle)) + '" alt="" draggable="false" decoding="async"></i>'; };
    var at = function (i) { return list[i % list.length]; };
    if (v === 'packs') return [3, 1, 0, 2, 4].map(function (k) { return im(at(k), 'i' + (k + 1)); }).join('');
    if (v === 'mix') return im(list[0], 'i1') + (list[1] ? im(list[1], 'i2') : '') + (list[2] ? im(list[2], 'i3') : '');
    if (v === 'big') return '<i class="glow" aria-hidden="true"></i>' + im(list[0], 'i1');
    if (v === 'sets') return im(at(0), 'i1') + im(at(2), 'i3') + im(at(1), 'i2');
    if (v === 'nieuw') return im(list[0], 'i1') + '<b class="tag">' + esc(S.t.newTag) + '</b>';
    if (v === 'cadeau') return im(list[0], 'i1') + '<i class="rb-v"></i><i class="rb-h"></i><i class="bow"></i>';
    if (v === 'spelen') return '<i class="sl"></i>' + im(list[0], 'i1') + '<i class="die"></i>';
    if (v === 'populair') return '<i class="pod p2"><b>2</b></i><i class="pod p1"><b>1</b></i><i class="pod p3"><b>3</b></i>' + im(list[1], 'i2') + im(list[0], 'i1') + im(list[2], 'i3');
    return list.map(function (p, i) { return im(p, 'i' + (i + 1)); }).join('');
  }
  /* taalkeuze (enkelvoudig, zoals het menu): Alle talen plus de talen die voor de franchise bestaan; in stap 2, de strook
     van stap 3 en Voeg iets toe. Enkel zichtbaar als er meer dan 1 taal is. */
  function renderLangs(S) {
    var ls = langsMenu(S), t = S.t;
    if (S.tl && ls.indexOf(S.tl) === -1) S.tl = '';
    var html = ls.length > 1 ? '<button type="button" class="rlw-lchip" data-tl="" aria-pressed="' + (!S.tl) + '">' + esc(t.allLangs) + '</button>' + ls.map(function (l) {
      return '<button type="button" class="rlw-lchip" data-tl="' + esc(l) + '" aria-pressed="' + (S.tl === l) + '">' + esc(langLabel(S, l)) + '</button>';
    }).join('') : '';
    qsa('[data-rlw-langs]', S.el).forEach(function (box) { if (box.innerHTML !== html) box.innerHTML = html; box.hidden = !html; var w = box.closest('[data-rlw-langw]'); if (w) w.hidden = !html; });
  }
  function setTl(S, v) {
    if (S.tl === v) return;
    S.tl = v; S.types = []; renderTypes(S); renderTune(S); changed(S);
    if (addOpenState(S)) renderAdd(S);
  }
  function allTypeIds(S) { return availTypes(S).map(function (x) { return x.id; }); }
  function typeOn(S, id) { return !S.noneSel && (!S.types.length || S.types.indexOf(id) !== -1); }
  /* vinkje aan of uit (eigenaar 10 okt: alles staat aan, de klant vinkt uit). strip = in de strook van de selectie: daar
     kan de laatste soort niet uit (er is daar geen knop om te blokkeren) */
  function toggleType(S, id, strip) {
    var all = allTypeIds(S); if (all.indexOf(id) === -1) return;
    S.typesAuto = false;
    if (S.noneSel) { S.noneSel = false; S.types = [id]; S.lastType = id; }
    else if (!S.types.length) { S.types = all.filter(function (x) { return x !== id; }); if (!S.types.length) { if (strip) S.types = []; else S.noneSel = true; } }
    else {
      var i = S.types.indexOf(id);
      if (i === -1) { S.types.push(id); S.lastType = id; } else S.types.splice(i, 1);
      if (S.types.length >= all.length) S.types = [];
      else if (!S.types.length) { if (strip) S.types = [id]; else S.noneSel = true; }
    }
    syncTypes(S); changed(S);
  }
  /* Alle soorten: niet alles aan = alles aan; alles aan = alles uit (enkel in stap Soort; in de strook altijd alles aan) */
  function allTypesClick(S, strip) {
    S.typesAuto = false;
    if (!strip && !S.noneSel && !S.types.length) S.noneSel = true; else { S.noneSel = false; S.types = []; }
    syncTypes(S); changed(S);
  }
  function syncTypes(S) {
    var t = S.t, allOn = !S.noneSel && !S.types.length;
    qsa('[data-type]', S.el).forEach(function (b) { b.setAttribute(b.classList.contains('rlw-type') ? 'aria-checked' : 'aria-pressed', String(typeOn(S, b.getAttribute('data-type')))); });
    qsa('[data-alltypes2]', S.el).forEach(function (b) { b.setAttribute('aria-checked', String(allOn)); });
    qsa('[data-alltypes]', S.el).forEach(function (b) { b.setAttribute('aria-pressed', String(allOn)); });
    /* niets aangevinkt: hoofdknop uit met een korte hint */
    var cb = qs('[data-rlw-compose]', S.el); if (cb) { cb.disabled = !!S.noneSel; cb.title = S.noneSel ? t.typesMin : ''; }
    var mh = qs('[data-rlw-typesmin]', S.el); if (mh) mh.hidden = !S.noneSel;
    var mh2 = qs('[data-rlw-typesmin2]', S.el); if (mh2) mh2.hidden = !S.noneSel;
    qsa('[data-rlw-selall]', S.el).forEach(function (b) { b.disabled = allOn; });
    qsa('[data-rlw-selnone]', S.el).forEach(function (b) { b.disabled = !!S.noneSel; });
    qs('[data-rlw-typeshint]', S.el).textContent = S.types.length ? t.typesN(S.types.length) : t.typesNone;
    qs('[data-rlw-ttsum]', S.el).textContent = !S.types.length ? t.tAll : S.types.length === 1 ? catLabel(S, S.types[0]) : t.tN(S.types.length);
    /* strook: met een actieve soortfilter is de knop Soort net iets opvallender (paars met een bolletje, enkel css) */
    var ttb = qs('[data-rlw-ttbtn]', S.el); if (ttb) ttb.classList.toggle('is-filtered', S.types.length > 0);
    /* stap 2: een gekozen categorie boven het budget toont meteen de knop Zet budget op (op de plaats van de hint) */
    var up = typeUp(S), fx = qs('[data-rlw-typefix]', S.el), hint = qs('[data-rlw-typeshint]', S.el);
    if (fx) {
      fx.hidden = !up; if (hint) hint.hidden = !!up;
      if (up) fx.innerHTML = '<span>' + esc(t.catFrom(up.label, S.eur(up.min))) + '</span><button type="button" class="rlw-fixbtn" data-fix2="' + up.to + '">' + esc(t.setTo(S.eurInt(up.to))) + '</button>';
    }
  }
  function openAsk(S) {
    if (S.ctx.on && S.ctx.on.ask) { try { S.ctx.on.ask(); return; } catch (e) { /* negeren */ } }
    var fab = document.querySelector('.cl-fab'); if (fab) { fab.click(); return; }
    var ml = document.querySelector('a[href^="mailto:"]'); if (ml) window.location.href = ml.getAttribute('href');
  }
  function wireTypes(S) {
    S.on(S.el, 'click', function (e) { var b = e.target.closest('[data-rlw-ask]'); if (b && S.el.contains(b)) openAsk(S); });
    S.on(S.el, 'click', function (e) { var b = e.target.closest('[data-tl]'); if (!b || !S.el.contains(b)) return; setTl(S, b.getAttribute('data-tl')); });
    S.on(S.el, 'click', function (e) {
      var a = e.target.closest('[data-rlw-selall], [data-rlw-selnone]'); if (!a || !S.el.contains(a) || a.disabled) return;
      S.typesAuto = false; S.types = []; S.noneSel = a.hasAttribute('data-rlw-selnone');
      syncTypes(S); changed(S);
      var g = G(); if (g && !S.RM && !S.noneSel) g.fromTo(qsa('.rlw-type .cb', S.el), { scale: .6 }, { scale: 1, duration: .4, stagger: .02, ease: 'back.out(3)', clearProps: 'transform' });
    });
    S.on(S.el, 'click', function (e) {
      var c = e.target.closest('[data-rlw-clrtypes]'); if (c && S.el.contains(c)) { clearTypes(S); live(S, S.t.allTypes); }
    });
    S.on(S.el, 'click', function (e) {
      var b = e.target.closest('[data-fix2]'); if (!b || !S.el.contains(b)) return;
      setBudget(S, +b.getAttribute('data-fix2'), 'chip');
      live(S, S.t.pillBud + S.eurInt(S.budget));
    });
    S.on(qs('[data-rlw-types]', S.el), 'click', function (e) {
      var b = e.target.closest('.rlw-type'); if (!b) return;
      if (b.hasAttribute('data-alltypes2')) { allTypesClick(S, false); return; }
      toggleType(S, b.getAttribute('data-type'));
      var g = G(); if (g && !S.RM) g.fromTo(qs('.ic', b), { scale: .8 }, { scale: 1, duration: .45, ease: 'back.out(3)', clearProps: 'transform' });
    });
  }
  /* volgende zichtbare samenstelling (Populairst enkel met echte verkoopcijfers) */
  function nextStyle(S, d) {
    var vis = STYLES.filter(function (v) { return v !== 'populair' || S.popRank; }), i = vis.indexOf(S.style);
    return vis[(i + d + vis.length) % vis.length];
  }
  /* ================= Samenstelling: lijst plus podium (gpt-tasteskill, eigenaar 10 okt) =================
     Overgezet uit riplab-samenstelling/gpt-taste.html. Links de lijst met de 8 keuzes (mini-collage van echte producten,
     glijdende witte indicator), rechts een groot lavendel podium waarop de producten per keuze in hun eigen formatie
     vliegen. Het podium toont de echte uitkomst: compose() van de wizard met de gekozen franchise, het budget en de
     soortfilter (hoogstens enkele producten zichtbaar). Hover op een rij (desktop) toont al een voorproef; wisselen is
     een morph (gedeelde producten vliegen naar hun nieuwe plek), onderbreekbaar. GSAP van de pagina; zonder GSAP of bij
     reduced motion meteen de eindstand. Enkel transform en opacity. */
  var POD_FORM = { packs: 'packs', mix: 'mix', big: 'top', sets: 'sets', nieuw: 'new', cadeau: 'gift', spelen: 'play', populair: 'pop' };
  var POD_CAP = { packs: 7, mix: 5, top: 1, sets: 6, new: 5, gift: 3, play: 3, pop: 3 };
  var POD_HOVER = typeof matchMedia === 'function' && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function podSize(p) {
    var k = typeOf(p);
    if (/\btin\b/i.test(p.title || '')) return .36;
    return k === 'packs' ? .46 : k === 'boxen' ? .56 : k === 'etb' ? .52 : .5;
  }
  /* hoogte/breedte van de uitsnede (cut-meta: bb en ar van het productkader), anders een standaard per soort */
  var POD_NAT = {};
  function podAsp(p, noNat) {
    if (!noNat && POD_NAT[p.handle]) return POD_NAT[p.handle];
    var cm = cmByH(p.handle), bb = cm && cm.bb;
    if (cm && cm.ar > 0 && bb && bb.length === 4) return (bb[2] - bb[0]) / ((bb[3] - bb[1]) * cm.ar);
    var k = typeOf(p);
    return k === 'packs' ? 1.75 : k === 'blisters' ? .92 : k === 'boxen' ? 1.2 : k === 'etb' ? .95 : /\btin\b/i.test(p.title || '') ? .8 : 1;
  }
  /* de producten van een keuze: compose() met die stijl (zelfde regels als stap 4), aantallen uitgeschreven */
  function podItems(S, v) {
    var keep = S.style, r = null;
    S.style = v;
    try { r = compose(S, S.seed); } catch (e) { r = null; }
    S.style = keep;
    var f = POD_FORM[v] || 'mix', cap = POD_CAP[f] || 5, out = [], seen = {};
    if (!r || !r.items || !r.items.length) return [];
    var rows = r.items.slice();
    if (f === 'pop' && S.popRank) rows.sort(function (a, b) { return (S.popRank[a.p.handle] || 99) - (S.popRank[b.p.handle] || 99); });
    if (f === 'new') rows.sort(function (a, b) { return newOf(S, b.p) - newOf(S, a.p); });
    rows.forEach(function (x) {
      var dup = f === 'packs' || f === 'mix';
      for (var q = 0; q < x.qty && out.length < cap; q++) {
        if (!dup && seen[x.p.handle]) break;
        seen[x.p.handle] = 1; out.push(x.p);
        if (!dup) break;
      }
    });
    return out;
  }
  function podState(S) { return S.pd || (S.pd = { pool: new Map(), vis: {}, tl: null, idle: [], sig: '', shown: '', hT: 0, thT: 0, pill: '' }); }
  function podEls(S) {
    var st = qs('[data-rlw-pod]', S.el); if (!st) return null;
    if (st._els) return st._els;
    var e = { st: st, dim: qs('.dm', st), spot: qs('.sp', st), disc: qs('.dc', st), mat: qs('.mt', st), gb: qs('.gb', st), gf: qs('.gf', st), lid: qs('.gl', st), bow: qs('.bow', st), tag: qs('.ptag', st),
      pods: [qs('.pd.p1', st), qs('.pd.p2', st), qs('.pd.p3', st)], sparks: qsa('.spk', st) };
    e.groups = { spot: [e.dim, e.spot, e.disc], gift: [e.gb, e.gf, e.lid], mat: [e.mat], pod: e.pods, spark: e.sparks };
    return (st._els = e);
  }
  var POD_WANT = { top: 'spot', gift: 'gift', play: 'mat', pop: 'pod', new: 'spark' };
  /* doos van Cadeau: kleiner en gecentreerd; producten vallen IN de doos (achter de voorwand) en piepen er nadien boven uit */
  /* doos van Cadeau (eigenaar 10 okt): maat op basis van het podium, nooit van de producten: romp 38% van de podiumhoogte,
     breedte 1,5 keer de romp (hoogstens 45% van de podiumbreedte), gecentreerd op de vloer */
  function podGift(W, H, F) { var bh = H * .38, bw = Math.min(bh * 1.5, W * .45); return { bw: bw, bh: bh, bx: W / 2 - bw / 2, by: (F != null ? F : H * .86) - bh }; }
  function podMat(W, H) { return { mw: Math.min(W * .74, H * 1.6), mh: H * .2 }; }
  function podPods(W, H) { var bw = Math.min(W * .19, H * .38); return { bw: bw, hs: [H * .2, H * .135, H * .09], xs: [W / 2, W / 2 - bw, W / 2 + bw] }; }
  function podW(p, h, mw) { return Math.min(h / podAsp(p), mw); }
  /* (10 okt) de producten vullen het podium: de formatie schaalt mee met de podiumgrootte en het aantal producten (de
     hoogste ongeveer 75% van de podiumhoogte bij 1 product, 63% bij 2 tot 3, 50% bij 4 tot 5, 40% vanaf 6), binnen 85%
     van de breedte, nooit boven de rand of onder de vloer; doos, mat en podium 1-2-3 schalen mee (Hs = geschaalde hoogte) */
  function podLayout(f, items, W, H0) {
    var n = items.length, T = (n <= 1 ? .75 : n <= 3 ? .63 : n <= 5 ? .5 : .4) * H0, F = H0 * .86, k = 1, L = [];
    if (f === 'gift') { L = podLayoutK(f, items, W, H0, H0); L.Hs = H0; return L; } /* cadeau: de doos bepaalt de maat */
    for (var it = 0; it < 5; it++) {
      L = podLayoutK(f, items, W, H0 * k, H0);
      if (!L.length) break;
      var maxH = 0, minX = 1e9, maxX = -1e9, minTop = 1e9;
      L.forEach(function (l, j) {
        var hh = Math.min(l.h, l.mw * podAsp(items[j])), w = podW(items[j], l.h, l.mw);
        maxH = Math.max(maxH, hh); minX = Math.min(minX, l.x - w / 2); maxX = Math.max(maxX, l.x + w / 2); minTop = Math.min(minTop, l.y - hh - (l.peek || 0));
      });
      var r = Math.min(maxH > 0 ? T / maxH : 1, maxX > minX ? (W * .85) / (maxX - minX) : 9, F - minTop > 0 ? (F - H0 * .05) / (F - minTop) : 9);
      var k2 = Math.max(.5, Math.min(3, k * r));
      if (Math.abs(k2 / k - 1) < .02) break;
      k = k2;
    }
    L.Hs = H0 * k;
    return L;
  }
  function podLayoutK(f, items, W, H, H0) {
    var F = H0 * .86, cx = W / 2, n = items.length, L = [], narrow = W / H0 < 1.35;
    var sz = function (p) { return podSize(p) * H; };
    if (f === 'packs') {
      var spread = Math.min(narrow ? 84 : 116, (narrow ? 11 : 15) * (n - 1)), R = H * .3, Py = F + R * .55;
      items.forEach(function (p, j) {
        var a = n > 1 ? -spread / 2 + j * spread / (n - 1) : 0, rd = a * Math.PI / 180;
        L.push({ x: cx + Math.sin(rd) * R, y: Py - Math.cos(rd) * R, r: a, h: sz(p) * (narrow ? .82 : 1), z: 10 + j, mw: W * .3 });
      });
    } else if (f === 'mix') {
      var c = items[0], ch = sz(c) * 1.12, cw = podW(c, ch, W * .38);
      L.push({ x: cx, y: F - H * .015, r: 0, h: ch, z: 12, mw: W * .38 });
      items.slice(1).forEach(function (p, k) {
        var side = k % 2 ? 1 : -1, m = Math.floor(k / 2), ph = sz(p) * .86, pw = podW(p, ph, W * .2);
        L.push({ x: cx + side * (cw / 2 + pw * .22 + m * pw * .62), y: F + m * H * .012, r: side * (7 + m * 8), h: ph * (1 - m * .06), z: 16 - m * 2 + (side > 0 ? 1 : 0), mw: W * .2 });
      });
    } else if (f === 'top') {
      items.forEach(function () { L.push({ x: cx, y: F - H * .035, r: 0, h: H * .64, z: 12, mw: Math.min(W * .5, H * .95) }); });
    } else if (f === 'sets') {
      var span = Math.min(W * .8, n * H * .25);
      items.forEach(function (p, j) {
        var t = n > 1 ? j / (n - 1) : .5;
        L.push({ x: cx - span / 2 + t * span, y: F - Math.sin(Math.PI * t) * H * .05 - (j % 2 ? H * .03 : 0), r: j % 2 ? 4 : -4, h: sz(p) * .8, z: (j % 2 ? 10 : 20) + j, mw: W * .18 });
      });
    } else if (f === 'new') {
      items.forEach(function (p, j) {
        var t = n > 1 ? j / (n - 1) : 0;
        L.push({ x: n > 1 ? W * (.24 + .54 * t) : cx, y: F - t * H * .15, r: -2 + t * 5, h: sz(p) * (1.08 - t * .32), z: 30 - j, mw: W * .3 });
      });
    } else if (f === 'gift') {
      /* de onderkant van elk product staat net boven de bodem van de doos en de bovenkant onder de rand: volledig achter
         de voorwand; na de strik schuiven ze omhoog tot ze er boven uit piepen (nooit onder de vloer) */
      var g = podGift(W, H, F);
      items.forEach(function (p, j) {
        var side = j === 0 ? 0 : (j % 2 ? -1 : 1);
        /* binnenmaat: bodem net boven de bodem van de doos, bovenkant onder de rand (hoogte hoogstens 84% van de doos,
           breedte binnen de doos); na het openen piepen ze 30% van de doos (hoogstens ~35% van het product) boven uit */
        var gh = g.bh * (j === 0 ? .88 : .76), gmw = g.bw * (j === 0 ? .5 : .34), hh = Math.min(gh, gmw * podAsp(p));
        /* peek: in de eindstand staat 30% van het product boven de rand (bodem 6% boven de bodem van de doos) */
        L.push({ x: cx + side * g.bw * .24, y: F - g.bh * .06, r: side * 8, h: gh, z: j === 0 ? 12 : 11, mw: gmw, peek: Math.max(0, g.bh * .94 - hh * .7) });
      });
    } else if (f === 'play') {
      var mm = podMat(W, H);
      items.forEach(function (p, j) {
        var o = j - (n - 1) / 2;
        L.push({ x: cx + o * mm.mw * .3, y: F - H * .005, r: o * -6, h: sz(p) * .92, z: 12 + j, mw: mm.mw * .36 });
      });
    } else if (f === 'pop') {
      var q = podPods(W, H);
      items.forEach(function (p, j) { L.push({ x: q.xs[j], y: F - q.hs[j], r: 0, h: sz(p) * (j === 0 ? .9 : .74), z: 12 - j, mw: q.bw * .95 }); });
    }
    /* (10 okt) nooit onder de vloerlijn: een gekanteld product zakt met zijn onderste hoek (halve breedte maal sin van de
       hoek) onder zijn ankerpunt. Waaier: de hele waaier zakt minder diep (iets kleiner en samen omhoog); andere formaties
       per product omhoog. Cadeau niet: daar staan de producten bewust in de doos achter de voorwand. */
    if (f !== 'gift' && L.length) {
      var dipOf = function (l, p) { var w = podW(p, l.h, l.mw); return l.y + (w / 2) * Math.sin(Math.abs(l.r) * Math.PI / 180) - F; };
      if (f === 'packs') {
        var mx = 0; L.forEach(function (l, j) { mx = Math.max(mx, dipOf(l, items[j])); });
        if (mx > 0) {
          var k = Math.max(.82, 1 - mx / (H * .9));
          L.forEach(function (l) { l.h *= k; l.mw *= k; });
          mx = 0; L.forEach(function (l, j) { mx = Math.max(mx, dipOf(l, items[j])); });
          if (mx > 0) L.forEach(function (l) { l.y -= mx; });
        }
      } else L.forEach(function (l, j) { var d = dipOf(l, items[j]); if (d > 0) l.y -= d; });
    }
    return L;
  }
  function podFrom(f, l, W, H, j, n) {
    var dc = Math.abs(j - (n - 1) / 2);
    if (f === 'packs') return { x: W / 2, y: H * 1.12, r: 0, s: .7, t: .045 * dc, d: .95, e: 'expo.out' };
    if (f === 'mix') return j === 0 ? { x: l.x, y: -H * .05, r: -8, s: 1, t: 0, d: .85, e: 'back.out(1.3)' } : { x: l.x + (l.x < W / 2 ? -W * .35 : W * .35), y: l.y, r: l.r * 3, s: .9, t: .22 + .06 * j, d: .75, e: 'expo.out' };
    if (f === 'top') return { x: l.x, y: l.y + H * .1, r: 0, s: .6, t: .2, d: 1.1, e: 'expo.out' };
    if (f === 'sets') return { x: l.x, y: -H * .1, r: l.r * 4 + (j % 2 ? 14 : -14), s: .9, t: .055 * j, d: .7, e: 'back.out(1.5)' };
    if (f === 'new') return { x: W * 1.25, y: l.y - H * .06, r: -14, s: 1, t: .08 * j, d: .9, e: 'expo.out' };
    if (f === 'gift') return { x: l.x, y: l.y - H * .55, r: l.r - 10, s: 1, t: .25 + .08 * j, d: .6, e: 'power2.in' };
    if (f === 'play') return { x: l.x - W * .1, y: H * 1.25, r: l.r + 25, s: .9, t: .25 + .09 * j, d: .75, e: 'expo.out' };
    if (f === 'pop') return { x: l.x, y: l.y - H * .5, r: 0, s: 1, t: .45 + ([0, .12, .22][j] || 0), d: .75, e: 'bounce.out' };
    return { x: l.x, y: l.y + 40, r: 0, s: .9, t: 0, d: .6, e: 'power3.out' };
  }
  function podBox(el, x, y, w, h) { el.style.left = x + 'px'; el.style.top = y + 'px'; el.style.width = w + 'px'; el.style.height = h + 'px'; }
  function podPlace(E, grp, W, H0, items, L, g) {
    var F = H0 * .86, H = (L && L.Hs) || H0;
    if (grp === 'spot') { podBox(E.spot, W / 2 - W * .25, 0, W * .5, H0 * .9); podBox(E.disc, W / 2 - W * .17, F - H * .045, W * .34, H * .09); }
    if (grp === 'gift') { var q = podGift(W, H, F); podBox(E.gb, q.bx + q.bw * .05, q.by - q.bh * .14, q.bw * .9, q.bh * .3); podBox(E.gf, q.bx, q.by, q.bw, q.bh); podBox(E.lid, q.bx - q.bw * .03, q.by - q.bh * .2, q.bw * 1.06, q.bh * .24); }
    if (grp === 'mat') { var m = podMat(W, H); podBox(E.mat, W / 2 - m.mw / 2, F + H * .07 - m.mh * 2, m.mw, m.mh * 2); if (g) g.set(E.mat, { transformPerspective: 900, rotationX: 58, transformOrigin: '50% 100%' }); }
    if (grp === 'pod') { var pq = podPods(W, H); E.pods.forEach(function (p, k) { podBox(p, pq.xs[k] - pq.bw / 2, F - pq.hs[k], pq.bw, pq.hs[k] + 2); }); }
    if (grp === 'spark' && L[0]) {
      var l = L[0], w = podW(items[0], l.h, l.mw), h = Math.min(l.h, l.mw * podAsp(items[0]));
      var pts = [[l.x - w / 2 - 16, l.y - h * .86], [l.x + w / 2 + 8, l.y - h * 1.02], [l.x + w / 2 + 22, l.y - h * .5], [l.x - w / 2 + 6, l.y - h * 1.1]], s = [26, 20, 14, 16];
      E.sparks.forEach(function (el, k) { podBox(el, pts[k][0] - s[k] / 2, pts[k][1] - s[k] / 2, s[k], s[k]); });
    }
  }
  /* rekwisieten (spotlight, doos, mat, podium, sparkjes) altijd naar een vaste eindstand: na een onderbreking (tl.kill)
     wordt vanaf de huidige waarde naar de eindstand getweend, nooit blijft een tussenstand staan. De voor- en achterwand
     van de doos zijn altijd volledig ondoorzichtig: in en uit enkel met transform, daarna zichtbaarheid aan of uit. */
  function podOn(g, el) { return +g.getProperty(el, 'opacity') > .01 && g.getProperty(el, 'visibility') !== 'hidden'; }
  function podProps(S, tl, g, f, W, H, items, L) {
    var E = podEls(S), want = POD_WANT[f];
    Object.keys(E.groups).forEach(function (k) {
      if (k === want) return;
      var els = E.groups[k].filter(function (el) { return podOn(g, el); }); if (!els.length) return;
      if (k === 'gift') {
        var walls = [E.gb, E.gf].filter(function (el) { return els.indexOf(el) !== -1; });
        if (walls.length) tl.to(walls, { y: H * .3, duration: .3, ease: 'power2.in' }, 0).set(walls, { autoAlpha: 0 }, .3);
        if (els.indexOf(E.lid) !== -1) tl.to(E.lid, { opacity: 0, duration: .2 }, 0);
      } else tl.to(els, { opacity: 0, duration: .3, ease: 'power1.out' }, 0);
    });
    if (!want) return;
    podPlace(E, want, W, H, items, L, g);
    if (want === 'spot') {
      if (!podOn(g, E.spot)) { g.set(E.spot, { scaleX: .15, rotation: 0, transformOrigin: '50% 0%' }); g.set(E.disc, { scale: .4 }); }
      tl.to(E.dim, { opacity: 1, duration: .6 }, .05)
        .to(E.spot, { opacity: 1, scaleX: 1, duration: .85, ease: 'expo.out', transformOrigin: '50% 0%' }, .1)
        .to(E.disc, { opacity: 1, scale: 1, duration: .7, ease: 'back.out(1.6)' }, .25);
    }
    if (want === 'gift') {
      var hidden = !podOn(g, E.gf);
      g.set([E.gb, E.gf], { autoAlpha: 1, scaleY: 1 });
      if (hidden) g.set([E.gb, E.gf], { y: H * .3 });
      tl.to([E.gb, E.gf], { y: 0, duration: .6, ease: 'expo.out' }, .05);
      tl.set(E.lid, { opacity: 0, x: 0, y: 0, rotation: 0, zIndex: 35 }, 0).set(E.bow, { scale: 0, transformOrigin: '50% 60%' }, 0);
    }
    if (want === 'mat') {
      if (!podOn(g, E.mat)) g.set(E.mat, { scaleX: .5 });
      tl.to(E.mat, { opacity: 1, scaleX: 1, duration: .75, ease: 'expo.out' }, .05);
    }
    if (want === 'pod') {
      var on = E.pods.slice(0, items.length), off = E.pods.slice(items.length);
      if (off.length) tl.to(off, { opacity: 0, duration: .2 }, 0);
      on.forEach(function (el) { if (!podOn(g, el)) g.set(el, { opacity: 1, scaleY: 0, transformOrigin: '50% 100%' }); });
      tl.to(on, { opacity: 1, scaleY: 1, duration: .55, ease: 'back.out(1.5)', stagger: .08 }, .05);
    }
    if (want === 'spark') tl.fromTo(E.sparks, { opacity: 0, scale: 0, rotation: -90 }, { opacity: 1, scale: 1, rotation: 0, duration: .5, ease: 'back.out(2.5)', stagger: .08 }, .75);
  }

  function podMake(S, p) {
    var E = podEls(S), el = document.createElement('div');
    el.className = 'pp';
    el.innerHTML = '<span class="sh"></span><div class="f"><div class="h"><img alt="" draggable="false" decoding="async"></div></div>';
    var im = qs('img', el);
    im.addEventListener('load', function () {
      var a = im.naturalWidth ? im.naturalHeight / im.naturalWidth : 0; if (!a) return;
      var was = POD_NAT[p.handle]; POD_NAT[p.handle] = a;
      if (!was && Math.abs(a - podAsp(p, true)) / a > .04) { podState(S).sig = ''; podSoon(S); }
    }, { once: true });
    im.src = S.ctx.img(p.handle);
    E.st.insertBefore(el, E.tag);
    var v = { el: el, f: qs('.f', el), h: qs('.h', el), p: p, state: 'live' };
    if (POD_HOVER) {
      el.addEventListener('mouseenter', function () { podHoverP(S, v, true); });
      el.addEventListener('mouseleave', function () { podHoverP(S, v, false); });
    } else {
      /* touch: een tik toont de naam 2 seconden */
      el.addEventListener('click', function () {
        var P = podState(S); clearTimeout(P.tipT);
        podTip(S, v, true); P.tipT = setTimeout(function () { podTip(S, v, false); }, 2000);
      });
    }
    return v;
  }
  function podHoverP(S, v, on) {
    var g = G(), E = podEls(S); if (!g || v.state !== 'live') return;
    g.to(v.h, { y: on ? -12 : 0, scale: on ? 1.05 : 1, duration: S.RM ? 0 : .4, ease: on ? 'back.out(2)' : 'power3.out', overwrite: 'auto' });
    podTip(S, v, on);
  }
  /* naam enkel bij hover (eigenaar 10 okt): een tooltip voor het product onder de cursor, 12 px boven de zichtbare
     bovenkant (rekening gehouden met de lift bij hover), over het product als het niet past; set-eyebrow plus type en
     een gouden 2x als het product meerdere keren op het podium staat */
  function podTip(S, v, on) {
    var box = qs('[data-rlw-pnm]', S.el), st = qs('[data-rlw-pod]', S.el), g = G(); if (!box || !st) return;
    var old = qs('.pt', box);
    if (!on) { if (old && old.getAttribute('data-h') === v.p.handle) { if (g && !S.RM) g.to(old, { opacity: 0, scale: .85, duration: .15, onComplete: function () { old.remove(); } }); else old.remove(); } return; }
    if (old) old.remove();
    var sr = st.getBoundingClientRect(), W = st.clientWidth, H = st.clientHeight, b = podVisBox(v, sr), n = 0, P = podState(S);
    P.pool.forEach(function (x) { if (x.state === 'live' && x.p.handle === v.p.handle) n++; });
    var lift = POD_HOVER && !S.RM ? 12 + (b.b - b.t) * .05 : 0, top = b.t - lift, np = podNameParts(v.p), mob = S.mode === 'm';
    var el = document.createElement('span'); el.className = 'pt'; el.setAttribute('data-h', v.p.handle);
    el.innerHTML = (n > 1 ? '<em class="qx">' + n + 'x</em>' : '') + (np.set && !mob ? '<small>' + esc(np.set) + '</small>' : '') + '<b>' + esc(np.type) + '</b><i class="ar"></i>';
    box.appendChild(el);
    var w = el.offsetWidth || 120, h = el.offsetHeight || 40, M = 12, AR = 6, x = (b.l + b.r) / 2, cx = Math.max(M + w / 2, Math.min(W - M - w / 2, x));
    var y = top - M - AR, inside = false;
    if (y - h < M) { y = Math.min(H - M, top + M + h); inside = true; }
    el.style.left = cx.toFixed(1) + 'px'; el.style.top = y.toFixed(1) + 'px';
    el.classList.toggle('is-in', inside);
    var ar = qs('.ar', el); if (ar) ar.style.left = Math.max(12, Math.min(w - 12, w / 2 + (x - cx))).toFixed(1) + 'px';
    if (g && !S.RM) { g.set(el, { xPercent: -50, yPercent: -100, transformOrigin: '50% 100%' }); g.fromTo(el, { opacity: 0, scale: .7 }, { opacity: 1, scale: 1, duration: .3, ease: 'back.out(2.4)' }); }
    else { el.style.opacity = '1'; el.style.transform = 'translate(-50%,-100%)'; }
  }
  function podScale(p, l) { return Math.min(l.h / (200 * podAsp(p)), l.mw / 200); }
  function podKillIdle(S, g) {
    var P = podState(S), E = podEls(S);
    P.idle.forEach(function (t) { t.kill(); }); P.idle = [];
    var fs = []; P.pool.forEach(function (v) { fs.push(v.f); });
    if (fs.length) g.to(fs, { y: 0, rotation: 0, duration: S.RM ? 0 : .3, overwrite: 'auto' });
    g.to(E.spot, { rotation: 0, duration: S.RM ? 0 : .3 });
  }
  function podIdle(S, g, f) {
    var P = podState(S), E = podEls(S), k = 0;
    if (S.RM) return;
    P.pool.forEach(function (v) {
      if (v.state !== 'live') return;
      if (f === 'top') P.idle.push(g.to(v.f, { y: -12, duration: 2.2, ease: 'sine.inOut', yoyo: true, repeat: -1 }));
      else P.idle.push(g.to(v.f, { y: -4, rotation: (k % 2 ? 1 : -1) * .8, duration: 2 + (k % 3) * .4, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: (k % 4) * .15 }));
      k++;
    });
    if (f === 'top') P.idle.push(g.fromTo(E.spot, { rotation: -1.2 }, { rotation: 1.2, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1, transformOrigin: '50% 0%' }));
    if (f === 'new') E.sparks.forEach(function (s, j) { P.idle.push(g.to(s, { scale: .55, rotation: 45, duration: .9 + j * .25, ease: 'sine.inOut', yoyo: true, repeat: -1 })); });
  }
  /* zonder GSAP: de eindstand met gewone transforms (product onderaan gecentreerd op x/y) */
  function podStatic(S, f, items, L, W, H) {
    var P = podState(S), E = podEls(S);
    P.pool.forEach(function (v) { v.el.remove(); }); P.pool.clear();
    Object.keys(E.groups).forEach(function (k) { E.groups[k].forEach(function (el) { el.style.opacity = '0'; }); });
    var want = POD_WANT[f];
    if (want) { podPlace(E, want, W, H, items, L, null); E.groups[want].slice(0, want === 'pod' ? items.length : 9).forEach(function (el) { el.style.opacity = '1'; }); if (want === 'gift') { var gq = podGift(W, L.Hs || H, H * .86); E.lid.style.zIndex = '2'; E.lid.style.transform = 'translate(' + (gq.bw * .5).toFixed(1) + 'px,' + (-gq.bh * .38).toFixed(1) + 'px) rotate(16deg)'; } }
    items.forEach(function (p, j) {
      var l = L[j], v = podMake(S, p), sc = podScale(p, l);
      P.pool.set(p.handle + '#' + j, v);
      v.el.style.zIndex = l.z;
      v.el.style.transform = 'translate(' + l.x.toFixed(1) + 'px,' + (l.y - (l.peek || 0)).toFixed(1) + 'px) translate(-50%,-100%) rotate(' + l.r + 'deg) scale(' + sc.toFixed(3) + ')';
    });
  }
  /* namen bij de producten (eigenaar 10 okt): pas na de eindstand van de formatie, in een nette rij onder de vloerlijn
     (zelfde volgorde als op het podium, links naar rechts), zodat ze nooit overlappen; "2x" bij meerdere stuks, geen
     prijzen. Bij een nieuwe keuze of onderbreking eerst weg. Gsm: een compacte lijst onder het podium. */
  function podNamesHide(S) {
    qsa('[data-rlw-pnm] .pt, [data-rlw-pnm] .lk', S.el).forEach(function (el) { el.remove(); });
  }
  /* naam in twee lagen: de set als eyebrow, het producttype eronder; lukt het splitsen niet, dan de korte titel */
  function podNameParts(p) {
    var t = fullTitle(p.title || ''), m = KIND_RE.exec(t), type = '', set = '';
    if (m) { type = m[1]; set = t.slice(0, m.index).replace(/^One Piece( Card Game)?:?\s*/i, '').replace(/^Disney Lorcana Set \d+:\s*/i, 'Lorcana ').replace(/[\s\-:&]+$/, '').trim(); }
    if (!type || !set) return { set: '', type: shortTitle(p.title || '') || t };
    return { set: set, type: type };
  }
  /* namen als vaste tooltips boven elk product (eigenaar 10 okt): na de eindstand een kleine pil met een pijltje naar
     het product (set als eyebrow plus producttype, gouden 2x bij meerdere stuks); nooit over elkaar of buiten het
     podium: bij dicht op elkaar staande producten om en om hoger, anders weggelaten; hoogstens 5 (gsm 3) */
  /* zichtbare box van een product op het podium: de img na alle transforms, ingekort tot het productkader van de
     uitsnede (cut-meta bb), zodat de transparante rand niet meetelt */
  function podVisBox(v, sr) {
    var im = qs('img', v.el), r = (im || v.el).getBoundingClientRect(), cm = cmByH(v.p.handle), bb = cm && cm.bb && cm.bb.length === 4 ? cm.bb : [0, 0, 1, 1];
    return { l: r.left - sr.left + bb[0] * r.width, r: r.left - sr.left + bb[2] * r.width, t: r.top - sr.top + bb[1] * r.height, b: r.top - sr.top + bb[3] * r.height };
  }
  /* namen als vaste tooltips (eigenaar 10 okt): na de eindstand, 12 px boven de zichtbare bovenkant van het product
     (pijltje inbegrepen); past dat niet binnen het podium, dan bovenaan over het product; botsen ze, dan om en om hoger;
     botsen ze dan nog (waaier), dan een nette stapel naast de formatie met een dun lijntje naar elk product. Elk product
     (hoogstens 5, gsm 3) krijgt een naam. */
  function podNamesShow(S) {
    var mob = S.mode === 'm', box = qs('[data-rlw-pnm]', S.el), mm = qs('[data-rlw-pnmm]', S.el), g = G(), P = podState(S);
    if (mm) mm.innerHTML = '';
    if (!box) return;
    var st = qs('[data-rlw-pod]', S.el); if (!st) return;
    var sr = st.getBoundingClientRect(), W = st.clientWidth, H = st.clientHeight, rows = [], at = {};
    P.pool.forEach(function (v) {
      if (v.state !== 'live') return;
      var b = podVisBox(v, sr), h = v.p.handle, x = (b.l + b.r) / 2;
      if (at[h] != null) { var o = rows[at[h]]; o.n++; if (b.t < o.b.t) { o.b = b; o.x = x; } return; }
      at[h] = rows.length; rows.push({ p: v.p, n: 1, x: x, b: b });
    });
    rows.sort(function (a, b) { return a.x - b.x; });
    rows = rows.slice(0, mob ? 3 : 5);
    box.innerHTML = '<svg class="lk" aria-hidden="true"></svg>' + rows.map(function (r) {
      var np = podNameParts(r.p);
      return '<span class="pt" data-h="' + esc(r.p.handle) + '">' + (r.n > 1 ? '<em class="qx">' + r.n + 'x</em>' : '') +
        (np.set && !mob ? '<small>' + esc(np.set) + '</small>' : '') + '<b>' + esc(np.type) + '</b><i class="ar"></i></span>';
    }).join('');
    var els = qsa('.pt', box), M = 12, AR = 6, gap = 12, placed = [], pos = [], clash = false;
    var hit = function (a) { return placed.some(function (q) { return a.l < q.r + gap && a.r > q.l - gap && a.t < q.b + gap && a.b > q.t - gap; }); };
    els.forEach(function (el, k) {
      var r = rows[k], w = el.offsetWidth || 120, h = el.offsetHeight || 40;
      var cx = Math.max(M + w / 2, Math.min(W - M - w / 2, r.x)), done = null;
      for (var lvl = 0; lvl < 2 && !done; lvl++) {
        var y = r.b.t - M - AR - lvl * (h + gap), inside = false;
        if (y - h < M) { if (lvl) break; y = Math.min(H - M, r.b.t + M + h); inside = true; }
        var a = { l: cx - w / 2, r: cx + w / 2, t: y - h, b: y };
        if (!hit(a)) done = { a: a, cx: cx, y: y, inside: inside };
      }
      if (!done) clash = true; else placed.push(done.a);
      pos.push(done);
    });
    var svg = qs('.lk', box), lines = '';
    if (clash) {
      /* stapel naast de formatie: de kant met de meeste ruimte, verticaal gecentreerd op de producten */
      var minX = Math.min.apply(null, rows.map(function (r) { return r.b.l; })), maxX = Math.max.apply(null, rows.map(function (r) { return r.b.r; }));
      var ws = els.map(function (el) { return el.offsetWidth || 120; }), hs = els.map(function (el) { return el.offsetHeight || 40; });
      var colW = Math.max.apply(null, ws), right = W - maxX >= minX, tot = hs.reduce(function (a, b) { return a + b; }, 0) + gap * (els.length - 1);
      var midY = rows.reduce(function (a, r) { return a + (r.b.t + r.b.b) / 2; }, 0) / rows.length, y0 = Math.max(M, Math.min(H - M - tot, midY - tot / 2));
      var colX = right ? Math.min(W - M - colW / 2, maxX + 24 + colW / 2) : Math.max(M + colW / 2, minX - 24 - colW / 2);
      pos = els.map(function (el, k) {
        var y = y0 + hs.slice(0, k + 1).reduce(function (a, b) { return a + b; }, 0) + gap * k;
        var ex = right ? colX - ws[k] / 2 : colX + ws[k] / 2, ey = y - hs[k] / 2, r = rows[k];
        lines += '<line x1="' + ex.toFixed(1) + '" y1="' + ey.toFixed(1) + '" x2="' + r.x.toFixed(1) + '" y2="' + (r.b.t + (r.b.b - r.b.t) * .25).toFixed(1) + '"/><circle cx="' + r.x.toFixed(1) + '" cy="' + (r.b.t + (r.b.b - r.b.t) * .25).toFixed(1) + '" r="3.5"/>';
        return { cx: colX, y: y, side: true };
      });
    }
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H); svg.setAttribute('width', W); svg.setAttribute('height', H); svg.innerHTML = lines;
    els.forEach(function (el, k) {
      var q = pos[k], r = rows[k], w = el.offsetWidth || 120;
      el.style.left = q.cx.toFixed(1) + 'px'; el.style.top = q.y.toFixed(1) + 'px';
      el.classList.toggle('is-in', !!q.inside); el.classList.toggle('is-side', !!q.side);
      var ar = qs('.ar', el); if (ar) ar.style.left = Math.max(12, Math.min(w - 12, w / 2 + (r.x - q.cx))).toFixed(1) + 'px';
    });
    if (g && !S.RM) { g.set(els, { xPercent: -50, yPercent: -100, transformOrigin: '50% 100%' }); g.fromTo(els, { opacity: 0, scale: .6 }, { opacity: 1, scale: 1, duration: .45, ease: 'back.out(2.2)', stagger: .07 }); g.fromTo(svg, { opacity: 0 }, { opacity: 1, duration: .4, delay: .1 }); }
    else { els.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'translate(-50%,-100%)'; }); svg.style.opacity = '1'; }
  }
  function podRender(S, v, o) {
    o = o || {};
    var E = podEls(S), P = podState(S); if (!E || !v) return;
    var W = E.st.clientWidth, H = E.st.clientHeight; if (!W || !H) return;
    var sig = v + '|' + S.fr + '|' + S.budget + '|' + S.types.join(',') + '|' + (S.noneSel ? 'n' : '') + '|' + W + 'x' + H + '|' + (S.popRank ? 'p' : '');
    if (sig === P.sig && !o.force) return;
    P.sig = sig; P.shown = v;
    var f = POD_FORM[v] || 'mix', items = podItems(S, v), L = podLayout(f, items, W, H), g = G();
    E.st.setAttribute('data-f', f);
    podPill(S, items[0]);
    if (!g) { podStatic(S, f, items, L, W, H); return; }
    if (P.tl) P.tl.kill();
    podKillIdle(S, g);
    podNamesHide(S, g);
    g.to(E.tag, { opacity: 0, duration: .1 });
    var tl = g.timeline(); P.tl = tl;
    var cnt = {}, next = items.map(function (p, j) { cnt[p.handle] = (cnt[p.handle] || 0) + 1; return { k: p.handle + '#' + cnt[p.handle], p: p, l: L[j] }; });
    var nk = {}; next.forEach(function (n) { nk[n.k] = 1; });
    var ex = 0;
    P.pool.forEach(function (vv, k) {
      if (nk[k]) return;
      vv.state = 'exit';
      g.to(vv.h, { y: 0, scale: 1, duration: .2, overwrite: 'auto' });
      tl.to(vv.el, { y: g.getProperty(vv.el, 'y') - H * .2, opacity: 0, scale: g.getProperty(vv.el, 'scaleX') * .82, rotation: g.getProperty(vv.el, 'rotation') + (ex % 2 ? 10 : -10), duration: .38, ease: 'power2.in',
        onComplete: function () { if (vv.state === 'exit') { vv.el.remove(); P.pool.delete(k); } } }, ex * .02);
      ex++;
    });
    var at = ex ? .16 : 0;
    podProps(S, tl, g, f, W, H, items, L);
    next.forEach(function (n, j) {
      var l = n.l, sc = podScale(n.p, l), vv = P.pool.get(n.k);
      if (vv) {
        vv.state = 'live';
        g.set(vv.el, { zIndex: l.z });
        tl.to(vv.el, { x: l.x, y: l.y, rotation: l.r, scale: sc, opacity: 1, duration: .85, ease: 'power3.inOut' }, .03 * j);
      } else {
        vv = podMake(S, n.p); P.pool.set(n.k, vv);
        var fr = podFrom(f, l, W, H, j, next.length);
        g.set(vv.el, { xPercent: -50, yPercent: -100, transformOrigin: '50% 100%', zIndex: l.z, x: fr.x, y: fr.y, rotation: fr.r, scale: sc * fr.s, opacity: 0 });
        tl.to(vv.el, { x: l.x, y: l.y, rotation: l.r, scale: sc, duration: fr.d, ease: fr.e }, at + fr.t)
          .to(vv.el, { opacity: 1, duration: .25, ease: 'none' }, at + fr.t);
      }
    });
    if (f === 'gift' && next.length) {
      /* in de doos: deksel dicht, strik, deksel weer open en de producten piepen er BOVEN uit (bodem blijft in de doos) */
      var q = podGift(W, L.Hs || H, H * .86), els = next.map(function (n) { return P.pool.get(n.k).el; }), T = tl.duration() + .1;
      tl.fromTo(E.lid, { x: 0, y: -H * .35, rotation: -6, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, duration: .5, ease: 'back.out(1.6)' }, T)
        .to(E.gf, { scaleY: .97, transformOrigin: '50% 100%', duration: .1, yoyo: true, repeat: 1 }, T + .35)
        .fromTo(E.bow, { scale: 0, rotation: -30 }, { scale: 1, rotation: 0, duration: .5, ease: 'back.out(3)' }, T + .4)
        .set(E.lid, { zIndex: 2 }, T + 1.3)
        .to(E.lid, { y: -q.bh * .38, x: q.bw * .5, rotation: 16, duration: .6, ease: 'power3.inOut' }, T + 1.25)
        .to(els, { y: function (k) { return next[k].l.y - next[k].l.peek; }, duration: .6, ease: 'back.out(1.4)', stagger: .08 }, T + 1.4);
    }
    tl.call(function () { podIdle(S, g, f); });
    if (S.RM || o.instant) tl.progress(1);
  }
  /* productpil in de titel (Inline Typography Image): het eerste product van de keuze */
  function podPill(S, p) {
    var P = podState(S), box = qs('[data-rlw-hpill]', S.el), g = G(); if (!box) return;
    var src = p ? S.ctx.img(p.handle) : '';
    if (src === P.pill) return; P.pill = src;
    var old = qs('img', box);
    if (!src) { if (old) old.remove(); return; }
    var im = document.createElement('img'); im.src = src; im.alt = ''; box.appendChild(im);
    if (!g || S.RM) { if (old) old.remove(); return; }
    g.set(im, { xPercent: -50, yPercent: -38 });
    if (old) g.to(old, { y: -26, opacity: 0, duration: .28, ease: 'power2.in', onComplete: function () { old.remove(); } });
    g.fromTo(im, { y: 26, opacity: 0, rotation: -8 }, { y: 0, opacity: 1, rotation: 0, duration: .5, ease: 'back.out(1.8)', delay: .08 });
  }
  /* mini-collage per rij uit dezelfde echte uitkomst (2 tot 3 producten) */
  var POD_TH = {
    packs: [[-10, 1, -18, .95], [10, 1, 18, .95], [0, -1, 0, 1]], mix: [[-12, 0, -12, .78], [12, 0, 12, .78], [0, 0, 0, 1.02]], top: [[0, 0, 0, 1.12]],
    sets: [[-12, 0, -5, .82], [12, 0, 5, .82], [0, -3, 0, .86]], new: [[8, -5, 6, .74], [-7, 1, -4, .95]], gift: [[0, 0, 0, 1], [12, 0, 10, .7]],
    play: [[-8, -2, -8, .85], [9, -2, 8, .85]], pop: [[-12, -5, 0, .62], [12, -3, 0, .6], [0, -9, 0, .78]]
  };
  /* vaste mini-composities per keuze (eigenaar 10 okt): los van de samenstelling, de gekozen keuze, het budget en de
     soortfilter; enkel per franchise een keer gekozen (en een keer na het laden van releasedata of verkoopcijfers).
     Bewust representatief, nooit Kluis, mystery, CARDWORLD-eigen of accessoires. */
  var TH_SVG = {
    star: '<svg class="ov ov-star" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 0c.8 6.4 4.8 10.6 12 12-7.2 1.4-11.2 5.6-12 12-.8-6.4-4.8-10.6-12-12C7.2 10.6 11.2 6.4 12 0z" fill="#E8C840"/></svg>',
    bow: '<svg class="ov ov-bow" viewBox="0 0 64 40" aria-hidden="true"><path d="M32 22C24 6 8 2 6 12s14 12 26 10zM32 22C40 6 56 2 58 12S44 24 32 22z" fill="#E8C840"/><path d="M30 22l-8 16 6-2 4 4zM34 22l8 16-6-2-4 4z" fill="#d4b22a"/><circle cx="32" cy="22" r="5" fill="#f4f0fb" stroke="#d4b22a" stroke-width="2"/></svg>',
    die: '<svg class="ov ov-die" viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5" fill="#fff" stroke="#b9a8dc" stroke-width="1.5"/><circle cx="8" cy="8" r="2" fill="#4a2d7a"/><circle cx="12" cy="12" r="2" fill="#4a2d7a"/><circle cx="16" cy="16" r="2" fill="#4a2d7a"/></svg>',
    medal: '<svg class="ov ov-medal" viewBox="0 0 24 28" aria-hidden="true"><path d="M7 0h4l2 7H9zM13 0h4l-2 7h-4z" fill="#7B5EA7"/><circle cx="12" cy="17" r="10" fill="#E8C840" stroke="#d4b22a" stroke-width="1.5"/><path d="M12.8 11.5v11h-2.2v-8.2l-2 .9v-2.1l2.6-1.6z" fill="#2d1270"/></svg>'
  };
  var TH_POS = {
    packs: [[-12, 0, -14, 1, 34], [12, 0, 14, 1, 34], [0, -2, 0, 1, 38]],
    mix: [[-6, 0, 0, 1, 40], [12, 0, 9, 1, 29], [19, 1, 17, 1, 25]],
    big: [[0, 0, 0, 1, 46]],
    sets: [[-15, 0, -7, 1, 31], [-5, -1, -2, 1, 33], [5, -1, 2, 1, 33], [15, 0, 7, 1, 31]],
    nieuw: [[0, 0, 0, 1, 44]], cadeau: [[0, 0, 0, 1, 36]], spelen: [[-5, 0, 0, 1, 38]], populair: [[3, 0, 0, 1, 42]]
  };
  var TH_OV = { nieuw: 'star', cadeau: 'bow', spelen: 'die', populair: 'medal' };
  function thumbPicks(S) {
    var ok = S.all.filter(function (p) { return inFr(p, S.fr) && !NOSET_RE.test(p.title || '') && !NOSET_RE.test(p.handle || '') && !CAT_EXC.test(p.kind || ''); });
    var cur = function (p) { return p.type !== 'shop' ? 0 : 1; };
    var by = function (fn, sort) { return ok.filter(fn).sort(sort || function (a, b) { return cur(a) - cur(b) || a.price - b.price || a.handle.localeCompare(b.handle); }); };
    var isPack = function (p) { return typeOf(p) === 'packs' && !/sleeved/i.test(p.title || ''); };
    var distinct = function (list, n) { var seen = {}, out = []; list.forEach(function (p) { var k = setOf(S, p); if (out.length < n && !seen[k]) { seen[k] = 1; out.push(p); } }); return out; };
    var packs = by(isPack), out = {};
    out.packs = distinct(packs, 3);
    var box = by(function (p) { var k = typeOf(p); return k === 'etb' || k === 'bundels'; })[0];
    out.mix = box ? [box].concat(packs.slice(0, 2)) : [];
    out.big = by(function (p) { var k = typeOf(p); return (k === 'boxen' || k === 'collecties' || /ultra premium|premium collection/i.test(p.title || '')) && !/\btin\b/i.test(p.title || ''); }, function (a, b) { return b.price - a.price; }).slice(0, 1);
    out.sets = distinct(packs.slice().reverse(), 4);
    if (out.sets.length < 2) out.sets = packs.slice(0, 3);
    if (out.packs.length < 3) out.packs = out.packs.concat(packs.filter(function (p) { return out.packs.indexOf(p) === -1; })).slice(0, 3);
    var nw = ok.filter(function (p) { return newOf(S, p) > 0; }).sort(function (a, b) { return newOf(S, b) - newOf(S, a) || (isPack(a) ? 0 : 1) - (isPack(b) ? 0 : 1) || cur(a) - cur(b); });
    out.nieuw = nw.slice(0, 1);
    out.cadeau = by(function (p) { return typeOf(p) === 'collecties' && !/ultra premium/i.test(p.title || ''); }, function (a, b) { return cur(a) - cur(b) || b.price - a.price; }).slice(0, 1);
    out.spelen = by(function (p) { return typeOf(p) === 'etb'; }).slice(0, 1);
    out.populair = S.popRank ? ok.filter(function (p) { return p.handle in S.popRank; }).sort(function (a, b) { return S.popRank[a.handle] - S.popRank[b.handle]; }).slice(0, 1) : [];
    return out;
  }
  function podThumbs(S) {
    var key = S.fr + '|' + (S.popRank ? 'p' : '') + '|' + (S.relPk ? 'r' : '');
    if (S.thKey === key) return;
    S.thKey = key;
    var picks = thumbPicks(S);
    qsa('.rlw-cmp .rlw-style', S.el).forEach(function (b) {
      var v = b.getAttribute('data-style'), th = qs('.ill', b), list = picks[v] || [], pos = TH_POS[v] || TH_POS.big; if (!th) return;
      var hk = list.map(function (p) { return p.handle; }).join('|');
      if (th.getAttribute('data-k') === hk) return;
      th.setAttribute('data-k', hk);
      /* minder producten dan plaatsen: symmetrisch rond het midden (nooit een product alleen aan de zijkant) */
      var cnt = Math.min(list.length, pos.length);
      if (cnt && cnt < pos.length && (v === 'sets' || v === 'packs' || v === 'mix')) {
        var hh = v === 'mix' ? pos[1][4] : pos[0][4], step = cnt === 1 ? 0 : Math.min(14, 28 / (cnt - 1));
        pos = v === 'mix' ? [[cnt > 1 ? -6 : 0, 0, 0, 1, 40], [12, 0, 9, 1, 29]] : list.slice(0, cnt).map(function (p, k) { var o = k - (cnt - 1) / 2; return [o * step, Math.abs(o) * 1, o * 7, 1, hh + 4]; });
      }
      var html = '<span class="thw">' + list.slice(0, pos.length).map(function (p, k) {
        var a = pos[k];
        return '<img src="' + esc(S.ctx.img(p.handle)) + '" alt="" draggable="false" decoding="async" style="--x:' + a[0] + 'px;--y:' + a[1] + 'px;--r:' + a[2] + 'deg;--s:' + a[3] + ';--h:' + a[4] + 'px;z-index:' + (k + 1) + '">';
      }).join('') + (list.length && TH_OV[v] ? TH_SVG[TH_OV[v]] : '') + '</span>';
      /* zonder flikkeren: de nieuwe compositie pas tonen als de beelden geladen zijn */
      var tmp = document.createElement('span'); tmp.innerHTML = html;
      var imgs = qsa('img', tmp), left = imgs.length, swap = function () { th.innerHTML = ''; th.appendChild(tmp.firstChild); };
      if (!left || !th.firstChild) { swap(); return; }
      imgs.forEach(function (im) { var d = function () { if (--left === 0) swap(); }; if (im.complete) d(); else { im.addEventListener('load', d, { once: true }); im.addEventListener('error', d, { once: true }); } });
    });
  }
  function podSoon(S) {
    var P = podState(S);
    clearTimeout(P.thT);
    P.thT = setTimeout(function () {
      if (!getState(S.el) || S.step !== 2 || S.sub !== 'sty') return;
      podThumbs(S); podRender(S, P.hover || S.style); podInd(S);
    }, 90);
  }
  /* glijdende witte indicator onder de gekozen rij */
  function podInd(S) {
    var ind = qs('.rlw-cind', S.el), r = qs('.rlw-cmp .rlw-style[aria-checked="true"]', S.el), g = G(); if (!ind || !r) return;
    ind.style.height = r.offsetHeight + 'px';
    if (g && !S.RM && ind._on) g.to(ind, { y: r.offsetTop, duration: .5, ease: 'expo.out', overwrite: 'auto' });
    else { if (g) g.set(ind, { y: r.offsetTop }); else ind.style.transform = 'translateY(' + r.offsetTop + 'px)'; }
    ind._on = true;
  }
  /* Volgende: de producten zoeven rechts weg, dan door naar Soort */
  function podLeave(S, cb) {
    var P = podState(S), E = podEls(S), g = G();
    clearTimeout(P.hT); P.hover = null;
    var done = function () {
      P.pool.forEach(function (v) { v.el.remove(); }); P.pool.clear(); P.vis = {}; P.sig = '';
      qsa('[data-rlw-pnm], [data-rlw-pnmm]', S.el).forEach(function (b) { b.innerHTML = ''; });
      if (E) Object.keys(E.groups).forEach(function (k) { E.groups[k].forEach(function (el) { el.style.opacity = '0'; }); });
      cb();
    };
    if (!g || S.RM || !E || !P.pool.size) { done(); return; }
    if (P.tl) P.tl.kill(); podKillIdle(S, g);
    var W = E.st.clientWidth, els = []; P.pool.forEach(function (v) { v.state = 'gone'; els.push(v.el); });
    var t = g.timeline(); P.tl = t;
    t.to(els, { x: '+=' + W * .75, rotation: '+=14', opacity: 0, duration: .5, ease: 'power3.in', stagger: .03 }, 0)
      .to([E.dim, E.spot, E.disc, E.gb, E.gf, E.lid, E.mat].concat(E.pods, E.sparks), { opacity: 0, duration: .3 }, 0)
      .add(done, .42);
  }
  function wirePod(S) {
    var list = qs('.rlw-cl', S.el), P = podState(S); if (!list) return;
    /* (10 okt) geen hover-voorproef meer op het podium: enkel een klik of het toetsenbord wisselt de formatie */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { clearTimeout(P.rT); P.rT = setTimeout(function () { if (S.step === 2 && S.sub === 'sty') { podInd(S); podRender(S, P.hover || S.style, { instant: true }); } }, 120); });
      ro.observe(qs('[data-rlw-pod]', S.el));
      S.offs.push(function () { ro.disconnect(); });
    }
  }
  function renderStyles(S) { qsa('.rlw-style', S.el).forEach(function (b) { var on = b.getAttribute('data-style') === S.style; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; }); var P = podState(S); P.hover = null; podSoon(S); }
  function setStyle(S, v) { if (S.style === v || STYLES.indexOf(v) === -1 || (v === 'populair' && !S.popRank)) return; S.style = v; suggestTypes(S); renderStyles(S); renderTune(S); changed(S); }
  function wireStyles(S) {
    var box = qs('[data-rlw-styles]', S.el);
    S.on(box, 'click', function (e) { var b = e.target.closest('.rlw-style'); if (b) setStyle(S, b.getAttribute('data-style')); });
    S.on(box, 'keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }; if (!(e.key in keys)) return;
      e.preventDefault(); e.stopPropagation();
      var n = nextStyle(S, keys[e.key]);
      setStyle(S, n); var nb = qs('.rlw-style[data-style="' + n + '"]', S.el); if (nb) nb.focus({ preventScroll: true });
    });
  }
  /* pillen in stap 2 (eigenaar 10 okt): franchise en budget ter plekke aanpassen in een compacte laag, niet terug naar stap 1 */
  function setSpop(S, k, back) {
    var was = S.spop || null; if (was === (k || null)) return;
    S.spop = k || null;
    qsa('[data-rlw-spop]', S.el).forEach(function (p) { p.hidden = p.getAttribute('data-rlw-spop') !== S.spop; });
    renderSummary(S);
    var g = G(), box = S.spop ? qs('[data-rlw-spop="' + S.spop + '"]', S.el) : null;
    if (box) {
      if (g && !S.RM) g.fromTo(box, { autoAlpha: 0, y: -6 }, { autoAlpha: 1, y: 0, duration: .22, ease: 'power2.out', clearProps: 'transform,opacity,visibility' });
      /* focus zonder de tekst te selecteren: cursor achteraan */
      var f = qs(S.spop === 'fr' ? '[data-pw][aria-pressed="true"]' : '[data-rlw-pin]', box); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); if (f.setSelectionRange && f.value != null) { var L = String(f.value).length; f.setSelectionRange(L, L); } } catch (e) { /* negeren */ } }, 30);
    } else if (back && was) { var pl = qs('[data-rlw-pill="' + was + '"]', S.el); if (pl) try { pl.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }
  }
  function wireSpop(S) {
    var el = S.el, on = S.on;
    on(el, 'click', function (e) {
      var pl = e.target.closest('[data-rlw-pill]'); if (pl && el.contains(pl)) { var k = pl.getAttribute('data-rlw-pill'); setSpop(S, S.spop === k ? null : k, true); return; }
      var tl = e.target.closest('[data-pw]'); if (tl && el.contains(tl)) { pickWorld(S, tl.getAttribute('data-pw'), tl); renderSummary(S); return; }
      if (e.target.closest('[data-rlw-spdone]')) { setSpop(S, null, true); return; }
      var ch = e.target.closest('[data-rlw-pchips] .rlw-chip'); if (ch) setBudget(S, +ch.getAttribute('data-v'), 'chip');
    });
    var pin = qs('[data-rlw-pin]', el), pr = qs('[data-rlw-prange]', el);
    if (pr) pr.max = String(STEPS.length - 1);
    on(pr, 'input', function () { setBudget(S, STEPS[+pr.value], 'prange'); });
    on(pin, 'input', function () { var d = digitsOf(pin.value); pin.value = d; if (d && +d >= MIN) setBudget(S, +d, 'pinput'); });
    on(pin, 'blur', function () { setBudget(S, +digitsOf(pin.value) || S.budget, 'blur'); });
    on(pin, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); setSpop(S, null, true); } });
    /* klik buiten de laag en de pil sluit */
    on(document, 'pointerdown', function (e) {
      if (!S.spop) return;
      if (e.target.closest && (e.target.closest('[data-rlw-spop]') || e.target.closest('[data-rlw-pill]'))) return;
      setSpop(S, null, false);
    }, true);
  }
  function renderSummary(S) {
    var t = S.t, box = qs('[data-rlw-sum]', S.el); if (!box) return;
    var u = S.uid, f = S.spop === 'fr', b = S.spop === 'bud';
    box.innerHTML = '<button type="button" class="rlw-pill" data-rlw-pill="fr" aria-haspopup="dialog" aria-expanded="' + f + '" aria-controls="' + u + '-spop-fr" aria-label="' + esc(t.pillFr + t.fr[S.fr]) + '"><span class="v">' + esc(t.fr[S.fr]) + '</span>' + ICON.edit + '</button>' +
      '<button type="button" class="rlw-pill rlw-pill--num" data-rlw-pill="bud" aria-haspopup="dialog" aria-expanded="' + b + '" aria-controls="' + u + '-spop-bud" aria-label="' + esc(t.pillBud + S.eurInt(S.budget)) + '">' + esc(S.eurInt(S.budget)) + ICON.edit + '</button>';
    qsa('[data-pw]', S.el).forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-pw') === S.fr)); });
  }

  /* ---------------- bedieningsstrook op de resultaatpagina ---------------- */
  function renderTune(S) {
    var t = S.t, el = S.el;
    qsa('.rlw-tf', el).forEach(function (b) { var on = b.getAttribute('data-w') === S.fr; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
    qsa('.rlw-ts', el).forEach(function (b) { var on = b.getAttribute('data-ts') === S.style; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
    var sum = qs('[data-rlw-tunesum]', el); if (sum) sum.textContent = t.fr[S.fr] + ', ' + S.eurInt(S.budget);
    var ss = qs('[data-rlw-tssum]', el); if (ss) ss.textContent = t.sty[S.style] || '';
  }
  function setPop(S, open) { var p = qs('[data-rlw-tpop]', S.el), b = qs('[data-rlw-ttbtn]', S.el); if (!p) return;
    if (!open && S.noneSel && S.step === 3 && p.classList.contains('is-open')) { S.noneSel = false; S.types = []; syncTypes(S); changed(S); }
    p.classList.toggle('is-open', open); if (b) b.setAttribute('aria-expanded', String(open)); if (open) { placePop(S); requestAnimationFrame(function () { refitThumbs(S); }); } }
  /* het soortmenu past altijd volledig in beeld: hoogte begrensd door het venster en het kader, met een eigen scroll en Klaar
     vast onderaan; is er onder de knop te weinig plaats en boven meer, dan opent het omhoog. Op gsm zit het in het blad. */
  function placePop(S, p, b) {
    p = p || qs('[data-rlw-tpop]', S.el); b = b || qs('[data-rlw-ttbtn]', S.el); if (!p || !b) return;
    p.classList.remove('is-up'); p.style.removeProperty('--tp-mh'); p.style.removeProperty('transform');
    if (S.mode === 'm' || !p.classList.contains('is-open')) return;
    var r = b.getBoundingClientRect(), fr = S.el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    var below = Math.min(vh, fr.bottom) - r.bottom - 26, above = r.top - Math.max(0, fr.top) - 26;
    p.style.setProperty('--tp-mh', '2000px');
    var nat = p.offsetHeight, up = nat > below && above > below;
    p.classList.toggle('is-up', up);
    p.style.setProperty('--tp-mh', Math.round(Math.max(200, Math.min(nat, up ? above : below))) + 'px');
    /* horizontaal binnen het kader houden (het menu hangt rechts aan de knop) */
    p.style.removeProperty('transform');
    var pr = p.getBoundingClientRect(), dx = 0;
    if (pr.left < fr.left + 12) dx = fr.left + 12 - pr.left;
    else if (pr.right > fr.right - 12) dx = fr.right - 12 - pr.right;
    if (dx) p.style.transform = 'translateX(' + Math.round(dx) + 'px)';
  }
  function popOpen(S) { var p = qs('[data-rlw-tpop]', S.el); return !!(p && p.classList.contains('is-open')); }
  function setSPop(S, open) {
    var p = qs('[data-rlw-tspop]', S.el), b = qs('[data-rlw-tsbtn]', S.el); if (!p) return;
    p.classList.toggle('is-open', open); if (b) b.setAttribute('aria-expanded', String(open));
    if (open) { setPop(S, false); placePop(S, p, b); }
  }
  function sPopOpen(S) { var p = qs('[data-rlw-tspop]', S.el); return !!(p && p.classList.contains('is-open')); }
  function setSheet(S, open) {
    var wrap = qs('[data-rlw-tunewrap]', S.el), btn = qs('[data-rlw-tunebtn]', S.el); if (!wrap) return;
    var was = wrap.classList.contains('is-open');
    if (was === open) return;
    wrap.classList.toggle('is-open', open); if (btn) btn.setAttribute('aria-expanded', String(open));
    if (open) { var f = qs('.rlw-tf[aria-checked="true"]', S.el); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }, 60); }
    else if (S.mode === 'm' && S.step === 3 && btn) try { btn.focus({ preventScroll: true }); } catch (e) { /* negeren */ }
  }
  function sheetOpen(S) { var w = qs('[data-rlw-tunewrap]', S.el); return !!(w && w.classList.contains('is-open')); }
  function wireTune(S) {
    var el = S.el, on = S.on;
    on(qs('[data-rlw-tfr]', el), 'click', function (e) { var b = e.target.closest('.rlw-tf'); if (b) pickWorld(S, b.getAttribute('data-w'), b); });
    on(qs('[data-rlw-tsty]', el), 'click', function (e) {
      var b = e.target.closest('.rlw-ts'); if (!b) return;
      setStyle(S, b.getAttribute('data-ts'));
      if (S.mode !== 'm') { setSPop(S, false); var sb = qs('[data-rlw-tsbtn]', el); if (sb) try { sb.focus({ preventScroll: true }); } catch (er) { /* negeren */ } }
    });
    on(qs('[data-rlw-tsbtn]', el), 'click', function () { setSPop(S, !sPopOpen(S)); });
    on(document, 'click', function (e) { if (sPopOpen(S) && !e.target.closest('.rlw-tstyw')) setSPop(S, false); });
    on(window, 'resize', function () { if (sPopOpen(S)) placePop(S, qs('[data-rlw-tspop]', el), qs('[data-rlw-tsbtn]', el)); });
    on(qs('[data-rlw-tpop]', el), 'click', function (e) {
      if (e.target.closest('[data-rlw-tpdone]')) { setPop(S, false); var tb = qs('[data-rlw-ttbtn]', el); if (tb) try { tb.focus({ preventScroll: true }); } catch (er) { /* negeren */ } return; }
      if (e.target.closest('[data-alltypes]')) { allTypesClick(S, true); return; }
      var b = e.target.closest('.rlw-tt'); if (b) toggleType(S, b.getAttribute('data-type'), true);
    });
    on(qs('[data-rlw-ttbtn]', el), 'click', function () { if (!popOpen(S)) setSPop(S, false); setPop(S, !popOpen(S)); });
    on(window, 'resize', function () { if (popOpen(S)) placePop(S); });
    on(document, 'click', function (e) { if (popOpen(S) && !e.target.closest('.rlw-ttyp')) setPop(S, false); });
    on(qs('[data-rlw-tunebtn]', el), 'click', function () { setSheet(S, !sheetOpen(S)); });
    on(qs('[data-rlw-tdone]', el), 'click', function () { setSheet(S, false); });
    on(qs('[data-rlw-tback]', el), 'click', function () { setSheet(S, false); });
    [qs('[data-rlw-tfr]', el), qs('[data-rlw-tsty]', el)].forEach(function (grp) {
      on(grp, 'keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }; if (!(e.key in keys)) return;
        e.preventDefault(); e.stopPropagation();
        if (grp.hasAttribute('data-rlw-tfr')) { var n = FR_ORDER[(FR_ORDER.indexOf(S.fr) + keys[e.key] + 4) % 4], b = qs('.rlw-tf[data-w="' + n + '"]', el); pickWorld(S, n, b); if (b) b.focus({ preventScroll: true }); }
        else { var s = nextStyle(S, keys[e.key]); setStyle(S, s); var sb = qs('.rlw-ts[data-ts="' + s + '"]', el); if (sb) sb.focus({ preventScroll: true }); }
      });
    });
  }

  /* ================= stap 3: de selectie ================= */
  function cardHTML(S, row) {
    var p = row.p, t = S.t, st = fullTitle(p.title);
    return '<article class="rlw-card" data-h="' + esc(p.handle) + '">' +
      '<div class="rlw-sw"><div class="rlw-stage" data-h3="' + esc(p.handle) + '" role="button" tabindex="0" aria-label="' + esc(t.openAria(st)) + '">' +
      '<div class="rlw-fb"><img alt="" decoding="async" draggable="false" src="' + esc(S.ctx.img(p.handle)) + '" data-area="' + fitArea(p) + '"></div><div class="rlw-3d"></div></div>' +
      '<span class="rlw-qb"' + (row.qty > 1 ? '' : ' hidden') + '>' + row.qty + 'x</span>' +
      '<span class="rlw-3db" aria-hidden="true" title="' + esc(t.hover3d) + '">3D</span>' +
      '<span class="rlw-dh" aria-hidden="true">' + ICON.drag + '<span class="t">' + esc(t.dh) + '</span></span></div>' +
      '<div class="rlw-cm"><p class="rlw-kind">' + esc(kindOf(p, S.lang)) + '</p><button type="button" class="rlw-name" data-act="open" title="' + esc(p.title) + '" aria-label="' + esc(t.openAria(st)) + '">' + esc(st) + '</button><p class="rlw-price">' + esc(S.eur(p.price)) + '</p>' +
      '<div class="rlw-ctl"><div class="rlw-stepper" role="group" aria-label="' + esc(t.qtyAria(st)) + '"><button type="button" data-act="minus" aria-label="' + esc(t.minus) + '">' + ICON.minus + '</button><output>' + row.qty + '</output><button type="button" data-act="plus" aria-label="' + esc(t.plus) + '">' + ICON.plus + '</button></div>' +
      '<i class="dv" aria-hidden="true"></i><button type="button" class="rlw-ib" data-act="swap" aria-label="' + esc(t.swap) + '" title="' + esc(t.swapT) + '">' + ICON.swap + '</button>' +
      '<i class="dv" aria-hidden="true"></i><button type="button" class="rlw-ib" data-act="remove" aria-label="' + esc(t.remove) + '" title="' + esc(t.removeT) + '">' + ICON.x + '</button></div></div></article>';
  }
  /* de foto op dezelfde maat en plek als het 3D-model van mountHero3D (oppervlakte 50% of 72%, onderaan met FIT_GAP lucht),
     zodat de 3D zonder sprong over de foto kruisfadet */
  function fitArea(p) { return /Booster Pack|Blister|Double Pack/i.test((p && p.kind) || '') ? .5 : .72; }
  /* productkader per uitsnede (cutmeta.py, in de pagina als #cut-meta): bb = fractie van de foto, ar = verhouding van het kader */
  function cutMetaOf(S, h) {
    if (!S.cm) { try { var el = document.getElementById('cut-meta'); S.cm = el ? JSON.parse(el.textContent) : {}; } catch (e) { S.cm = {}; } }
    return S.cm[h] || null;
  }
  /* de foto krijgt exact dezelfde kadrering als het 3D-model van mountHero3D (app.js): het productkader (cut-meta bb) op de
     doelrechthoek die de pool voor het model berekent (zelfde formule, zelfde vaste verhouding cm.ar, onderaan gecentreerd,
     FIT_GAP lucht voor de contactschaduw). Zo kruisfadet het model over de foto zonder schaal- of positiesprong. */
  function fitImg(img, forceH) {
    var fb = img && img.parentNode, box = fb && fb.parentNode; if (!box) return;
    var W = box.clientWidth, Hb = box.clientHeight - FIT_GAP, nw = img.naturalWidth, nh = img.naturalHeight;
    if (W < 8 || Hb < 8 || !nw || !nh) return;
    var cm = img._rlwCm || null, bb = cm && cm.bb && cm.bb.length === 4 ? cm.bb : [0, 0, 1, 1];
    var fw = Math.max(1, (bb[2] - bb[0]) * nw), fh = Math.max(1, (bb[3] - bb[1]) * nh);
    var ar = cm && cm.ar > 0 ? cm.ar : fw / fh, area = +img.getAttribute('data-area') || .5;
    var h = forceH > 0 ? forceH : Math.min(Math.sqrt(area * W * Hb / ar), (W * .9) / ar, Hb * .96), w = h * ar;
    var sc = h / fh, iw = nw * sc, ih = nh * sc, left = (W - w) / 2 - bb[0] * nw * sc, top = (Hb - h) - bb[1] * nh * sc;
    img.style.width = iw.toFixed(1) + 'px'; img.style.height = ih.toFixed(1) + 'px';
    img.style.left = left.toFixed(1) + 'px'; img.style.top = top.toFixed(1) + 'px';
    box._rlwPhoto = { x: (W - w) / 2, y: Hb - h, w: w, h: h }; /* doelrechthoek (voor de meting in tests) */
  }
  function refitAll(S) { qsa('.rlw-fb img', S.el).forEach(function (img) { fitImg(img); }); }
  function wireImg(S, stage) {
    var img = qs('.rlw-fb img', stage); if (!img) return;
    img._rlwCm = cutMetaOf(S, stage.getAttribute('data-h3'));
    var ok = function () { fitImg(img); stage.classList.add('rlw-fbok'); };
    if (img.complete && img.naturalWidth) ok(); else { img.addEventListener('load', ok, { once: true }); img.addEventListener('error', function () { img.style.visibility = 'hidden'; }, { once: true }); }
  }
  /* ---------------- 3D via de pool van de pagina (ctx.mount3D), enkel op vraag (eigenaar 9 okt, "3D bij hover") ----------------
     Standaard toont elke kaart de stilstaande uitsnede op de doelrechthoek van het model (fitImg); automatisch 3D liet de
     pagina haperen en de wissel foto naar 3D oogde vreemd. Desktop: 120 ms hover op het beeldvak haalt het model uit de pool,
     het wordt op de foto gelegd (fit3D) en neemt na het eerste frame over (kruisfade 200 ms); na het verlaten blijft het
     4 s staan en gaat dan terug naar de pool (foto terug, kruisfade). Gsm: enkel de actieve slide, na 600 ms stilstand.
     Hoogstens de pool-limiet tegelijk; de oudste niet-gehoverde eerst vrij. */
  var HOVER_MS = 120, LINGER_MS = 4000, SLIDE_MS = 600;
  function poolMax() { return (window.matchMedia && window.matchMedia('(min-width:1100px)').matches) ? 6 : 3; }
  function want3D(S, stage) {
    if (!stage || !stage.isConnected || S.step !== 3 || stage.classList.contains('rlw-no3d')) return;
    stage._rlwT = nowMs();
    clearTimeout(stage._rlwRel); stage._rlwRel = 0;
    if (S.ctls.has(stage)) return;
    while (S.ctls.size >= poolMax()) {
      var old = null;
      S.ctls.forEach(function (c, st) { if (st !== stage && !st._rlwHov && (!old || (st._rlwT || 0) < (old._rlwT || 0))) old = st; });
      if (!old) return; /* alles in gebruik: de foto blijft */
      kill3D(S, old);
    }
    attach3D(S, stage);
    if (!S.ctls.has(stage)) stage.classList.add('rlw-no3d'); /* geen model voor dit product: badge weg, foto blijft */
  }
  function release3D(S, stage, delay) {
    clearTimeout(stage._rlwRel);
    stage._rlwRel = setTimeout(function () {
      stage._rlwRel = 0;
      if (!getState(S.el) || stage._rlwHov || !S.ctls.has(stage)) return;
      /* eerst de kruisfade (model weg, foto terug), dan pas teruggeven aan de pool: geen sprong */
      stage.classList.remove('rlw-3don');
      setTimeout(function () { if (!stage._rlwHov && S.ctls.has(stage)) kill3D(S, stage); }, 220);
    }, delay);
  }
  function wireHover3D(S) {
    var on = S.on;
    on(S.body, 'pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var st = e.target.closest && e.target.closest('.rlw-stage'); if (!st || st._rlwHov || !S.body.contains(st)) return;
      st._rlwHov = true; clearTimeout(st._rlwRel); st._rlwRel = 0;
      clearTimeout(st._rlwHt); st._rlwHt = setTimeout(function () { if (st._rlwHov) want3D(S, st); }, HOVER_MS);
    });
    on(S.body, 'pointerout', function (e) {
      var st = e.target.closest && e.target.closest('.rlw-stage'); if (!st || !st._rlwHov) return;
      if (e.relatedTarget && st.contains(e.relatedTarget)) return;
      st._rlwHov = false; clearTimeout(st._rlwHt);
      if (S.ctls.has(st)) release3D(S, st, LINGER_MS);
    });
    /* gsm: de actieve slide (meest zichtbaar in de carrousel) na 600 ms stilstand; de andere geven hun model vrij */
    on(S.body, 'scroll', function () { if (S.mode === 'm') slideSoon(S); }, { passive: true });
    if (S.scr) on(S.scr, 'scroll', function () { if (S.mode === 'm') slideSoon(S); }, { passive: true });
  }
  function slideSoon(S) {
    clearTimeout(S.slideT);
    S.slideT = setTimeout(function () {
      if (!getState(S.el) || S.mode !== 'm' || S.step !== 3) return;
      /* gsm-raster (2 kolommen, verticaal in de scrollzone) of carrousel: de kaart met het grootste zichtbare oppervlak */
      var br = S.body.getBoundingClientRect(), vr = S.scr ? S.scr.getBoundingClientRect() : br, best = null, bestV = 0;
      var top = Math.max(br.top, vr.top), bot = Math.min(br.bottom, vr.bottom);
      qsa('.rlw-stage', S.body).forEach(function (st) {
        var r = st.getBoundingClientRect(), v = Math.max(0, Math.min(r.right, br.right) - Math.max(r.left, br.left)) * Math.max(0, Math.min(r.bottom, bot) - Math.max(r.top, top));
        if (v > bestV) { bestV = v; best = st; }
      });
      S.ctls.forEach(function (c, st) { if (st !== best) release3D(S, st, 0); });
      if (best) want3D(S, best);
    }, SLIDE_MS);
  }
  var ATT_GAP = 160;
  var ATT_GAP = 160;
  function attach3D(S, stage) {
    if (!stage || !stage.isConnected || S.ctls.has(stage) || !S.ctx.mount3D) return;
    var d = qs('.rlw-3d', stage), h = stage.getAttribute('data-h3'), ctl = null;
    if (!d || !h) return;
    try { ctl = S.ctx.mount3D(d, h); } catch (e) { ctl = null; }
    if (!ctl) return; /* geen model voor dit product of pool vol: de foto blijft */
    S.ctls.set(stage, ctl);
    /* zodra de pool het model heeft (cws-h3d on): eerst exact op de foto leggen (fit3D), dan pas zichtbaar (kruisfade 260 ms) */
    if (!d._rlwOn) { d._rlwOn = 1; d.addEventListener('cws-h3d', function (e) {
      var on = !!(e.detail && e.detail.on);
      if (!on) { stage.classList.remove('rlw-3don'); return; }
      if (!fit3D(S, stage)) d._rlwFitTry = d.clientWidth + 'x' + d.clientHeight;
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (!S.ctls.has(stage) || !d.classList.contains('cws-h3d-on')) return;
        if (!d._rlwFitKey && fit3D(S, stage)) d._rlwFitTry = null; /* de motor had nog geen geldige projectie: nog eens, voor de kruisfade */
        stage.classList.add('rlw-3don');
      }); });
    }); }
    if (d.classList.contains('cws-h3d-on')) stage.classList.add('rlw-3don');
  }
  /* enkel nog voor een kaart die er al om vroeg (hover of actieve slide), bv. na wisselen of een maatwijziging */
  function attQueue(S, stage) {
    if (!stage || S.ctls.has(stage) || S.attQ.indexOf(stage) !== -1) return;
    if (!stage._rlwHov && !(S.mode === 'm' && stage._rlwT)) return;
    S.attQ.push(stage);
    if (!S.attT) S.attT = setTimeout(function () { attPump(S); }, 20);
  }
  function attPump(S) {
    S.attT = 0;
    if (!getState(S.el)) return;
    var st;
    while ((st = S.attQ.shift()) && !st.isConnected) { /* weg intussen: overslaan */ }
    if (st) attach3D(S, st);
    if (S.attQ.length) S.attT = setTimeout(function () { attPump(S); }, ATT_GAP);
  }
  function kill3D(S, stage) {
    var ctl = S.ctls.get(stage);
    if (ctl) { try { ctl.destroy(); } catch (e) { /* negeren */ } S.ctls.delete(stage); }
    if (stage) { stage.classList.remove('rlw-3don'); qsa('.cws-h3d-ph', stage).forEach(function (n) { n.remove(); }); /* placeholder van de pool opruimen */ }
    var i = S.attQ.indexOf(stage); if (i !== -1) S.attQ.splice(i, 1);
  }
  /* na een onthulling of herbouw: geen automatisch 3D meer (enkel bij hover); op gsm de actieve slide na stilstand */
  function mount3D(S) {
    if (S.step !== 3) return;
    armHint(S);
    if (S.mode === 'm') slideSoon(S);
  }
  function unmount3D(S) {
    clearTimeout(S.attT); S.attT = 0; S.attQ = []; clearTimeout(S.slideT);
    qsa('.rlw-stage', S.el).forEach(function (st) { clearTimeout(st._rlwRel); clearTimeout(st._rlwHt); st._rlwRel = 0; });
    Array.from(S.ctls.keys()).forEach(function (st) { kill3D(S, st); });
  }
  /* ---------------- 3D: rustig wiegen als niemand het aanraakt (zoals rip-lab-i2c) ----------------
     app.js pauzeert een pool-instantie zolang de actieve scene van de feed niet het startscherm is (in de Clean-laag stond het
     model daardoor stil): deze lus zet de instanties van onze vakken zelf aan zolang ze in beeld zijn, en wiegt ze zachtjes. */
  var SWAY_IDLE = 1400;
  function swayStart(S) {
    if (S.swayRaf || !getState(S.el) || document.hidden) return;
    var f = function (t) {
      S.swayRaf = 0;
      if (!getState(S.el)) return;
      if (document.hidden || !isShown(S) || S.step !== 3) { swayPauseAll(S); return; }
      swayTick(S, t);
      S.swayRaf = requestAnimationFrame(f);
    };
    S.swayRaf = requestAnimationFrame(f);
  }
  function swayEach(S, fn) {
    var k = 0;
    S.ctls.forEach(function (ctl, stage) {
      k++;
      var d = qs('.rlw-3d', stage); if (!d) return;
      var inst = d._h3d;
      if (!inst || !inst.pointer || !inst.owns || !inst.owns(d)) return;
      fn(d, inst, k);
    });
  }
  function swayRun(d, inst, want, t) {
    if (d._rlwInst !== inst || d._rlwRun !== want || (want && t - (d._rlwRunT || 0) > 1000)) {
      d._rlwInst = inst; d._rlwRun = want; d._rlwRunT = t;
      try { inst.pause(!want); } catch (e) { /* negeren */ }
    }
  }
  function swayPauseAll(S) { var t = nowMs(); swayEach(S, function (d, inst) { swayRun(d, inst, false, t); }); }
  function swayTick(S, t) {
    swayEach(S, function (d, inst, k) {
      var vis = !(d._h3dM && !d._h3dM.vis);
      swayRun(d, inst, vis, t);
      /* vangnet: een model dat nog niet (of op een andere maat) op de foto gelegd is, alsnog passen */
      var fk = d.clientWidth + 'x' + d.clientHeight;
      if (vis && d._rlwFitKey !== fk && d._rlwFitTry !== fk && d.parentNode && d.parentNode.classList.contains('rlw-3don')) { if (!fit3D(S, d.parentNode)) d._rlwFitTry = fk; }
      if (!vis || S.RM) return;
      if (S.swayDown === d || d.classList.contains('cws-h3d-hov') || t - (d._rlwLast || 0) < SWAY_IDLE) return;
      if (d._rlwPh == null) d._rlwPh = (k * 1931) % 7000;
      inst.pointer(Math.sin((t + d._rlwPh) / 1400) * .38, Math.cos((t + d._rlwPh) / 1900) * .1);
    });
  }
  function wireSway(S) {
    var mark = function (e) { var d = e.target && e.target.closest && e.target.closest('.rlw-3d'); if (d) d._rlwLast = nowMs(); return d; };
    S.on(S.el, 'pointermove', mark, { passive: true });
    S.on(S.el, 'pointerdown', function (e) { S.swayDown = mark(e); }, { passive: true });
    var up = function () { if (S.swayDown) { S.swayDown._rlwLast = nowMs(); S.swayDown = null; } };
    S.on(window, 'pointerup', up); S.on(window, 'pointercancel', up);
    S.on(document, 'visibilitychange', function () { if (!document.hidden) swayStart(S); });
    swayStart(S);
  }

  /* ---------------- opbouw, raster, navigatie ---------------- */
  function buildSelection(S) {
    unmount3D(S);
    if (!S.items.length) { renderEmpty(S); updateMeter(S, true); updateHead(S); return; }
    S.body.classList.remove('is-empty');
    S.body.innerHTML = S.items.map(function (r) { return cardHTML(S, r); }).join('');
    qsa('.rlw-stage', S.body).forEach(function (st) { wireImg(S, st); });
    syncControls(S); updateMeter(S, true); updateHead(S);
  }
  function renderEmpty(S) {
    var t = S.t, h;
    S.body.classList.add('is-empty');
    if (S.cheapest != null && S.budget < S.cheapest) {
      var need = Math.ceil(S.cheapest / 5) * 5;
      h = '<div class="rlw-emptysel"><span class="ic">' + ICON.empty + '</span><h3>' + esc(t.eTightH) + '</h3><p>' + esc(t.eTightP(t.fr[S.fr], S.eur(S.cheapest), S.eurInt(need))) + '</p><button type="button" class="rlw-btn rlw-btn--pri" data-fix="' + need + '">' + esc(t.eTightB(S.eurInt(need))) + '</button></div>';
    } else {
      h = '<div class="rlw-emptysel"><span class="ic">' + ICON.empty + '</span><h3>' + esc(t.eEmptyH) + '</h3><p>' + esc(t.eEmptyP) + '</p><button type="button" class="rlw-btn rlw-btn--pri" data-redo>' + esc(t.eEmptyB) + '</button></div>';
    }
    S.body.innerHTML = h;
  }
  /* gelijk raster: tot 4 per rij, 5 tot 8 in twee rijen als er hoogte is; met minder dan 3 blijven de kaarten even groot als bij 3 */
  function foldFit(S, ch) {
    var sec = qs('[data-rlw-tk]', S.el); if (!sec || sec.hidden) return;
    var head = qs('.rlw-tkhead', sec) || sec, f = feedOf(), y = f ? f.scrollTop : 0;
    var want = head.getBoundingClientRect().bottom + y + 70, vh = window.innerHeight || document.documentElement.clientHeight;
    var over = Math.ceil(want - vh);
    if (over > 0) { var c2 = Math.max(260, ch - over); if (c2 < ch) S.body.style.setProperty('--ch', c2 + 'px'); }
  }
  function layoutGrid(S) {
    var n = qsa('.rlw-card', S.body).length;
    S.body.classList.toggle('is-empty', n === 0);
    if (S.mode === 'd') {
      var h = S.pg ? pageBodyH(S) : S.scr ? S.scr.clientHeight - (S.scr.classList.contains('has-top') ? 48 : 0) : S.body.clientHeight, W = S.body.clientWidth;
      var rows = n > 4 && h >= 440 ? 2 : 1;
      /* per rij zoveel kaarten als er bij minstens CARD_MIN px breedte passen (4 tot 6): op 1728 passen 5 of 6 kaarten
         zonder schuiven, op 1280 vier; pas daarboven schuift de strook (pijlen) en staat de eerste kaart altijd helemaal in
         beeld (css: justify-content start, safe center) */
      var maxVis = clamp(Math.floor((W + 14) / (CARD_MIN + 14)), 4, 6);
      /* vanaf 7 producten (eigenaar 9 okt): een raster van rijen met de kaartgrootte van de rij van 6, verticaal scrollend
         binnen de strook; strook bovenaan en voetbalk onderaan blijven staan (eigen rijen van de scene), geen pijlen.
         De hoogte laat de volgende rij nog zien, zodat je weet dat er meer is. 3D enkel voor wat in beeld is (pool). */
      /* raster ook als de kaarten niet in de rijen passen (lage schermen: anders zijn de laatste kaarten zonder pijlen onbereikbaar) */
      var grid = n > 6 || n > maxVis * rows;
      /* paginascroll (html.rlw-pagescroll): altijd rijen die volledig meegroeien, geen vaste hoogte en geen eigen scrollvak;
         enkel de pagina scrolt. Een korte selectie blijft een enkele rij op de volle kaarthoogte. */
      if (S.pg) { grid = true; S.body.style.removeProperty('height'); }
      S.body.classList.toggle('is-grid', grid);
      if (grid) {
        var cols = S.pg && n <= maxVis ? Math.max(3, n) : maxVis;
        var cw = (W - 14 * (cols - 1)) / cols, ch = Math.round(Math.max(220, Math.min(h * (S.pg && n <= maxVis ? 1 : .86), cw * 1.3)));
        S.body.style.setProperty('--vis', cols); S.body.style.setProperty('--rows', 1); S.body.style.setProperty('--ch', ch + 'px');
        /* (10 okt) een rij producten: de kaarten net zo laag maken dat de knop Bekijk de topkaarten en de kop van de
           topkaarten (met het begin van de rij) zonder scrollen in beeld staan; nooit lager dan 260 px */
        if (S.pg && n <= maxVis) foldFit(S, ch);
      } else {
        var vis = Math.max(3, Math.min(maxVis, Math.ceil(n / rows)));
        S.body.style.setProperty('--rows', rows); S.body.style.setProperty('--vis', vis);
      }
    }
    refitAll(S); refit3D(S);
    updateNav(S);
  }
  var CARD_MIN = 236;
  /* het 3D-model opnieuw in zijn vak passen als het vak van maat verandert (1 of 2 rijen, breedte): dezelfde regel als
     mountHero3D in app.js (oppervlakte 50% of 72%, hoogstens 96% van de hoogte boven de contactschaduw en 96% van de breedte),
     via retarget van de motor zonder de scene opnieuw op te bouwen. Zo valt geen enkel product buiten zijn vak, ook een
     staand pack in een laag vak van twee rijen. */
  /* het model exact op de foto: het silhouet van het model (debugFrame, met zijvlak) krijgt dezelfde hoogte, onderkant en
     midden als het productkader van de foto; past dat silhouet niet in de breedte, dan krimpen foto en model samen. Zo
     kruisfadet het model zonder sprong; geen hoogte- of breedtesprong meer tussen foto en model (eigenaar 9 okt). */
  function fit3D(S, stage) {
    var d = qs('.rlw-3d', stage), inst = d && d._h3d;
    if (!inst || !inst.owns || !inst.owns(d) || !inst.retarget || !inst.debugFrame) return false;
    var W = d.clientWidth, H = d.clientHeight; if (W < 8 || H < 8) return false;
    var fr = null; try { fr = inst.debugFrame(); } catch (e) { fr = null; }
    var pw = fr && fr.proj && fr.proj.w, phh = fr && fr.proj && fr.proj.h;
    if (!(pw > 4) || !(phh > 4)) return false;
    var img = qs('.rlw-fb img', stage), Hb = H - FIT_GAP, rho = pw / phh, ph = stage._rlwPhoto, h;
    if (ph && ph.h > 4) h = ph.h;
    else { var hd = stage.getAttribute('data-h3'), p = S.byH[hd] || {}, ar = (S.ctx.ar && +S.ctx.ar(hd)) || rho; h = Math.min(Math.sqrt(fitArea(p) * W * Hb / ar), (W * .9) / ar, Hb * .96); }
    var w = h * rho, k = Math.min(1, (W * .96) / w, (Hb * .96) / h);
    if (k < 1) { w *= k; h *= k; if (img && ph) fitImg(img, h); }
    d._rlwFitKey = W + 'x' + H;
    try { inst.retarget({ x: (W - w) / 2, y: Hb - h, w: w, h: h }, d); } catch (e) { return false; }
    return true;
  }
  /* het vak veranderde duidelijk van maat (1 of 2 rijen, breedte): het model opnieuw uit de pool halen, zodat de motor
     vers op de nieuwe maat past en het daarna weer exact op de (al herpaste) foto komt; een gepauzeerde of verouderde
     projectie kan zo nooit buiten het vak blijven hangen */
  function refit3D(S) {
    Array.from(S.ctls.keys()).forEach(function (stage) {
      var d = qs('.rlw-3d', stage); if (!d) return;
      var W = d.clientWidth, H = d.clientHeight, m = /^(\d+)x(\d+)$/.exec(d._rlwFitKey || '');
      if (W < 8 || H < 8) return;
      if (m && Math.abs(+m[1] - W) <= 6 && Math.abs(+m[2] - H) <= 6) return;
      /* nooit gepast (fit3D faalde of nog aan het laden): niet herladen, de wieglus probeert opnieuw bij een andere maat */
      if (!m) return;
      kill3D(S, stage); d._rlwFitKey = null; d._rlwFitTry = null;
      if (stage._rlwHov) want3D(S, stage); else if (S.mode === 'm') slideSoon(S);
    });
  }
  function updateNav(S) {
    var sc = S.body, cards = qsa('.rlw-card', sc), t = S.t;
    var over = S.mode === 'm' && sc.scrollWidth > sc.clientWidth + 4; /* desktop: geen pijlen (rij of verticaal raster) */
    var p = qs('[data-rlw-gprev]', S.el), x = qs('[data-rlw-gnext]', S.el), cnt = qs('[data-rlw-gcount]', S.el);
    p.hidden = !over; x.hidden = !over;
    p.disabled = sc.scrollLeft <= 2; x.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2;
    if (over && cards.length > 1) {
      var w = cards[0].getBoundingClientRect().width + 10;
      cnt.textContent = t.countOf(Math.min(cards.length, Math.round(sc.scrollLeft / Math.max(1, w)) + 1), cards.length); cnt.hidden = false;
    } else cnt.hidden = true;
  }
  function nav(S, d) { var sc = S.body; sc.scrollBy({ left: d * sc.clientWidth * .82, behavior: S.RM ? 'auto' : 'smooth' }); }
  /* ---------------- Topkaarten uit je sets (eigenaar 9 okt): puur informatief, zoals de sectie "Topkaarten uit deze
     sets" van de pagina. Data: de PriceDex-snapshot die de pagina al heeft (window.CW_RS_TOPCARDS = TOPCARDS uit app.js:
     products wijst een producthandle naar een setsleutel, sets[sleutel].info en .cards met k, n, no, r, im, pr, u, ab).
     Geen sommen, geen kansen of verwachte waarde: per kaart enkel de PriceDex-prijs van de snapshot. Klik opent de
     PriceDex-kaartweergave van de pagina (window.PDXModal.open(k)), anders de PriceDex-pagina in een nieuw tabblad. */
  var TK_MAX = 20; /* per set de top 20 (op prijs) in een horizontaal scrollende rij */
  function topData() { try { var d = window.CW_RS_TOPCARDS; return d && d.products && d.sets ? d : null; } catch (e) { return null; } }
  /* Waarom soms maar 1 set (9 okt): TOPCARDS.products koppelt maar 155 van de 233 producten aan een set (topcards.py).
     Tins, collecties en posterboxen missen vaak een koppeling (bv. Pokemon GO Tin), en random tins hebben geen vaste set.
     Daarom: eerst de koppeling van TOPCARDS, anders de setnaam (of de One Piece-setcode) in de titel van het product,
     binnen dezelfde franchise; een titel met twee sets (Black Bolt en White Flare) geeft twee rijen. */
  function normT(x) { return ' ' + String(x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }
  function setKeysFor(S, D, p) {
    if (D.products[p.handle]) return [D.products[p.handle]];
    S.tkSetIdx = S.tkSetIdx || Object.keys(D.sets).filter(function (k) { var st = D.sets[k]; return st && st.cards && st.cards.length; }).map(function (k) {
      var info = D.sets[k].info || {}, words = normT(info.name).trim().split(' ').filter(function (w) { return w && w !== 'pokemon'; });
      return { k: k, words: words, code: /^one-piece/.test(k) ? normT(info.code || k.split('|')[1]).replace(/ /g, '') : '' };
    });
    var t = normT(p.title), tc = t.replace(/ /g, ''), fr = frOf(p), out = [];
    S.tkSetIdx.forEach(function (x) {
      if ((fr === 'pk') !== /^pokemon\|/.test(x.k) || (fr === 'op') !== /^one-piece\|/.test(x.k)) return;
      var hit = x.words.length && x.words.every(function (w) { return t.indexOf(' ' + w + ' ') !== -1; });
      if (!hit && x.code && x.code.length >= 3 && tc.indexOf(x.code) !== -1) hit = true;
      if (hit) out.push(x.k);
    });
    return out;
  }
  /* beeld van de setkop (10 okt): een gewoon product van die set uit de volledige catalogus van de pagina, liefst de booster
     pack, anders ETB, booster bundle of booster box; nooit CARDWORLD-eigen of speciale producten (Kluis, CARDWORLD,
     Mystery) of random tins. Niets gevonden: het product uit de selectie. */
  var SET_IMG_SKIP = /kluis|cardworld|mystery|random|vault/i;
  function setImgHandle(S, D, key, fb) {
    S.setImg = S.setImg || {};
    if (S.setImg[key]) return S.setImg[key];
    var M = metaAll(S) || [], best = null, bestR = 9;
    var rank = function (c) { return /Booster Pack|Sleeved/i.test(c) ? 0 : /Elite Trainer|ETB/i.test(c) ? 1 : /Bundle/i.test(c) ? 2 : /Booster Box/i.test(c) ? 3 : 5; };
    M.forEach(function (m) {
      if (D.products[m.h] !== key || SET_IMG_SKIP.test(m.t || '') || SET_IMG_SKIP.test(m.h)) return;
      var r = rank(m.scat || ''); if (r < bestR) { bestR = r; best = m.h; }
    });
    S.setImg[key] = best || fb;
    return S.setImg[key];
  }
  /* sets van een product uit het metafield custom.tcg_set_id, op dezelfde publieke manier als de productpagina die ze krijgt:
     de productsectie van de shop (Section Rendering API, anders de volledige productpagina) bevat
     var metafieldSetId = "OP15,OP-16". Zelfde ontleding als cwpParseSetList (cw-product-chase-multi.liquid). Per product
     een keer, in sessionStorage (6 uur). null = nog bezig of onbekend, [] = geen sets. */
  var MS_SECTION = 'template--26277065261405__cw-product-main';
  function parseSetList(raw) {
    if (!raw || typeof raw !== 'string') return null;
    var out = [], parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var q = parts[i].trim(); if (!q) continue;
      if (q.indexOf(' ') !== -1 || !/^[a-z0-9][a-z0-9-]*$/i.test(q)) return null;
      q = q.toLowerCase(); if (out.indexOf(q) === -1) out.push(q);
    }
    return out.length ? out : null;
  }
  function msOf(S, p) {
    S.ms = S.ms || {};
    if (p.handle in S.ms) return S.ms[p.handle];
    var ck = 'rlw-ms1-' + p.handle, hit = null;
    try { hit = JSON.parse(sessionStorage.getItem(ck) || 'null'); } catch (e) { hit = null; }
    if (hit && hit.at && Date.now() - hit.at < PDX_TTL) return (S.ms[p.handle] = hit.keys || []);
    S.ms[p.handle] = null;
    if (!window.fetch) { S.ms[p.handle] = []; return []; }
    var fr = frOf(p) === 'op' ? 'one-piece' : frOf(p) === 'pk' ? 'pokemon' : '';
    var grab = function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); }); };
    var base = '/products/' + encodeURIComponent(p.handle);
    grab(base + '?section_id=' + MS_SECTION).catch(function () { return grab(base); }).then(function (html) {
      var m = /metafieldSetId\s*=\s*"([^"]*)"/.exec(html || ''), ids = m ? parseSetList(m[1]) : null;
      var keys = fr && ids ? ids.map(function (id) { return fr + '|' + id; }) : [];
      S.ms[p.handle] = keys;
      try { sessionStorage.setItem(ck, JSON.stringify({ at: Date.now(), keys: keys })); } catch (e) { /* vol of privévenster */ }
      if (keys.length && getState(S.el)) renderTopSoon(S);
    }).catch(function () { S.ms[p.handle] = []; });
    return null;
  }
  function renderTopSoon(S) { if (S.tkRaf) return; S.tkRaf = requestAnimationFrame(function () { S.tkRaf = 0; if (getState(S.el)) renderTop(S); }); }
  function renderTop(S) {
    var D = topData(), sec = qs('[data-rlw-tk]', S.el), hint = qs('[data-rlw-tkhintw]', S.el), rows = qs('[data-rlw-tkrows]', S.el), t = S.t;
    S.tkBad = S.tkBad || {};
    if (!sec || !rows) return;
    var sets = [], seen = {}, noFix = [], noData = [], subKeys = [];
    var spOf = function (c) { return c.sp != null ? c.sp : (c.pr || 0); };
    if (D) S.items.forEach(function (x) {
      var keys = setKeysFor(S, D, x.p);
      /* (10 okt) product met sets uit het metafield custom.tcg_set_id (komma-lijst, bv. Illustration Box: OP15,OP-16),
         zoals de productpagina: alle sets live ophalen, samenvoegen, duurste eerst, top 20, geen ontdubbeling op naam */
      var msq = !keys.length && !/random/i.test(x.p.title), ms = msq ? msOf(S, x.p) : null;
      if (msq && ms === null) return; /* sets worden nog opgehaald: nog geen rij (ook geen "geen topkaarten") */
      if (ms && ms.length) {
        var mk = 'multi:' + x.p.handle; if (seen[mk]) return; seen[mk] = 1;
        ms.forEach(function (k) { subKeys.push(k); });
        var got = []; ms.forEach(function (k) { (S.tkLive && S.tkLive[k] || []).forEach(function (c) { got.push(c); }); });
        if (!got.length) { noData.push(x.p); return; }
        got.sort(function (a, b) { return spOf(b) - spOf(a); });
        var okm = got.filter(function (c) { return c.im && !S.tkBad[c.im]; });
        var topm = got.reduce(function (m, c) { return !m || (c.pr || 0) > (m.pr || 0) ? c : m; }, null);
        var lbl = ms.map(function (k) { var id = k.split('|')[1] || ''; return k.indexOf('one-piece|') === 0 ? id.toUpperCase().replace(/^([A-Z]+)-?(\d+)$/, '$1-$2') : (((D.sets[k] || {}).info || {}).name || id); }).join(' + ');
        sets.push({ key: mk, info: { name: lbl }, handle: x.p.handle, price: x.p.price, top: topm, cards: okm.slice(0, TK_MAX), res: okm.slice(TK_MAX), live: got.length });
        return;
      }
      if (!keys.length) { (/random/i.test(x.p.title) ? noFix : noData).push(x.p); return; }
      keys.forEach(function (key) {
      var st = D.sets[key];
      if (seen[key]) return;
      if (!st || !st.cards || !st.cards.length) { seen[key] = 1; noData.push(x.p); return; }
      seen[key] = 1;
      /* kaarten waarvan het beeld eerder niet laadde (S.tkBad) vooraf overslaan; de rest is reserve voor een beeld dat faalt */
      var live = S.tkLive && S.tkLive[key];
      var all = (live && live.length ? live : st.cards).slice().sort(function (a, b) { return spOf(b) - spOf(a); });
      var top = all.reduce(function (m, c) { return !m || (c.pr || 0) > (m.pr || 0) ? c : m; }, null);
      var ok = all.filter(function (c) { return c.im && !S.tkBad[c.im]; });
      sets.push({ key: key, info: st.info || {}, handle: x.p.handle, price: x.p.price, top: top, cards: ok.slice(0, TK_MAX), res: ok.slice(TK_MAX) });
      });
    });
    /* (10 okt) producten zonder topkaarten of zonder vaste set: volwaardige setrijen na de sets met topkaarten, met dezelfde
       setkop en rechts een rustig paneel met een korte boodschap en drie lege kaartsilhouetten; geen Duurste kaart */
    var extra = noData.map(function (p) { return { p: p, fix: false }; }).concat(noFix.map(function (p) { return { p: p, fix: true }; }));
    var mEl = qs('[data-rlw-tkmiss]', S.el); if (mEl) { mEl.textContent = ''; mEl.hidden = true; }
    var sig = S.lang + '|' + sets.map(function (x) { return x.key + ':' + x.handle + (S.tkLive && S.tkLive[x.key] ? ':l' : '') + (x.live ? ':' + x.live : ''); }).join(',') + '|' + extra.map(function (e) { return e.p.handle; }).join(',');
    S.tkKeys = sets.map(function (x) { return x.key; }).filter(function (k) { return k.indexOf('multi:') !== 0; }).concat(subKeys.filter(function (k, i) { return subKeys.indexOf(k) === i; }));
    if (S.tkAwake) liveLoad(S);
    S.tkRes = {}; sets.forEach(function (x) { S.tkRes[x.key] = x.res; });
    paintTeaser(S, sets);
    var has = sets.length > 0, any = has || extra.length > 0;
    sec.hidden = !any; if (hint) hint.hidden = !has;
    if (S.scr && S.scr.classList.contains('has-top') !== any) { S.scr.classList.toggle('has-top', any); if (S.pg) layoutGrid(S); }
    if (rows.getAttribute('data-k') === sig) return;
    rows.setAttribute('data-k', sig);
    if (!any) { rows.innerHTML = ''; return; }
    rows.innerHTML = sets.map(function (x) {
      var nm = x.info.name || x.key.split('|')[1] || x.key;
      return '<div class="rlw-tkrow" data-set="' + esc(x.key) + '"><div class="rlw-tkset"><span class="lg"><img src="' + esc(S.ctx.img(setImgHandle(S, D, x.key, x.handle))) + '" alt="" loading="lazy" decoding="async" draggable="false"></span>' +
        '<span class="sn"><b>' + esc(nm) + '</b>' + roiHTML(S, x) + '</span></div>' +
        '<div class="rlw-tkwrap"><button type="button" class="rlw-tknav prev" data-tknav="-1" aria-label="' + esc(t.gPrev) + '" hidden>' + ICON.prev + '</button>' +
        '<div class="rlw-tkcards">' + x.cards.map(function (c) { return tkCardHTML(S, c); }).join('') + '</div>' +
        '<button type="button" class="rlw-tknav next" data-tknav="1" aria-label="' + esc(t.gNext) + '" hidden>' + ICON.next + '</button></div></div>';
    }).join('') + extra.map(function (e) {
      return '<div class="rlw-tkrow is-empty" data-set="none:' + esc(e.p.handle) + '"><div class="rlw-tkset"><span class="lg"><img src="' + esc(S.ctx.img(e.p.handle)) + '" alt="" loading="lazy" decoding="async" draggable="false"></span>' +
        '<span class="sn"><b>' + esc(fullTitle(e.p.title)) + '</b></span></div>' +
        '<div class="rlw-tkwrap"><div class="rlw-tknone"><span class="sil" aria-hidden="true"><i></i><i></i><i></i></span><span class="msg">' + ICON.empty +
        (e.fix ? '<b>' + esc(t.tkNoSetH) + '</b>' : '') + '<span>' + esc(e.fix ? t.tkNoSet : t.tkNone) + '</span></span></div></div></div>';
    }).join('');
    paintTkSrc(S);
    var g = G();
    watchRows(S); tkNavAll(S);
    if (g && !S.RM && !S.pg) g.fromTo(qsa('.rlw-tkrow', rows), { autoAlpha: 0, y: 12 }, { autoAlpha: 1, y: 0, duration: .4, stagger: .05, ease: 'power3.out', clearProps: 'transform,opacity,visibility' });
  }
  /* setkop: enkel de duurste kaart van de set (het ROI-label is op 10 okt weggehaald) */
  function roiHTML(S, x) {
    /* (10 okt) ROI-label weg op vraag van Andrea; enkel de duurste kaart van de set */
    if (!x.top || !(x.top.pr > 0)) return '';
    return '<span class="rlw-tktop"><span class="lbl">' + esc(S.t.tkTopL) + '</span><span class="amt">' + esc(S.eur(x.top.pr)) + '</span></span>';
  }

  /* kaartbeeld: eerst c.im, bij een laadfout de beelden uit de PriceDex-kaartdata van de pagina (#pricedex-cards, dezelfde
     bron als de PriceDex-pop-up) en de pokemontcg.io-afleiding van de pop-up; lukt niets, dan gaat de kaart uit de rij en
     komt de volgende duurste in de plaats (geen lege vakken) */
  function pdxCards() {
    if (pdxCards.d !== undefined) return pdxCards.d;
    try { var el = document.getElementById('pricedex-cards'); pdxCards.d = el ? JSON.parse(el.textContent) : null; } catch (e) { pdxCards.d = null; }
    return pdxCards.d;
  }
  function imgFallbacks(c) {
    var out = [], d = pdxCards(), e = d && d[c.k], card = e && e.card;
    if (card) {
      var im = card.images || {};
      [im.large, im.small, im.en, im.url, card.image_url, card.image].forEach(function (u) { if (u && u !== c.im && out.indexOf(u) === -1) out.push(u); });
      var pid = card.id || '', i = pid.lastIndexOf('-');
      if (false && i > 0) { var u2 = 'https://images.pokemontcg.io/' + pid.slice(0, i).toLowerCase() + '/' + pid.slice(i + 1) + '.png'; if (out.indexOf(u2) === -1) out.push(u2); }
    }
    return out;
  }
  function tkCardHTML(S, c) {
    var pr = S.eur(c.pr || 0), t = S.t;
    return '<button type="button" class="rlw-tkc" data-tk="' + esc(c.k) + '" data-u="' + esc(c.u || '') + '" aria-label="' + esc(t.tkOpen(c.n, pr)) + '">' +
      '<span class="im"><img src="' + esc(c.im) + '" data-im0="' + esc(c.im) + '" data-fb="' + esc(imgFallbacks(c).join(' ')) + '" alt="" loading="lazy" decoding="async" draggable="false"></span>' +
      '<span class="nm">' + esc(c.n) + '</span><span class="mt"><span class="no">' + esc(c.no || '') + '</span>' + (c.ab || c.r ? '<span class="rr" title="' + esc(c.r || '') + '">' + esc(c.ab || c.r) + '</span>' : '') + '</span>' +
      '<span class="pr">' + pr + '</span></button>';
  }
  /* pijlen en fade van een kaartenrij: enkel zichtbaar als er in die richting nog kaarten zijn */
  /* teaser tussen het raster en de sectie (10 okt): de 4 duurste kaarten uit alle sets van de selectie, licht gewaaierd,
     met "tot € X"; de hele strook scrolt naar de sectie en verdwijnt zodra die in beeld is */
  function paintTeaser(S, sets) {
    var fan = qs('[data-rlw-tkfan]', S.el), up = qs('[data-rlw-tkupto]', S.el); if (!fan) return;
    var all = []; sets.forEach(function (x) { x.cards.forEach(function (c) { if (c.im && !(S.tkBad && S.tkBad[c.im])) all.push(c); }); });
    all.sort(function (a, b) { return (b.pr || 0) - (a.pr || 0); });
    var top = all.slice(0, 4), key = top.map(function (c) { return c.k; }).join('|');
    if (up) up.textContent = top.length ? S.t.tkUpTo(S.eur(top[0].pr)) : '';
    if (fan.getAttribute('data-k') === key) return;
    fan.setAttribute('data-k', key);
    fan.innerHTML = top.map(function (c, i) { return '<span class="fc f' + i + '"><img src="' + esc(c.im) + '" alt="" loading="lazy" decoding="async" draggable="false"></span>'; }).join('');
    qsa('img', fan).forEach(function (im) { im.addEventListener('error', function () { var f = im.parentNode; if (f && f.parentNode) f.parentNode.removeChild(f); }, { once: true }); });
  }
  function tkNav(rowCards) {
    var w = rowCards.parentNode; if (!w) return;
    var max = rowCards.scrollWidth - rowCards.clientWidth, x = rowCards.scrollLeft;
    var l = x > 4, r = x < max - 4;
    w.classList.toggle('more-l', l); w.classList.toggle('more-r', r);
    var p = qs('[data-tknav="-1"]', w), n = qs('[data-tknav="1"]', w);
    if (p) p.hidden = !l; if (n) n.hidden = !r;
  }
  function tkNavAll(S) { qsa('.rlw-tkcards', S.el).forEach(tkNav); }
  function tkImgError(S, img) {
    var fb = (img.getAttribute('data-fb') || '').split(' ').filter(Boolean);
    if (fb.length) { img.setAttribute('data-fb', fb.slice(1).join(' ')); img.src = fb[0]; return; }
    var btn = img.closest('.rlw-tkc'), row = btn && btn.closest('.rlw-tkrow'); if (!btn || !row) return;
    /* (10 okt) onthouden per beeld-URL, niet per kaart: een kapot snapshotbeeld mag dezelfde kaart met een werkend live
       beeld niet uitsluiten (zo vielen de B/RGB- en G/RGB-Mew van 30th Celebration weg) */
    S.tkBad = S.tkBad || {}; S.tkBad[img.getAttribute('data-im0') || img.src] = 1;
    var res = (S.tkRes && S.tkRes[row.getAttribute('data-set')]) || [], next = null;
    while (res.length && !next) { var c = res.shift(); if (!S.tkBad[c.im]) next = c; }
    var box = btn.parentNode; btn.remove(); setTimeout(function () { tkNavAll(S); }, 0);
    if (next && box) box.insertAdjacentHTML('beforeend', tkCardHTML(S, next));
    if (box && !box.children.length) row.remove();
  }
  /* ---------------- live topkaarten (10 okt): exact de bron van de PriceDex-pagina (cw-pricedex.js): admin.cardworld.be
     /api/tcg/pk-cards/<set> en /api/tcg/op-cards/<set>?v=2, met de prijsregel van die pagina (cwcrCmPrice: lowestNearMint,
     dan averageSellPrice, trendPrice, avg30, avg7, avg1; One Piece: price of market_price) en de bijwerktijd uit de header
     X-Cw-Updated. CORS laat cardworld.be toe; lukt het niet (bv. lokaal), dan blijft de snapshot staan. Lui: pas als de
     sectie in beeld komt; per set in sessionStorage (6 uur). Kaarten zonder beeld vallen weg (geen kaartrug). */
  var PDX_BASE = 'https://admin.cardworld.be', PDX_TTL = 6 * 3600 * 1000;
  function liveCard(fr, setId, c, snap) {
    var pk = fr === 'pokemon', cp = c.cardmarket && c.cardmarket.prices;
    /* (10 okt) exact de hoofdprijs van de PriceDex-kaartweergave (openCardDetail in cw-pricedex.js, tab Wereld):
       cardmarket.prices.lowestNearMint, voor Pokémon en One Piece; daarna dezelfde terugvalvolgorde als cwcrCmPrice. Voorheen
       nam One Piece het veld price (lijstprijs van de API), dat afwijkt van de Near Mint-prijs. */
    var pr = cp ? (cp.lowestNearMint || cp.averageSellPrice || cp.trendPrice || cp.avg30 || cp.avg7 || cp.avg1 || 0) : 0;
    if (!pr && !pk) pr = parseFloat(c.market_price || c.price || c.value || 0) || 0;
    /* sp = de sorteer- en filterprijs van de chases op de productpagina (cw-product.liquid: Pokémon cwpPkCardPrice, gelijk
       aan pr; One Piece c.price, dan market_price, dan value) */
    var sp = pk ? pr : (parseFloat(c.price || c.market_price || c.value || 0) || 0);
    var no = pk ? (c.number || '') : (c.card_id || c.id || '');
    var im = pk ? ((c.images && (c.images.large || c.images.small)) || '') : (c.image || c.image_url || '');
    var k = (pk ? 'pokemon|' : 'one-piece|') + setId + '|' + no, sm = snap[k] || snap[no] || null;
    /* raw: het volledige live kaartobject, zodat de kaartweergave na een klik dezelfde gegevens toont (PDXModal.open(k, entry)) */
    return { k: sm ? sm.k : k, n: c.name || c.card_name || '', no: no, r: c.rarity || '', ab: sm ? sm.ab : '', im: im, pr: Math.round(pr * 100) / 100,
      u: sm ? sm.u : 'https://cardworld.be/pages/pricedex', f: pk ? 'pokemon' : 'onepiece', sp: Math.round(sp * 100) / 100, raw: c };
  }
  function liveLoad(S) {
    var D = topData(); if (!D || !window.fetch) return;
    S.tkLive = S.tkLive || {}; S.tkBusy = S.tkBusy || {};
    (S.tkKeys || []).forEach(function (key) {
      if (S.tkLive[key] || S.tkBusy[key]) return;
      var parts = key.split('|'), fr = parts[0], id = parts[1]; if (!id || (fr !== 'pokemon' && fr !== 'one-piece')) return;
      var ck = 'rlw-pdx4-' + key, hit = null; /* v4: met de sorteerprijs van de productpagina (sp) */
      try { hit = JSON.parse(sessionStorage.getItem(ck) || 'null'); } catch (e) { hit = null; }
      if (hit && hit.at && Date.now() - hit.at < PDX_TTL && hit.cards && hit.cards.length) { liveDone(S, key, hit.cards, hit.upd); return; }
      S.tkBusy[key] = 1;
      var url = (window.CW_RS_PDX_BASE || PDX_BASE) + '/api/tcg/' + (fr === 'pokemon' ? 'pk-cards/' + encodeURIComponent(id) : 'op-cards/' + encodeURIComponent(id) + '?v=2'), upd = null;
      fetch(url).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); try { upd = r.headers.get('X-Cw-Updated'); } catch (e) { upd = null; } return r.json(); }).then(function (data) {
        var arr = fr === 'pokemon' ? (data && data.data) || [] : (Array.isArray(data) ? data : []);
        var snap = {}; ((D.sets[key] || {}).cards || []).forEach(function (c) { snap[c.k] = c; if (c.no) snap[c.no] = c; });
        /* zoals de chases op de productpagina: prijs boven € 1, duurste eerst, geen ontdubbeling op naam (elke kaart is
           franchise|set|nummer); kaarten zonder beeld vallen weg (geen kaartrug) */
        var cards = arr.map(function (c) { return liveCard(fr, id, c, snap); }).filter(function (c) { return c.im && c.sp > 1 && c.n; })
          .sort(function (a, b) { return b.sp - a.sp; }).slice(0, 30);
        if (!cards.length) throw new Error('leeg');
        try { sessionStorage.setItem(ck, JSON.stringify({ at: Date.now(), upd: upd, cards: cards })); } catch (e) { /* vol of privévenster */ }
        liveDone(S, key, cards, upd);
      }).catch(function () { /* de snapshot blijft staan */ }).then(function () { if (S.tkBusy) delete S.tkBusy[key]; });
    });
  }
  function liveDone(S, key, cards, upd) {
    if (!getState(S.el)) return;
    S.tkLive[key] = cards;
    if (upd && (!S.tkUpd || upd > S.tkUpd)) S.tkUpd = upd;
    renderTopSoon(S);
  }
  function paintTkSrc(S) {
    var src = qs('[data-rlw-tksrc]', S.el), D = topData(), t = S.t; if (!src) return;
    if (S.tkUpd) {
      var d = new Date(S.tkUpd), tag = S.lang === 'fr' ? 'fr-BE' : S.lang === 'en' ? 'en-GB' : 'nl-BE', txt = '';
      try { txt = d.toLocaleDateString(tag, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Brussels' }) + ', ' + d.toLocaleTimeString(tag, { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Brussels' }); } catch (e) { txt = S.tkUpd.slice(0, 10); }
      src.textContent = t.tkLive(txt);
    } else src.textContent = D && D.snapshot ? t.tkSrc(D.snapshot) : '';
  }
  function wireTop(S) {
    var rowsEl = qs('[data-rlw-tkrows]', S.el);
    /* horizontaal scrollen per rij (scroll bubbelt niet: capture) en de pijlknoppen */
    S.on(rowsEl, 'scroll', function (e) { if (e.target.classList && e.target.classList.contains('rlw-tkcards')) tkNav(e.target); }, true);
    S.on(rowsEl, 'click', function (e) {
      var b = e.target.closest('[data-tknav]'); if (!b) return;
      var c = qs('.rlw-tkcards', b.parentNode); if (!c) return;
      c.scrollBy({ left: +b.getAttribute('data-tknav') * c.clientWidth * .8, behavior: S.RM ? 'auto' : 'smooth' });
    });
    S.on(window, 'resize', function () { tkNavAll(S); });
    /* lui: de live bron pas als de sectie (bijna) in beeld komt */
    var sec = qs('[data-rlw-tk]', S.el);
    if (sec && window.IntersectionObserver) {
      S.tkIO = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { S.tkAwake = true; liveLoad(S); S.tkIO.disconnect(); } }, { rootMargin: '0px 0px 300px 0px' });
      S.tkIO.observe(sec);
    } else S.tkAwake = true;
    /* laadfouten van kaartbeelden (error bubbelt niet: capture) */
    S.on(qs('[data-rlw-tkrows]', S.el), 'error', function (e) { var im = e.target; if (im && im.tagName === 'IMG' && im.closest('.rlw-tkc .im')) tkImgError(S, im); }, true);
    S.on(qs('[data-rlw-tkhint]', S.el), 'click', function () {
      var sec = qs('[data-rlw-tk]', S.el); if (!sec) return;
      var sc = S.pg ? feedOf() : S.scr; if (!sc) return;
      var top = sec.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 12;
      sc.scrollTo({ top: Math.max(0, top), behavior: S.RM ? 'auto' : 'smooth' });
    });
    S.on(qs('[data-rlw-tkrows]', S.el), 'click', function (e) {
      var b = e.target.closest('[data-tk]'); if (!b) return;
      /* live kaart: het live kaartobject meegeven, anders toont de weergave de ingebakken momentopname (#pricedex-cards, 3 okt) */
      var k = b.getAttribute('data-tk'), live = null;
      Object.keys(S.tkLive || {}).some(function (sk) { return (S.tkLive[sk] || []).some(function (c) { if (c.k === k && c.raw) { live = { franchise: c.f, card: c.raw }; return true; } return false; }); });
      var ok = false; try { ok = !!(window.PDXModal && window.PDXModal.open(k, live, { hideShop: true })); } catch (er) { ok = false; }
      if (!ok) { var u = b.getAttribute('data-u'); if (u) window.open(u, '_blank', 'noopener'); }
    });
  }
  function updateHead(S) {
    renderTopSoon(S);
    var t = S.t, u = units(S), n = S.items.length;
    qs('[data-rlw-mline]', S.el).textContent = n ? t.mline(t.products(n), t.units(u), t.fr[S.fr]) : t.mlineNone;
    var note = qs('[data-rlw-note]', S.el); note.classList.remove('rlw-note--warn'); var msg = '';
    /* gekozen categorie boven het budget: niet stil terugvallen, de melding met de knop Zet budget op */
    var up = S.fallback ? typeUp(S) : null;
    if (up) { note.innerHTML = esc(t.noteTypeUp(up.label, S.eur(up.min))) + ' <button type="button" class="rlw-fixbtn" data-fix="' + up.to + '">' + esc(t.setTo(S.eurInt(up.to))) + '</button>'; note.classList.add('rlw-note--warn'); note.hidden = false; return; }
    if (S.fallback && n) msg = t.noteFallback(S.eurInt(S.budget));
    else if (S.styleMiss && n) {
      /* de gekozen samenstelling botst met de soortfilter of het budget: zeg het in dezelfde compacte regel */
      var lim0 = typeLimitHTML(S);
      if (lim0) { note.innerHTML = lim0; note.classList.add('rlw-note--warn'); note.hidden = false; return; }
      msg = t.styleMiss(t.sty[S.style]);
    }
    else if (S.older && n && S.style === 'nieuw') msg = t.olderNote;
    else if (n && S.budget - S.total > Math.max(10, S.budget * .15)) {
      /* blijft er veel budget over door de soortfilter: de oorzaak noemen in plaats van enkel het restbedrag */
      var lim = typeLimitHTML(S);
      if (lim) { note.innerHTML = lim; note.classList.add('rlw-note--warn'); note.hidden = false; return; }
      msg = t.noteUnder(S.eur(S.budget - S.total));
    }
    note.textContent = msg; note.hidden = !msg;
  }
  /* voetregel: "van € 1.300, nog € 35,23" in een rustige regel plus een kleine voortgangsring (geen balk die op een schuif lijkt) */
  var RING_C = 100.53;
  function paintOf(S) {
    var t = S.t, left = round2(S.budget - S.total), of = qs('[data-rlw-of]', S.el), ring = qs('[data-rlw-ring]', S.el);
    if (of) of.textContent = t.ofB(S.eurInt(S.budget));
    var le = qs('[data-rlw-left]', S.el);
    if (le) { le.textContent = !S.items.length ? '' : left < -0.004 ? t.addOverBy(S.eur(-left)) : left <= 0.004 ? t.exactL : t.leftL(S.eur(left)); le.classList.toggle('is-over', left < -0.004); }
    var mf = qs('[data-rlw-mfill]', S.el);
    if (mf) { mf.style.setProperty('--f', Math.min(1, S.budget ? S.total / S.budget : 0).toFixed(4)); mf.parentNode.classList.toggle('is-over', left < -0.004); }
    if (ring) ring.style.setProperty('--o', (RING_C * (1 - Math.min(1, S.budget ? S.total / S.budget : 0))).toFixed(2));
    var ab = qs('[data-rlw-addbud]', S.addWrap || S.el); if (ab) ab.textContent = t.addBud(S.eurInt(S.budget));
    var al = qs('[data-rlw-addleft]', S.addWrap || S.el); if (al) al.textContent = left < -0.004 ? t.addOverBy(S.eur(-left)) : t.addLeft(S.eur(Math.max(0, left)));
  }
  function updateMeter(S, fromZero) {
    var t = S.t, tot = qs('[data-rlw-tot]', S.el);
    paintOf(S);
    var g = G();
    if (g && !S.RM && !fromZero) { var o = { v: S.shownTotal }; g.to(o, { v: S.total, duration: .45, ease: 'power2.out', onUpdate: function () { tot.textContent = S.eur(o.v); } }); }
    else tot.textContent = S.eur(S.total);
    S.shownTotal = S.total;
    qs('[data-rlw-tocart]', S.el).disabled = !S.items.length; qs('[data-rlw-reroll]', S.el).disabled = !S.composed;
  }
  function rowOf(S, h) { for (var i = 0; i < S.items.length; i++) if (S.items[i].p.handle === h) return S.items[i]; return null; }
  function syncControls(S) {
    var room = round2(S.budget - S.total);
    qsa('.rlw-card', S.body).forEach(function (card) {
      var row = rowOf(S, card.getAttribute('data-h')); if (!row) return;
      qs('[data-act="minus"]', card).disabled = row.qty <= 1;
      qs('[data-act="plus"]', card).disabled = row.p.price > room + 1e-9;
      var qb = qs('.rlw-qb', card); qb.hidden = row.qty <= 1; qb.textContent = row.qty + 'x';
      qs('output', card).textContent = row.qty;
    });
  }
  function fillCard(S, card, row) {
    var p = row.p, t = S.t, st = qs('.rlw-stage', card), img = qs('.rlw-fb img', st), stt = fullTitle(p.title);
    kill3D(S, st);
    card.setAttribute('data-h', p.handle); st.setAttribute('data-h3', p.handle); st.setAttribute('aria-label', t.openAria(stt));
    st.classList.remove('rlw-fbok', 'rlw-no3d'); img.style.visibility = ''; img.style.width = ''; img.style.height = '';
    img.setAttribute('data-area', fitArea(p)); img.src = S.ctx.img(p.handle); wireImg(S, st);
    qs('.rlw-kind', card).textContent = kindOf(p, S.lang);
    var nm = qs('.rlw-name', card); nm.textContent = stt; nm.title = p.title; nm.setAttribute('aria-label', t.openAria(stt));
    qs('.rlw-price', card).textContent = S.eur(p.price);
    qs('.rlw-stepper', card).setAttribute('aria-label', t.qtyAria(stt));
  }
  function hideHint(S) { S.hintGone = true; clearTimeout(S.hintT); qsa('.rlw-dh', S.body).forEach(function (h) { h.classList.add('is-gone'); }); }
  function armHint(S) {
    if (S.hintGone) { qsa('.rlw-dh', S.body).forEach(function (h) { h.classList.add('is-gone'); }); return; }
    clearTimeout(S.hintT); S.hintT = setTimeout(function () { if (getState(S.el)) hideHint(S); }, 3000);
  }
  function openProduct(S, h, node) { if (S.ctx.on && S.ctx.on.product) S.ctx.on.product(h, node ? qs('.rlw-fb img', node) : undefined); }
  function wireSelection(S) {
    var el = S.el, on = S.on, down = null;
    on(S.body, 'scroll', function () { updateNav(S); }, { passive: true });
    on(qs('[data-rlw-gprev]', el), 'click', function () { nav(S, -1); });
    on(qs('[data-rlw-gnext]', el), 'click', function () { nav(S, 1); });
    on(S.body, 'pointerdown', function (e) { if (e.target.closest('.rlw-stage')) hideHint(S); down = { x: e.clientX, y: e.clientY }; }, true);
    on(S.selScene, 'click', function (e) {
      var fix = e.target.closest('[data-fix]');
      if (fix) { setBudget(S, +fix.getAttribute('data-fix'), 'fix'); redo(S); return; }
      if (e.target.closest('[data-redo]')) { redo(S); return; }
      var card = e.target.closest('.rlw-card'); if (!card) return;
      var row = rowOf(S, card.getAttribute('data-h')); if (!row) return;
      /* een klik op het beeld (zonder slepen) opent het product; app.js onderdrukt de klik zelf na een sleep op het model */
      if (e.target.closest('.rlw-stage')) { if (S.busy) return; if (e.detail > 0 && down && Math.hypot(e.clientX - down.x, e.clientY - down.y) >= 6) return; openProduct(S, row.p.handle, card); return; }
      var b = e.target.closest('[data-act]'); if (!b || S.busy) return;
      var act = b.getAttribute('data-act');
      if (act === 'open') { openProduct(S, row.p.handle, card); return; }
      if (act === 'plus' || act === 'minus') {
        if (act === 'plus') {
          if (row.p.price > S.budget - S.total + 1e-9) { live(S, S.t.plusNo(shortTitle(row.p.title), S.eurInt(S.budget))); return; }
          row.qty++;
        } else { if (row.qty <= 1) return; row.qty--; }
        recalc(S); syncControls(S); updateMeter(S); updateHead(S);
        var g = G(); if (g && !S.RM) g.fromTo(qs('output', card), { scale: 1.35 }, { scale: 1, duration: .35, ease: 'back.out(3)', clearProps: 'transform' });
        live(S, S.t.live.qty(shortTitle(row.p.title), S.t.units(row.qty), S.eur(S.total)));
      } else if (act === 'swap') swapRow(S, card, row);
      else if (act === 'remove') removeRow(S, card, row);
    });
    on(S.body, 'keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var st = e.target.closest('.rlw-stage'); if (!st || st !== e.target) return;
      e.preventDefault(); var card = st.closest('.rlw-card'); if (card) openProduct(S, card.getAttribute('data-h'), card);
    });
  }
  function swapRow(S, card, row) {
    var t = S.t, inBasket = {}; S.items.forEach(function (x) { inBasket[x.p.handle] = 1; });
    var room = S.budget - (S.total - row.p.price * row.qty);
    row.tried = row.tried || {}; row.tried[row.p.handle] = 1;
    var tp = typeOf(row.p), cur = row.p;
    var cands = poolFor(S).filter(function (p) { return !inBasket[p.handle] && p.price <= room + 1e-9; });
    var g = G();
    if (!cands.length) { live(S, t.swapNo); if (g && !S.RM) g.fromTo(card, { x: -5 }, { x: 0, duration: .4, ease: 'elastic.out(1,.3)', clearProps: 'transform' }); return; }
    cands.sort(function (a, b) { return ((typeOf(a) === tp ? 0 : 1) - (typeOf(b) === tp ? 0 : 1)) || (Math.abs(a.price - cur.price) - Math.abs(b.price - cur.price)); });
    var next = null; for (var i = 0; i < cands.length; i++) if (!row.tried[cands[i].handle]) { next = cands[i]; break; }
    if (!next) { row.tried = {}; row.tried[cur.handle] = 1; next = cands[0]; }
    row.tried[next.handle] = 1;
    row.p = next; row.qty = Math.max(1, Math.min(row.qty, Math.floor(room / next.price)));
    recalc(S); fillCard(S, card, row); syncControls(S); updateMeter(S); updateHead(S);
    var st = qs('.rlw-stage', card);
    if (g && !S.RM) g.fromTo(qs('.rlw-sw', card), { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: .45, ease: 'power3.out', clearProps: 'transform,opacity,visibility', onComplete: function () { if (S.step === 3) attQueue(S, st); } });
    else if (S.step === 3) attQueue(S, st);
    live(S, t.live.swapped(shortTitle(next.title), S.eur(next.price)));
  }
  function removeRow(S, card, row) {
    var i = S.items.indexOf(row); if (i < 0) return;
    S.items.splice(i, 1); recalc(S);
    kill3D(S, qs('.rlw-stage', card));
    var fin = function () {
      if (!getState(S.el)) return;
      card.remove();
      if (!S.items.length) renderEmpty(S);
      layoutGrid(S); syncControls(S); updateMeter(S); updateHead(S);
    };
    live(S, S.t.live.removed(shortTitle(row.p.title)));
    var g = G();
    if (!g || S.RM) { fin(); return; }
    g.to(card, { autoAlpha: 0, scale: .92, duration: .26, ease: 'power2.in', onComplete: fin });
  }
  function redo(S) { finishAll(S); applyDiff(S, compose(S, S.seed)); }
  function clearT(S, els) { var g = G(); if (g && els && els.length) g.set(els, { clearProps: 'transform,opacity,visibility' }); }
  function finishAll(S) { var g = 0; while (S.stl && g++ < 5) { var tl = S.stl; S.stl = null; try { tl.progress(1); tl.kill(); } catch (e) { /* negeren */ } } }

  /* selectie bijwerken zonder alles te herladen: producten die blijven, blijven staan (hun 3D ook); wat wegvalt vervaagt,
     wat erbij komt rijst op en krijgt daarna pas zijn 3D */
  function applyDiff(S, r) {
    finishAll(S);
    var t = S.t, g = G(), A = anim(S);
    S.fallback = r.fallback; S.styleMiss = !!r.styleMiss; S.older = !!r.older; S.cheapest = r.cheapest; S.composed = true; S.dirty = false;
    remember(S, r);
    var cards = qsa('.rlw-card', S.body);
    if (!r.items.length) {
      S.items = []; S.total = 0;
      cards.forEach(function (c) { kill3D(S, qs('.rlw-stage', c)); });
      var fin0 = function () { if (!getState(S.el)) return; renderEmpty(S); layoutGrid(S); updateMeter(S); updateHead(S); };
      if (A && cards.length) { var tl0 = g.timeline({ onComplete: fin0 }); S.stl = tl0; tl0.to(cards, { autoAlpha: 0, scale: .94, duration: .22, stagger: .02, ease: 'power2.in' }); }
      else fin0();
      live(S, S.cheapest != null && S.budget < S.cheapest ? t.live.tooTight : t.live.none);
      return;
    }
    if (!cards.length) { S.items = r.items; recalc(S); buildSelection(S); layoutGrid(S); revealAgain(S); live(S, t.live.newSel(t.products(S.items.length), S.eur(S.total))); return; }
    var map = {}; r.items.forEach(function (x) { map[x.p.handle] = x; });
    var gone = cards.filter(function (c) { return !map[c.getAttribute('data-h')]; });
    var kept = {}; cards.forEach(function (c) { var h = c.getAttribute('data-h'); if (map[h]) kept[h] = 1; });
    var adds = r.items.filter(function (x) { return !kept[x.p.handle]; });
    S.items = r.items; recalc(S);
    gone.forEach(function (c) { kill3D(S, qs('.rlw-stage', c)); });
    var fin = function () {
      if (!getState(S.el)) return;
      gone.forEach(function (c) { c.remove(); });
      var empty = qs('.rlw-emptysel', S.body); if (empty) empty.remove();
      var fresh = adds.map(function (x) { var d = document.createElement('div'); d.innerHTML = cardHTML(S, x); return d.firstElementChild; });
      S.body.classList.remove('is-empty');
      fresh.forEach(function (c) { S.body.appendChild(c); wireImg(S, qs('.rlw-stage', c)); });
      S.items = qsa('.rlw-card', S.body).map(function (c) { return map[c.getAttribute('data-h')]; }).filter(Boolean);
      recalc(S); layoutGrid(S); syncControls(S); updateMeter(S); updateHead(S);
      var entering = qsa('.rlw-card', S.body).filter(function (c) { return adds.some(function (x) { return x.p.handle === c.getAttribute('data-h'); }); });
      if (A && entering.length) {
        var tl = g.timeline({ onComplete: function () { clearT(S, entering); mount3D(S); } });
        S.stl = tl;
        tl.fromTo(entering, { autoAlpha: 0, y: 26, scale: .94 }, { autoAlpha: 1, y: 0, scale: 1, duration: .45, stagger: .05, ease: 'power3.out' });
      } else mount3D(S);
      if (A) qsa('.rlw-card', S.body).forEach(function (c) { if (kept[c.getAttribute('data-h')]) g.fromTo(qs('output', c), { scale: 1.25 }, { scale: 1, duration: .35, ease: 'back.out(3)', clearProps: 'transform' }); });
    };
    if (A && gone.length) { var tl1 = g.timeline({ onComplete: fin }); S.stl = tl1; tl1.to(gone, { autoAlpha: 0, scale: .92, y: -10, duration: .22, stagger: .02, ease: 'power2.in' }); }
    else fin();
    live(S, t.live.upd(t.products(S.items.length), S.eur(S.total)));
  }
  function revealAgain(S) {
    var cards = qsa('.rlw-card', S.body), g = G();
    if (!anim(S)) { mount3D(S); return; }
    var tl = g.timeline({ onComplete: function () { clearT(S, cards); mount3D(S); } });
    S.stl = tl;
    tl.fromTo(cards, { autoAlpha: 0, y: 34, scale: .94 }, { autoAlpha: 1, y: 0, scale: 1, duration: .55, stagger: .06, ease: 'power3.out' });
    var o = { v: 0 }, tot = qs('[data-rlw-tot]', S.el);
    tl.fromTo(o, { v: 0 }, { v: S.total, duration: .6, ease: 'power2.out', onUpdate: function () { tot.textContent = S.eur(o.v); } }, 0);
  }
  function reroll(S) {
    if (S.busy || S.step !== 3 || !S.composed) return;
    finishAll(S); clearTimeout(S.rcT); S.dirty = false;
    remember(S, { items: S.items });
    var best = rerollSearch(S);
    /* klein aanbod: alle andere sets zijn al getoond; dan de geschiedenis leegmaken (enkel de huidige set uitgesloten) en
       een keer opnieuw zoeken, pas dan de melding */
    if (!best && Object.keys(S.shown.sets || {}).length > 1) {
      var keep = S.shown; S.shown = { key: shownKey(S), sigs: {}, sets: {}, anchors: {} };
      best = rerollSearch(S);
      if (!best) S.shown = keep;
    }
    if (!best) { noOther(S); return; }
    S.seed = best.seed; applyDiff(S, best.r);
  }
  function addOpenState(S) { var w = S.addWrap; return !!(w && !w.hidden); }
  /* pop-up open: focus erin, alles erachter inert, paginascroll vergrendeld; dicht: alles terug en focus op de knop */
  function setAdd(S, open) {
    var wrap = S.addWrap, btn = qs('[data-rlw-addbtn]', S.el); if (!wrap) return;
    if (addOpenState(S) === open) return;
    wrap.hidden = !open; if (btn) btn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('rlw-modal-open', open);
    if (open) {
      S.inerted = [];
      Array.prototype.forEach.call(document.body.children, function (k) { if (k !== wrap && !k.inert && k.tagName !== 'SCRIPT' && k.tagName !== 'STYLE') { k.inert = true; S.inerted.push(k); } });
      wrap.style.setProperty('--ac', FR_AC[S.fr] || '#7B5EA7');
      S.add = { q: (S.add && S.add.q) || '', type: '', more: !!(S.add && S.add.more), fr: S.fr, tl: S.tl, sort: (S.add && S.add.sort) || 'rec' };
      var q = qs('[data-rlw-addq]', wrap); if (q) q.value = S.add.q;
      var mo = qs('[data-rlw-addmore]', wrap); if (mo) mo.checked = S.add.more;
      var so = qs('[data-rlw-addsort]', wrap); if (so) so.value = S.add.sort;
      renderAdd(S);
      var g = G();
      if (g && !S.RM) { g.fromTo(qs('.rlw-addback', wrap), { autoAlpha: 0 }, { autoAlpha: 1, duration: .25, clearProps: 'opacity,visibility' }); g.fromTo(qs('.rlw-add', wrap), { autoAlpha: 0, y: 24, scale: .985 }, { autoAlpha: 1, y: 0, scale: 1, duration: .35, ease: 'power3.out', clearProps: 'transform,opacity,visibility' }); }
      if (q) setTimeout(function () { try { q.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }, 40);
    } else {
      (S.inerted || []).forEach(function (k) { k.inert = false; }); S.inerted = [];
      if (btn) try { btn.focus({ preventScroll: true }); } catch (e) { /* negeren */ }
    }
  }
  var ADD_MAX = 120, ADD_QTY_MAX = 40;
  function addPool(S) {
    var A = S.add; metaAll(S);
    return S.all.filter(function (p) { return inFr(p, A.fr) && (!A.tl || langOf(p) === A.tl); });
  }
  function renderAdd(S) {
    var t = S.t, W = S.addWrap, A = S.add || (S.add = { q: '', type: '', more: false, fr: S.fr, tl: S.tl, sort: 'rec' }), room = round2(S.budget - S.total);
    if (!W) return;
    /* franchise, soort en taal: dezelfde lijsten als stap 2 */
    var frBox = qs('[data-rlw-addfr]', W), fk = A.fr;
    var frH = FR_ORDER.map(function (k) { return '<button type="button" class="rlw-lchip rlw-afr" data-afr="' + k + '" aria-pressed="' + (A.fr === k) + '" style="--w-ac:' + FR_AC[k] + '">' + MOTIF[k] + esc(t.fr[k]) + '</button>'; }).join('');
    if (frBox.getAttribute('data-k') !== fk) { frBox.setAttribute('data-k', fk); frBox.innerHTML = frH; }
    var ls = langsList(S, A.fr); if (A.tl && ls.indexOf(A.tl) === -1) A.tl = '';
    var lBox = qs('[data-rlw-alangs]', W), lk = A.fr + '|' + A.tl;
    if (lBox.getAttribute('data-k') !== lk) {
      lBox.setAttribute('data-k', lk);
      lBox.innerHTML = ls.length > 1 ? '<button type="button" class="rlw-lchip" data-atl="" aria-pressed="' + (!A.tl) + '">' + esc(t.allLangs) + '</button>' + ls.map(function (l) { return '<button type="button" class="rlw-lchip" data-atl="' + esc(l) + '" aria-pressed="' + (A.tl === l) + '">' + esc(langLabel(S, l)) + '</button>'; }).join('') : '';
      lBox.hidden = ls.length < 2;
    }
    var pool = addPool(S), q = String(A.q || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    var chips = qs('[data-rlw-addchips]', W);
    var ids = catsList(S, A.fr, A.tl).filter(function (id) { return pool.some(function (p) { return catOf(p) === id; }); });
    if (A.type && ids.indexOf(A.type) === -1) A.type = '';
    var ck = A.fr + '|' + A.tl + '|' + ids.join(',') + '|' + A.type;
    if (chips.getAttribute('data-k') !== ck) {
      chips.setAttribute('data-k', ck);
      chips.innerHTML = '<button type="button" class="rlw-tt" data-addtype="" aria-pressed="' + (!A.type) + '">' + esc(t.addAll) + '</button>' + ids.map(function (id) {
        return '<button type="button" class="rlw-tt rlw-atp" data-addtype="' + esc(id) + '" aria-pressed="' + (A.type === id) + '">' + thumbHTML(S, id, pool) + esc(catLabel(S, id)) + '</button>';
      }).join('');
      wirePics(chips, '.rlw-atp');
    }
    var cur = function (p) { return p.type !== 'shop' ? 0 : 1; };
    var list = pool.filter(function (p) {
      if (A.type && catOf(p) !== A.type) return false;
      if (!A.more && p.price > room + 1e-9) return false;
      if (q) { var hay = (p.title + ' ' + kindOf(p, S.lang) + ' ' + (catOf(p) || '')).toLowerCase().replace(/[^a-z0-9]+/g, ' '); if (q.split(' ').some(function (w) { return hay.indexOf(w) === -1; })) return false; }
      return true;
    }).sort(A.sort === 'asc' ? function (a, b) { return a.price - b.price; } : A.sort === 'desc' ? function (a, b) { return b.price - a.price; }
      : function (a, b) { var fa = a.price <= room + 1e-9 ? 0 : 1, fb = b.price <= room + 1e-9 ? 0 : 1; return (fa - fb) || (cur(a) - cur(b)) || (a.price - b.price); }).slice(0, ADD_MAX);
    var box = qs('[data-rlw-addlist]', W), have = {}; S.items.forEach(function (x) { have[x.p.handle] = x.qty; });
    box.innerHTML = list.length ? list.map(function (p) {
      var over = p.price > room + 1e-9, full = false, fl = S.addFlash === p.handle;
      return '<article class="rlw-ptile' + (over ? ' is-over' : '') + (fl ? ' is-added' : '') + '" role="listitem" data-h="' + esc(p.handle) + '">' +
        '<span class="pl"><img src="' + esc(S.ctx.img(p.handle)) + '" alt="" loading="lazy" decoding="async" draggable="false">' + (have[p.handle] ? '<span class="q">' + esc(t.inSel(have[p.handle])) + '</span>' : '') + '</span>' +
        '<span class="k">' + esc(t.fr[frOf(p)] + ' \u00b7 ' + (catLabel(S, catOf(p) || '') || kindOf(p, S.lang))) + '</span><span class="tt" title="' + esc(p.title) + '">' + esc(p.title) + '</span>' +
        '<span class="pr">' + esc(S.eur(p.price)) + (over ? '<em>' + esc(t.addOver) + '</em>' : '') + '</span>' +
        '<button type="button" class="rlw-ptadd" data-rlw-addp="' + esc(p.handle) + '"' + (full ? ' disabled' : '') + '><span class="a">' + ICON.plus + esc(t.addToSel) + '</span><span class="d">' + ICON.check + esc(t.addDone) + '</span></button></article>';
    }).join('') : '<p class="rlw-addnone">' + esc(t.addNone) + '</p>';
    paintOf(S);
  }
  /* toevoegen: in de selectie (aantal +1 als het er al is), totaal bij, kaart in het raster (3D bij hover); korte bevestiging op de tegel */
  function addProduct(S, h) {
    var p = S.byH[h]; if (!p || S.busy) return;
    finishAll(S); clearTimeout(S.rcT); S.dirty = false;
    var row = rowOf(S, h);
    if (row) row.qty++; else S.items.push({ p: p, qty: 1 });
    recalc(S);
    if (!S.composed) { S.composed = true; S.cheapest = minPrice(poolFr(S)); S.fallback = false; }
    applyDiff(S, { items: S.items.slice(), total: S.total, cheapest: S.cheapest, fallback: S.fallback });
    S.addFlash = h; clearTimeout(S.addFlT);
    renderAdd(S);
    S.addFlT = setTimeout(function () { S.addFlash = null; var tl = S.addWrap && qs('.rlw-ptile.is-added', S.addWrap); if (tl) tl.classList.remove('is-added'); }, 1400);
    live(S, S.t.addAdded(shortTitle(p.title)));
    var b = S.addWrap && qs('[data-rlw-addp="' + h + '"]', S.addWrap); if (b) try { b.focus({ preventScroll: true }); } catch (e) { /* negeren */ }
  }
  function wireAdd(S) {
    var el = S.el, on = S.on, W = S.addWrap;
    on(qs('[data-rlw-addbtn]', el), 'click', function () { setSheet(S, false); setPop(S, false); setAdd(S, !addOpenState(S)); });
    if (!W) return;
    on(qs('[data-rlw-addx]', W), 'click', function () { setAdd(S, false); });
    on(qs('[data-rlw-addback]', W), 'click', function () { setAdd(S, false); });
    on(qs('[data-rlw-addq]', W), 'input', function (e) { S.add.q = e.target.value; renderAdd(S); });
    on(qs('[data-rlw-addmore]', W), 'change', function (e) { S.add.more = !!e.target.checked; renderAdd(S); });
    on(qs('[data-rlw-addsort]', W), 'change', function (e) { S.add.sort = e.target.value; renderAdd(S); });
    on(W, 'click', function (e) {
      var b;
      if ((b = e.target.closest('[data-afr]'))) { S.add.fr = b.getAttribute('data-afr'); S.add.type = ''; W.style.setProperty('--ac', FR_AC[S.add.fr]); renderAdd(S); return; }
      if ((b = e.target.closest('[data-atl]'))) { S.add.tl = b.getAttribute('data-atl'); S.add.type = ''; renderAdd(S); return; }
      if ((b = e.target.closest('[data-addtype]'))) { S.add.type = b.getAttribute('data-addtype'); renderAdd(S); return; }
      if ((b = e.target.closest('[data-rlw-addp]'))) addProduct(S, b.getAttribute('data-rlw-addp'));
    });
    /* Escape in de pop-up (die staat buiten het kader) */
    on(W, 'keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); setAdd(S, false); } });
  }
  /* de soortfilter beperkt de selectie echt (Andere selectie geblokkeerd of veel budget over): een rustige regel met een
     inline tekstknop Toon alle soorten */
  function typeLimitHTML(S) {
    if (!S.types.length || S.noneSel || S.fallback) return '';
    var t = S.t, ls = S.types.map(function (id) { return catLabel(S, id); });
    var lab = ls.length > 1 ? ls.slice(0, -1).join(', ') + t.and + ls[ls.length - 1] : ls[0];
    return '<span>' + esc(t.tyOnly(lab)) + ' <button type="button" class="rlw-nlink" data-rlw-clrtypes>' + esc(t.tyShowAll) + '</button></span>';
  }
  function clearTypes(S) { if (!S.types.length && !S.noneSel) return; S.types = []; S.noneSel = false; S.typesAuto = false; syncTypes(S); changed(S); }
  function noOther(S) {
    var note = qs('[data-rlw-note]', S.el), g = G(), lim = typeLimitHTML(S);
    if (lim) note.innerHTML = lim; else note.textContent = S.t.noOther;
    note.classList.add('rlw-note--warn'); note.hidden = false;
    if (g && !S.RM) {
      g.fromTo(note, { autoAlpha: 0, y: -6 }, { autoAlpha: 1, y: 0, duration: .35, ease: 'power2.out', clearProps: 'transform,opacity,visibility' });
      g.fromTo(qs('[data-rlw-reroll]', S.el), { x: -5 }, { x: 0, duration: .5, ease: 'elastic.out(1,.3)', clearProps: 'transform' });
    }
    live(S, note.textContent);
  }

  /* ---------------- wereldovergang: golf in de kleur van de franchise vanuit de gekozen tegel, motieven zweven op ---------------- */
  function worldFx(S, btn, k) {
    if (S.wtl) { try { S.wtl.progress(1); S.wtl.kill(); } catch (e) { /* negeren */ } S.wtl = null; }
    var g = G();
    if (!g || S.RM || !btn || !btn.offsetWidth) { setBg(S, k); return; }
    var wave = qs('[data-rlw-wave]', S.el), fx = qs('[data-rlw-fx]', S.el), rl = S.el;
    var rr = rl.getBoundingClientRect(), br = btn.getBoundingClientRect();
    var cx = br.left + br.width / 2 - rr.left, cy = br.top + br.height / 2 - rr.top;
    var D = 2 * Math.hypot(Math.max(cx, rr.width - cx), Math.max(cy, rr.height - cy));
    wave.style.width = D + 'px'; wave.style.height = D + 'px'; wave.style.left = (cx - D / 2) + 'px'; wave.style.top = (cy - D / 2) + 'px'; wave.style.background = FR_BASE[k];
    fx.innerHTML = '';
    var mots = [], rnd = mulberry32((S.fxN = (S.fxN || 0) + 1) * 7919);
    for (var i = 0; i < 9; i++) {
      var m = document.createElement('span'); m.className = 'rlw-mot'; m.innerHTML = MOTIF[k];
      m.style.left = (cx - 15 + (rnd() - .5) * br.width * .8) + 'px'; m.style.top = (cy - 15 + (rnd() - .5) * br.height * .5) + 'px';
      m.style.color = FR_AC[k];
      fx.appendChild(m); mots.push(m);
    }
    var tl = g.timeline({ onComplete: function () { fx.innerHTML = ''; S.wtl = null; } });
    S.wtl = tl;
    tl.fromTo(wave, { scale: 0, autoAlpha: .95 }, { scale: 1, duration: .7, ease: 'power2.inOut' }, 0)
      .add(function () { setBg(S, k); }, .38)
      .to(wave, { autoAlpha: 0, duration: .45, ease: 'power1.out' }, .62)
      .fromTo(mots, { scale: .3, autoAlpha: 0, x: 0, y: 0, rotation: function () { return (rnd() - .5) * 40; } },
        { scale: function () { return .7 + rnd() * .7; }, autoAlpha: .85, x: function () { return (rnd() - .5) * 180; }, y: function () { return -60 - rnd() * 140; }, rotation: function () { return (rnd() - .5) * 90; }, duration: .8, ease: 'power3.out', stagger: .03 }, .05)
      .to(mots, { autoAlpha: 0, duration: .4, stagger: .02 }, .6);
    var mot = qs('.mot', btn);
    if (mot) tl.fromTo(mot, { scale: 1, rotation: 0 }, { scale: 1.18, rotation: -8, duration: .18, ease: 'power2.out', yoyo: true, repeat: 1, clearProps: 'transform' }, 0);
  }

  /* ---------------- onthulling: vijf kaartjes waaieren, schudden, een gouden ring, dan rijzen de producten op ---------------- */
  /* onthulling van de selectie (eigenaar 10 okt): geen schudstapel meer (die stond in de paginascroll midden in het
     meegegroeide kader, dus onderaan achter de voetbalk, terwijl het raster leeg bleef). De kaarten staan meteen op hun
     plek als skelet (zelfde raster en maat, rustige pulse via opacity), daarna vloeit de inhoud in. Het totaal telt op en
     de regel "van € X, nog € Y" verschijnt pas samen met het eindtotaal, zodat de cijfers nooit tegenstrijdig zijn. */
  function addReveal(S, tl, scene) {
    var cards = qsa('.rlw-card', scene), inner = [];
    cards.forEach(function (c) { inner.push(qs('.rlw-sw', c), qs('.rlw-cm', c)); });
    inner = inner.filter(Boolean);
    var tot = qs('[data-rlw-tot]', S.el), of = qs('[data-rlw-of]', S.el), ring = qs('[data-rlw-ring]', S.el);
    var le = qs('[data-rlw-left]', S.el), mf = qs('[data-rlw-mfill]', S.el);
    tl.add(function () { cards.forEach(function (c) { c.classList.add('is-skel'); }); if (le) le.style.visibility = 'hidden'; if (mf) mf.style.setProperty('--f', '0'); if (tot) tot.textContent = S.eur(0); if (ring) ring.style.setProperty('--o', String(RING_C)); }, 0)
      .fromTo(inner, { autoAlpha: 0 }, { autoAlpha: 0, duration: .01 }, 0)
      .from(qsa('[data-in]', scene), { autoAlpha: 0, y: 16, duration: .45, stagger: .06, ease: 'power3.out' }, .05)
      .add(function () { cards.forEach(function (c) { c.classList.remove('is-skel'); }); }, .55)
      .fromTo(inner, { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: .5, stagger: .05, ease: 'power3.out', clearProps: 'transform,opacity,visibility' }, .55);
    var o = { v: 0 };
    tl.fromTo(o, { v: 0 }, { v: S.total, duration: .7, ease: 'power2.out', onUpdate: function () { if (tot) tot.textContent = S.eur(o.v); } }, .6)
      .add(function () { if (le) le.style.visibility = ''; paintOf(S); }, .6);
  }

  /* ---------------- navigatie tussen stappen ---------------- */
  /* stap 2 heeft twee pagina's: samenstelling (sty) en soort (typ); showSub zet de pagina zonder animatie, setSub met de
     overgang in de stijl van de stapwissel (huidige pagina schuift weg, de nieuwe schuift binnen) */
  function showSub(S, sub) {
    S.sub = sub === 'typ' ? 'typ' : 'sty';
    qsa('[data-rlw-sub]', S.el).forEach(function (b) { b.hidden = b.getAttribute('data-rlw-sub') !== S.sub; });
    qsa('[data-rlw-subf]', S.el).forEach(function (b) { b.hidden = b.getAttribute('data-rlw-subf') !== S.sub; });
    qsa('[data-rlw-subh]', S.el).forEach(function (b) { b.hidden = b.getAttribute('data-rlw-subh') !== S.sub; });
    var esc2 = qs('[data-rlw-any]', S.el); if (esc2) esc2.hidden = S.sub !== 'sty';
    S.el.setAttribute('data-sub', S.sub);
    requestAnimationFrame(function () { if (getState(S.el)) { refitThumbs(S); if (S.sub === 'sty') { podState(S).sig = ''; podSoon(S); } } });
  }
  function setSub(S, sub) {
    if (S.step !== 2) { showSub(S, sub); return; }
    if (sub === S.sub) return;
    var dir = sub === 'typ' ? 1 : -1, sc = S.scenes[1], g = G();
    var outEls = qsa('[data-rlw-sub="' + S.sub + '"], [data-rlw-subf="' + S.sub + '"]', sc);
    var swap = function () {
      if (!getState(S.el)) return;
      showSub(S, sub); updateBar(S);
      live(S, sub === 'typ' ? S.t.live.typ : S.t.live.step[1]);
      var h = qs(sub === 'sty' ? '.rlw-ctt' : '.rlw-h', sc); if (h) try { h.focus({ preventScroll: true }); } catch (e) { /* negeren */ }
    };
    if (!g || !anim(S)) { swap(); return; }
    finishAll(S);
    var tl = g.timeline(); S.stl = tl;
    tl.to(outEls, { autoAlpha: 0, x: -40 * dir, duration: .24, ease: 'power2.in' }, 0)
      .add(function () {
        g.set(outEls, { clearProps: 'transform,opacity,visibility' });
        swap();
        var inEls = qsa('[data-rlw-sub="' + sub + '"], [data-rlw-subf="' + sub + '"], [data-rlw-subh="' + sub + '"]', sc);
        g.fromTo(inEls, { autoAlpha: 0, x: 40 * dir }, { autoAlpha: 1, x: 0, duration: .45, ease: 'power3.out', clearProps: 'transform,opacity,visibility' });
      }, .25);
  }
  /* voorstel van soorten bij een samenstelling (eigenaar 10 okt): enkel bij Cadeau, Meer packs en Spelen, alleen soorten
     die er zijn en binnen het budget passen; de klant kan ze aan of uit vinken. Een eigen keuze van de klant blijft staan. */
  var STYLE_TYPES = { cadeau: ['collecties', 'etb', 'bundels'], packs: ['packs', 'blisters', 'bundels'], spelen: ['etb', 'bundels', 'packs'] };
  function suggestTypes(S) {
    if ((S.types.length || S.noneSel) && !S.typesAuto) return;
    var want = STYLE_TYPES[S.style] || [];
    S.types = want.length ? availTypes(S).filter(function (x) { return !x.out && want.indexOf(catIcon(x.id)) !== -1; }).map(function (x) { return x.id; }) : [];
    if (S.types.length >= allTypeIds(S).length) S.types = [];
    S.noneSel = false; S.typesAuto = S.types.length > 0;
    syncTypes(S);
  }
  function updateBar(S) {
    var vi = S.step === 1 ? 1 : S.step === 2 ? (S.sub === 'typ' ? 3 : 2) : S.step === 3 ? 4 : 5;
    qsa('.rlw-stp', S.el).forEach(function (b) {
      var n = +b.getAttribute('data-vi');
      if (n === vi) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      b.classList.toggle('is-done', n < vi);
      b.disabled = n === 4 ? !(S.composed || vi >= 2) : false;
    });
    var mi = Math.min(vi, 4), mk = qs('[data-rlw-mk]', S.el), mt = qs('[data-rlw-mt]', S.el);
    if (mk) mk.textContent = S.t.stepOf(mi, 4); if (mt) mt.textContent = S.t.steps[mi - 1];
    var back = qs('[data-rlw-back]', S.el), show = S.step > 1;
    back.setAttribute('aria-hidden', String(!show)); back.tabIndex = show ? 0 : -1;
  }
  function go(S, n, o) {
    o = o || {};
    if (S.busy && !o.bypass) return;
    if (n === S.step && !o.force) return;
    if (n === 3 && (!S.composed || S.dirty || o.compose)) { apply(S, compose(S, S.seed)); buildSelection(S); o.reveal = true; }
    finishAll(S);
    var t = S.t, from = S.scenes[S.step - 1], to = S.scenes[n - 1], dir = n >= S.step ? 1 : -1;
    if (S.step === 3 && n !== 3) { pageOff(S); unmount3D(S); setSheet(S, false); setPop(S, false); setAdd(S, false); clearTimeout(S.rcT); }
    if (S.spop) setSpop(S, null, false);
    if (n === 2) { showSub(S, o.sub || S.sub || 'sty'); podState(S).sig = ''; }
    S.step = n; S.el.setAttribute('data-step', String(n));
    var seq = n === 3 && from !== to && anim(S); /* stap 3 pas tonen (met paginascroll) als de vorige stap weg is */
    S.trans3 = seq;
    if (!seq) { to.classList.add('is-on'); to.inert = false; }
    if (n === 3 && !seq) pageSync(S);
    S.scenes.forEach(function (s) { if (s !== to) s.inert = true; });
    updateBar(S);
    if (n === 3 && !seq) layoutGrid(S);
    if (n === 3) S.el.classList.add('rlw-tk-wait');
    live(S, (n === 2 && S.sub === 'typ' ? t.live.typ : t.live.step[n - 1]) + (n === 3 && S.items.length ? ' ' + t.products(S.items.length) + ', ' + S.eur(S.total) + '.' : ''));
    var done = function () {
      if (!getState(S.el)) return;
      if (from !== to) from.classList.remove('is-on');
      clearT(S, [from, to].concat(qsa('[data-in], .rlw-card', to)));
      S.el.classList.remove('rlw-tk-wait');
      if (n === 3 && S.step === 3) { mount3D(S); updateNav(S); swayStart(S); renderTopSoon(S); }
      if (!o.quiet) { var h = qs(n === 2 && S.sub === 'sty' ? '.rlw-ctt' : '.rlw-h', to); if (h) try { h.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }
    };
    if (!anim(S) || from === to) { done(); return; }
    var tl = G().timeline({ onComplete: done });
    S.stl = tl;
    if (seq) {
      /* 2 naar 3: stap 2 vervaagt binnen de vaste kaderhoogte, dan wisselen (is-on, paginascroll, raster) en daarna pas
         stap 3 met de onthulling; de topkaarten blijven verborgen tot het einde (rlw-tk-wait) */
      var inner = G().timeline();
      inner.fromTo(to, { autoAlpha: 0, x: 40 * dir }, { autoAlpha: 1, x: 0, duration: .5, ease: 'power3.out' }, 0);
      if (o.reveal) addReveal(S, inner, to);
      else inner.from(qsa('[data-in]', to).concat(qsa('.rlw-card', to)), { autoAlpha: 0, y: 18, duration: .5, stagger: .05, ease: 'power3.out' }, .06);
      inner.pause();
      tl.to(from, { autoAlpha: 0, x: -40 * dir, duration: .26, ease: 'power2.in' }, 0)
        .add(function () {
          if (!getState(S.el)) return;
          S.trans3 = false;
          from.classList.remove('is-on'); G().set(to, { autoAlpha: 0 });
          to.classList.add('is-on'); to.inert = false;
          pageSync(S); layoutGrid(S);
        }, .27)
        .add(inner.play(0), .28);
      return;
    }
    tl.to(from, { autoAlpha: 0, x: -40 * dir, duration: .28, ease: 'power2.in' }, 0)
      .fromTo(to, { autoAlpha: 0, x: 40 * dir }, { autoAlpha: 1, x: 0, duration: .5, ease: 'power3.out' }, .16);
    if (o.reveal) addReveal(S, tl, to);
    else tl.from(qsa('[data-in]', to).concat(n === 3 ? qsa('.rlw-card', to) : []), { autoAlpha: 0, y: 18, duration: .5, stagger: .05, ease: 'power3.out' }, .22);
  }
  function wireNav(S) {
    var el = S.el, on = S.on;
    on(el, 'click', function (e) {
      var b = e.target.closest('[data-go]'); if (!b || !el.contains(b) || b.disabled) return;
      var g = b.getAttribute('data-go');
      if (g === '2' || g === '2t') { var sub = g === '2t' ? 'typ' : 'sty'; if (S.step === 2) setSub(S, sub); else go(S, 2, { sub: sub }); return; }
      go(S, +g);
    });
    var goBack = function () {
      if (S.step === 2 && S.sub === 'typ') { setSub(S, 'sty'); return; }
      if (S.step === 3) { go(S, 2, { sub: 'typ' }); return; }
      go(S, S.step === 4 ? 3 : S.step - 1);
    };
    on(qs('[data-rlw-back]', el), 'click', goBack);
    /* Terug linksonder in de voet van stap 2 en de voetbalk van stap 4 (eigenaar 10 okt) */
    on(el, 'click', function (e) { var b = e.target.closest('[data-rlw-back2]'); if (b && el.contains(b)) goBack(); });
    on(qs('[data-rlw-tos2]', el), 'click', function () { go(S, 2, { sub: 'sty' }); });
    on(qs('[data-rlw-tosub]', el), 'click', function () { podLeave(S, function () { setSub(S, 'typ'); }); });

    on(qs('[data-rlw-compose]', el), 'click', function () { go(S, 3, { compose: !S.composed || S.dirty }); });
    /* Maakt niet uit (eigenaar 10 okt): altijd franchise Alles (gewone wereldovergang, golf vanuit de kaart), alle soorten,
       Een mix, budget ongewijzigd, en meteen samenstellen */
    on(qs('[data-rlw-any]', el), 'click', function (e) {
      S.types = []; S.noneSel = false; S.typesAuto = false; S.style = 'mix';
      pickWorld(S, 'all', e.currentTarget);
      renderTypes(S); renderStyles(S); renderTune(S); renderSummary(S); S.seed += 1; markDirty(S);
      go(S, 3, { compose: true });
    });
    on(qs('[data-rlw-again]', el), 'click', function () { S.seed += 1; S.dirty = true; S.confirmed = null; go(S, 1); });
    on(qs('[data-rlw-reroll]', el), 'click', function () { reroll(S); });
  }

  /* ---------------- cadeaumoment: doos vullen, dicht, strik, kaartje, naar het echte mandje van de pagina ----------------
     De platte kopieen van de producten vliegen in een open doos (vaste laag in body, boven de header), het deksel valt dicht,
     linten en strik verschijnen, een kaartje zwaait aan; dan vliegt de doos naar het mandje van de pagina (de Clean-pil, het
     mandje in de header of de balk) en gaat alles via ctx.on.addMany in dat mandje: de pagina laat de producten vanaf de
     landingsplek in het mandje vallen en telt op. Zonder GSAP of bij reduced motion: meteen addMany (vanaf het beeld) en de
     bevestiging. */
  /* doel van de vlucht: eerst de Mandje-pil in de header via het contract van de Clean-laag (window.CW_RS_CART_TARGET,
     een functie die een element of null geeft), anders de eigen lijst; el is enkel gezet voor een echt element */
  function cartTarget() {
    var cands = [], f = window.CW_RS_CART_TARGET;
    if (typeof f === 'function') { try { var ce = f(); if (ce && ce.getBoundingClientRect) cands.push(ce); } catch (e) { /* contract faalt: eigen doel */ } }
    ['.cl-pill', '#cdkCart', '#hdrRip', '#rpStack', '#barStackBtn', '#barStack'].forEach(function (sel) { var el = document.querySelector(sel); if (el) cands.push(el); });
    for (var i = 0; i < cands.length; i++) {
      var r = cands[i].getBoundingClientRect();
      if (r.width > 4 && r.height > 4 && r.right > 0 && r.left < innerWidth && r.bottom > 0 && r.top < innerHeight) return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width, el: cands[i] };
    }
    return { x: innerWidth - 40, y: 30, w: 40, el: null };
  }
  /* na de landing veert het doel kort op (enkel transform, bovenop een eventuele eigen transform) */
  function bumpTarget(el) {
    if (!el || !el.animate || prefersReduced()) return;
    try { el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 360, easing: 'cubic-bezier(.3,.7,.4,1)', composite: 'add' }); } catch (e) { /* negeren */ }
  }
  /* app.js (addMany) neemt per regel hoogstens 20 stuks: grotere aantallen in delen van 20 doorgeven, zodat alles correct in
     het mandje komt zonder de klant te begrenzen. Elke regel geeft een vlucht; de delen staan achteraan, zodat eerst elk
     product een keer zichtbaar landt. */
  function addManyNow(S, from) {
    var first = [], rest = [];
    S.items.forEach(function (row) {
      var left = row.qty, k = 0;
      while (left > 0) { var q = Math.min(20, left), it = { handle: row.p.handle, qty: q }; if (from) it.from = from; (k++ ? rest : first).push(it); left -= q; }
    });
    var items = first.concat(rest);
    S.confirmed = { items: S.items.map(function (x) { return { handle: x.p.handle, qty: x.qty }; }), total: S.total, count: units(S) };
    if (S.ctx.on && S.ctx.on.addMany) S.ctx.on.addMany(items);
    peekCart(S, items.length);
  }
  /* na het toevoegen klapt de echte mandjelade van de pagina kort open (de Clean-laag doet dat zelf zodra het aantal stijgt);
     enkel als die lade dan nog niet open ging, roepen we het pad van de pagina aan */
  function peekCart(S, n) {
    clearTimeout(S.peekT);
    S.peekT = setTimeout(function () {
      if (!getState(S.el)) return;
      var b = document.body;
      if (b.classList.contains('cl-cart') || (qs('.sheet.on') && S.mode === 'm')) return;
      if (S.ctx.on && S.ctx.on.openCart) S.ctx.on.openCart();
    }, 1500 + Math.min(n, 12) * 120);
  }
  function fillDone(S, u, total) {
    var t = S.t;
    qs('[data-rlw-dline]', S.el).innerHTML = t.dline(t.units(u), S.eur(total));
    var max = 6, list = S.items.slice(0, max);
    qs('[data-rlw-thumbs]', S.el).innerHTML = list.map(function (x) { return '<span><img src="' + esc(S.ctx.img(x.p.handle)) + '" alt="' + esc(x.p.title) + '"></span>'; }).join('') + (S.items.length > max ? '<span>+' + (S.items.length - max) + '</span>' : '');
    var undo = qs('[data-rlw-undo]', S.el); if (undo) { undo.disabled = false; undo.hidden = false; }
  }
  function toCart(S) {
    if (S.busy || S.step !== 3) return;
    setSheet(S, false); setPop(S, false); setAdd(S, false);
    if (S.dirty) { clearTimeout(S.rcT); applyDiff(S, compose(S, S.seed)); }
    finishAll(S);
    if (!S.items.length) return;
    var t = S.t, u = units(S), total = S.total, g = G();
    fillDone(S, u, total);
    var first = qs('.rlw-stage', S.body), fr = first ? first.getBoundingClientRect() : null;
    if (!anim(S)) {
      addManyNow(S, fr && fr.width > 4 ? { x: fr.left + fr.width / 2, y: fr.top + fr.height / 2, w: clamp(fr.width * .6, 60, 150) } : null);
      go(S, 4, { bypass: true }); live(S, t.live.inCart(t.units(u), S.eur(total))); return;
    }
    S.busy = true;
    var vw = innerWidth, vh = innerHeight, kr = S.el.getBoundingClientRect();
    var top = Math.max(kr.top, 0), bot = Math.min(kr.bottom, vh);
    var mob = S.mode === 'm', W = mob ? 170 : 236, H = Math.round(W * .62), LH = Math.round(W * .19), PAD = 20, BOW = 62;
    var cx = kr.left + kr.width / 2, bb = top + (bot - top) * .7, boxTop = bb - H;
    var gw = W + PAD * 2, gh = H + LH + BOW, gl = cx - gw / 2, gt = bb - gh;
    var fly = document.createElement('div'); fly.className = 'rlw-fly'; fly.setAttribute('aria-hidden', 'true'); document.body.appendChild(fly); S.fly = fly;
    var mk = function (cls, css) { var d = document.createElement('div'); d.className = cls; Object.assign(d.style, css || {}); fly.appendChild(d); return d; };
    var dim = mk('gf-dim', { left: kr.left + 'px', top: top + 'px', width: kr.width + 'px', height: (bot - top) + 'px' });
    var back = mk('gf-back', { left: (cx - W / 2) + 'px', top: (boxTop - 16) + 'px', width: W + 'px', height: (H + 16) + 'px' });
    var imgs = [];
    qsa('.rlw-card', S.body).slice(0, 8).forEach(function (card) {
      var row = rowOf(S, card.getAttribute('data-h')); if (!row) return;
      var r = qs('.rlw-stage', card).getBoundingClientRect();
      var ok = r.width > 0 && r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      var rr = ok ? { left: r.left, top: r.top, width: r.width, height: r.height } : { left: cx - 60, top: bot - 40, width: 120, height: 120 };
      var im = new Image(); im.className = 'gf-img'; im.alt = ''; im.src = S.ctx.img(row.p.handle);
      Object.assign(im.style, { left: rr.left + 'px', top: rr.top + 'px', width: rr.width + 'px', height: rr.height + 'px' });
      fly.appendChild(im); imgs.push({ im: im, rr: rr });
    });
    var grp = mk('gf-grp', { left: gl + 'px', top: gt + 'px', width: gw + 'px', height: gh + 'px' });
    grp.innerHTML =
      '<div class="gf-front" style="height:' + H + 'px"><i class="gf-rib"></i></div>' +
      '<div class="gf-lid" style="top:' + (BOW + 4) + 'px;height:' + LH + 'px"><i class="gf-rib"></i></div>' +
      '<svg class="gf-bow" style="top:' + (BOW - 44) + 'px" viewBox="0 0 112 66" aria-hidden="true"><defs><linearGradient id="' + S.uid + 'fg" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#b8860f"/><stop offset=".45" stop-color="#F2C95E"/><stop offset="1" stop-color="#b8860f"/></linearGradient></defs><path d="M56 50C47 24 10 16 8 36c-2 16 28 17 48 14z" fill="url(#' + S.uid + 'fg)"/><path d="M56 50c9-26 46-34 48-14 2 16-28 17-48 14z" fill="url(#' + S.uid + 'fg)"/><path d="M56 50c-6 6-12 12-20 15M56 50c6 6 12 12 20 15" stroke="#b8860f" stroke-width="5" stroke-linecap="round" fill="none"/><circle cx="56" cy="49" r="8" fill="#c9971a"/></svg>' +
      '<div class="gf-tag" style="top:' + (BOW + LH + 18) + 'px"><b>' + esc(t.tag) + '</b><span>' + esc(S.eur(total)) + '</span></div>';
    var lid = qs('.gf-lid', grp), bow = qs('.gf-bow', grp), tag = qs('.gf-tag', grp), ribs = qsa('.gf-rib', grp);
    var skip = document.createElement('button'); skip.type = 'button'; skip.className = 'gf-skip'; skip.textContent = t.skip; fly.appendChild(skip);
    fly.classList.add('is-on'); fly.removeAttribute('aria-hidden');
    var landed = false, land = function () { if (landed) return; landed = true; addManyNow(S, { x: cartTarget().x, y: cartTarget().y, w: 60 }); };
    S.land = land; /* zodat unmount tijdens de doosanimatie de producten alsnog in het mandje legt */
    var end = function () {
      if (!S.busy) return;
      land(); fly.remove(); S.fly = null;
      S.busy = false; S.gtl = null;
      if (S.step !== 4) go(S, 4, { bypass: true, quiet: true });
      var h = qs('.rlw-s4 .rlw-h', S.el); if (h) try { h.focus({ preventScroll: true }); } catch (e) { /* negeren */ }
    };
    var tl = g.timeline({ onComplete: end });
    S.gtl = tl;
    skip.addEventListener('click', function () { if (S.gtl) S.gtl.progress(1); });
    tl.fromTo(dim, { autoAlpha: 0 }, { autoAlpha: 1, duration: .3, ease: 'power1.out' }, 0)
      .fromTo([back, grp], { autoAlpha: 0, y: 40, scale: .9 }, { autoAlpha: 1, y: 0, scale: 1, duration: .5, ease: 'back.out(1.6)' }, .08)
      .fromTo(lid, { x: -W * .34, y: -H * .95, rotation: -24 }, { x: -W * .34, y: -H * .95, rotation: -24, duration: .01 }, 0)
      .fromTo(ribs, { scaleY: 0 }, { scaleY: 0, duration: .01 }, 0)
      .fromTo(bow, { autoAlpha: 0, scale: 0 }, { autoAlpha: 0, scale: 0, duration: .01 }, 0)
      .fromTo(tag, { autoAlpha: 0, rotation: -50 }, { autoAlpha: 0, rotation: -50, duration: .01 }, 0)
      .fromTo(skip, { autoAlpha: 0 }, { autoAlpha: 1, duration: .3 }, .4);
    imgs.forEach(function (o, i) {
      var r = o.rr, at = .5 + i * .08;
      var tx = cx - (r.left + r.width / 2), ty = (boxTop + H * .08) - (r.top + r.height / 2), s = (W * .46) / Math.max(r.width, r.height);
      tl.to(o.im, { x: tx, duration: .66, ease: 'power2.out' }, at)
        .to(o.im, { y: ty, duration: .66, ease: 'back.in(1.3)' }, at)
        .to(o.im, { scale: s, rotation: (i % 2 ? 1 : -1) * (5 + i * 2), duration: .66, ease: 'power1.in' }, at)
        .to(o.im, { y: ty + H * .5, autoAlpha: 0, duration: .2, ease: 'power2.in' }, at + .66);
    });
    var tc = .5 + Math.max(0, imgs.length - 1) * .08 + .9;
    tl.to(lid, { x: 0, y: 0, rotation: 0, duration: .34, ease: 'power3.in' }, tc)
      .to(grp, { scaleY: .93, transformOrigin: '50% 100%', duration: .1, ease: 'power1.out', yoyo: true, repeat: 1 }, tc + .32)
      .to(ribs, { scaleY: 1, duration: .3, ease: 'power2.out', stagger: .06 }, tc + .44)
      .to(bow, { autoAlpha: 1, scale: 1, rotation: 0, duration: .55, ease: 'back.out(2.6)' }, tc + .58)
      .to(tag, { autoAlpha: 1, rotation: 6, duration: 1, ease: 'elastic.out(1,.42)' }, tc + .72);
    var tf = tc + 1.7;
    /* het mandje van de pagina pas op het moment van vertrek opzoeken (de Clean-pil kan intussen verschoven zijn) */
    tl.add(function () {
      var c = cartTarget();
      var dx = c.x - (gl + gw / 2), dy = c.y - (gt + gh / 2);
      g.set(grp, { transformOrigin: '50% 50%' });
      g.to(grp, { x: dx, y: dy, scale: .14, rotation: 10, duration: .72, ease: 'power2.in', onComplete: function () { bumpTarget(c.el); } });
      g.to(grp, { autoAlpha: 0, duration: .14, delay: .6 });
    }, tf)
      .set(back, { autoAlpha: 0 }, tf)
      .to([dim, skip], { autoAlpha: 0, duration: .4 }, tf + .25)
      .add(function () { go(S, 4, { bypass: true, quiet: true }); }, tf + .1)
      .add(land, tf + .7)
      .to({}, { duration: .1 }, tf + .8);
    live(S, t.live.gift(t.units(u)));
  }
  function wireCart(S) {
    var el = S.el, on = S.on;
    on(qs('[data-rlw-tocart]', el), 'click', function () { toCart(S); });
    on(qs('[data-rlw-seecart]', el), 'click', function () {
      var pill = document.querySelector('.cl-pill'), b = document.body;
      if (pill && pill.offsetWidth && S.mode === 'd') { if (!b.classList.contains('cl-cart')) pill.click(); return; }
      if (S.ctx.on && S.ctx.on.openCart) S.ctx.on.openCart();
    });
    on(qs('[data-rlw-undo]', el), 'click', function (e) {
      var c = S.confirmed; if (!c) return;
      if (S.ctx.on && S.ctx.on.removeMany) S.ctx.on.removeMany(c.items.map(function (it) { return { handle: it.handle, qty: it.qty }; }));
      S.confirmed = null; clearTimeout(S.peekT);
      qs('[data-rlw-dline]', el).textContent = S.t.dlineUndone;
      e.currentTarget.disabled = true;
      live(S, S.t.dlineUndone);
    });
  }

  function wireKeys(S) {
    /* Escape op document in de capture-fase: voor de Clean-laag en de pagina (die Escape zelf afhandelen), enkel als de
       toetsaanslag uit dit kader komt of een van onze lagen (blad, doos, keuzevenster) open staat */
    S.on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!isShown(S) || document.body.classList.contains('mode-grid')) return;
      var inside = S.el.contains(e.target), open = !!S.gtl || addOpenState(S) || popOpen(S) || sheetOpen(S) || !!S.spop;
      if (!inside && !open) return;
      if (!open) return;
      e.stopPropagation(); e.preventDefault();
      if (S.gtl) S.gtl.progress(1);
      else if (addOpenState(S)) setAdd(S, false);
      else if (popOpen(S)) setPop(S, false);
      else if (sheetOpen(S)) setSheet(S, false);
      else if (S.spop) setSpop(S, null, true);
    }, true);
    S.on(S.el, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (S.gtl) { e.stopPropagation(); S.gtl.progress(1); }
      else if (addOpenState(S)) { e.stopPropagation(); setAdd(S, false); }
      else if (popOpen(S)) { e.stopPropagation(); setPop(S, false); }
      else if (sheetOpen(S)) { e.stopPropagation(); setSheet(S, false); }
    });
  }

  /* ---------------- replay / unmount ---------------- */
  function replay(root) {
    var el = findRoot(root), S = el && getState(el); if (!S || !anim(S)) return;
    var to = S.scenes[S.step - 1], els = qsa('[data-in]', to).concat(S.step === 3 ? qsa('.rlw-card', to) : []);
    if (els.length) G().from(els, { autoAlpha: 0, y: 18, duration: .5, stagger: .05, ease: 'power3.out', clearProps: 'transform,opacity,visibility' });
  }
  function unmount(root) {
    var el = findRoot(root), S = el && getState(el);
    if (S) {
      S.timers.forEach(function (id) { clearTimeout(id); clearInterval(id); }); S.intervals.forEach(function (id) { clearInterval(id); });
      clearTimeout(S.rcT); clearTimeout(S.hintT); clearTimeout(S.peekT); clearTimeout(S.enterT); clearTimeout(S.attT);
      /* doosanimatie nog bezig: de klant klikte al op "Alles in mijn mandje", dus eerst landen (addMany), dan pas de tijdlijn doden */
      if (S.gtl && S.land) { try { S.land(); } catch (e) { /* negeren */ } }
      S.land = null;
      ['stl', 'wtl', 'gtl', 'ttl'].forEach(function (k) { if (S[k]) { try { S[k].kill(); } catch (e) { /* negeren */ } S[k] = null; } });
      if (S.fly && S.fly.parentNode) S.fly.parentNode.removeChild(S.fly);
      S.busy = false;
      unmount3D(S);
      cancelAnimationFrame(S.swayRaf || 0); S.swayRaf = 0; cancelAnimationFrame(S.roRaf || 0);
      S.offs.forEach(function (f) { try { f(); } catch (e) { /* negeren */ } });
      if (S.ro) { try { S.ro.disconnect(); } catch (e) { /* negeren */ } }
      if (S.mo) { try { S.mo.disconnect(); } catch (e) { /* negeren */ } }
      if (S.tkIO) { try { S.tkIO.disconnect(); } catch (e) { /* negeren */ } }
      ['rowIO', 'cueIO'].forEach(function (k) { if (S[k]) { try { S[k].disconnect(); } catch (e) { /* negeren */ } } });
      if (PROBE && PROBE.parentNode) PROBE.parentNode.removeChild(PROBE);
      PROBE = null;
      pageOff(S);
      if (S.addWrap) { (S.inerted || []).forEach(function (k) { k.inert = false; }); S.inerted = []; document.documentElement.classList.remove('rlw-modal-open'); if (S.addWrap.parentNode) S.addWrap.parentNode.removeChild(S.addWrap); S.addWrap = null; }
      var host = S.host; if (host && host.classList) { host.classList.remove('rlw-host', 'rlw-page'); unfit(host); }
    }
    if (el) setState(el, null);
  }

  var API = { html: html, mount: mount, replay: replay, unmount: unmount };
  window.CWStartWiz = API;

  /* ---------------- schakelaar ----------------
     Sinds 11 okt is rip-lab-cadeau.js de standaard Rip Lab (ook met ?riplab=nieuw); deze wizard is de terugval met
     ?riplab=wiz, onthouden voor de rest van de tab (sessionStorage '1'). ?riplab=nieuw, ?riplab=oud of ?riplab=i2c zet hem
     weer uit (sessionStorage '0'). Dit script staat in de pagina NA rip-lab-i2c.js en VOOR rip-lab-cadeau.js en app.js. */
  var KEY = 'cw-riplab-wiz', want = false;
  try {
    var q = new URLSearchParams(location.search).get('riplab');
    if (q === 'wiz') sessionStorage.setItem(KEY, '1');
    else if (q === 'nieuw' || q === 'oud' || q === 'i2c') sessionStorage.setItem(KEY, '0');
    want = q === 'wiz' || (q !== 'nieuw' && q !== 'oud' && q !== 'i2c' && sessionStorage.getItem(KEY) === '1');
  } catch (e) { want = /[?&]riplab=wiz\b/.test(location.search); }
  if (want) {
    window.CWStartVorig = window.CWStart || null;
    window.CWStart = API;
    try { document.documentElement.classList.add('rlw-active'); } catch (e) { /* negeren */ }
  }
})();

